import { DAILY_REWARD_STATUS } from '@Data/Models';
import { IGU_WALLET_TRANSACTIONS } from '@models/gamingWallet';
import {
    MARKETPLACE_ORDERS_SORT_OPTION,
    MARKETPLACE_PET_TYPE,
} from '@models/marketplace';
import {
    GAME_DIFFICULTY,
    LUCKY_STRIKE_GAMES_STATUS,
    MYSTERY_GAMES,
    MYSTERY_LIKES_STATUS,
    NFT_ROYAL_GAME_HISTORY_STATUS,
    NFT_ROYAL_GAME_MODE,
    TOKEN_TELLER_GAME_PREDICTION_DIRECTION,
    TOKEN_TELLER_GAME_STATUS,
    TOKEN_TELLER_HISTORY_GAMES_STATUS,
} from '@models/mysteryGames';
import ROUTES from '@navigation/routes';

const uk = {
    createWalletPassphrase: {
        title: 'Ваша сід фраза',
        text: "Будь ласка, запишіть ці 12 слів на аркуші паперу. Записуючи їх, пам'ятайте про їхній порядок. Зберігайте його в надійному місці.",
        button: 'Продовжити',
        loading: 'Генерація сід фрази..',
    },
    createWalletVerification: {
        title: 'Верифікація',
        text: 'Виберіть, будь ласка, правильні слова, виходячи з їх номерів (у тому порядку, в якому вони були записані на попередньому екрані)',
        button: 'Продовжити',
        errors: {
            passphraseNotCorrect:
                'Порядок слів неправильний. Виберіть правильні слова відповідно до їх порядку',
        },
        loading: 'Перевірка сід фрази..',
    },
    createWalletFirst: {
        title: 'Запишіть свою сід фразу',
        text: 'У разі втрати або крадіжки Вашого пристрою, Ви зможете відновити доступ до Ваших коштів за допомогою ключової фрази. Втрата кодової фрази призведе до втрати коштів.',
        button: 'Готово, продовжити',
    },
    importWalletInit: {
        title: 'Ми знайшли ваш обліковий запис',
        text: 'Ви увійшли з іншого пристрою і не маєте доступу до підключеного гаманця. Будь ласка, введіть ключову фразу вашого гаманця з 12 слів для продовження користування додатком',
        pets: 'Домашні тварини',
        import: 'Імпортувати гаманець',
        loading: 'Імпортування гаманця..',
    },
    importWalletScreen: {
        title: 'Імпортувати гаманець',
        text: 'Введіть свою фразу з 12 слів, щоб мати можливість користуватися гаманцем у додатку',
        listTitle: 'Сід фраза',
        inputPlaceholder: 'Введіть тут',
        clearAll: 'Очистити все',
        importWallet: 'Імпорт',
        privateKeyButton: 'Імпорт з приватного ключа',
        privateKeyModal: {
            title: 'Імпорт з приватного ключа',
            text: 'Якщо у вас немає seed-фрази, ви можете імпортувати гаманець за допомогою приватного ключа',
            label: 'Приватний ключ',
            placeholder: 'Введіть приватний ключ',
            button: 'Імпорт',
        },
        errors: {
            mnemonicError:
                'Гаманець з такою фразою з 12 слів не існує. Будь ласка, перевірте ще раз або вкажіть іншу фразу',
            privateKeyError:
                'Гаманця з таким приватним ключем не існує. Будь ласка, перевірте ще раз або надайте інший приватний ключ',
            walletNotEqual:
                'Наданий гаманець не відповідає гаманцю облікового запису',
            walletAlreadyVerified:
                'Цей гаманець належить іншому акаунту, не можна імпортувати',
        },
        success: 'Гаманець успішно імпортовано',
    },
    createWalletInit: {
        createButton: 'Створити гаманець',
        importButton: 'Імпортувати гаманець',
        slider: {
            titleSlide1: 'Підключити гаманець',
            textSlide1:
                'Створіть новий гаманець або імпортуйте існуючий, вказавши свою ключову фразу з 12 слів',
            titleSlide2: 'Гаманці самообслуговування',
            textSlide2:
                'IguVerse працює на гаманці самообслуговування, де ви одноосібно контролюєте свої приватні ключі, які в свою чергу контролюють вашу криптовалюту і доводять, що кошти належать вам',
            titleSlide3: 'Відновити обліковий запис',
            textSlide3:
                'Якщо ви втратите доступ до пристрою та вашої seed-фрази, ми не зможемо відновити ваш гаманець і кошти будуть втрачені.',
        },
    },
    createWalletSuccess: {
        title: 'Створено гаманець',
        text: 'Вітаємо! Ваш гаманець успішно створено, ви можете почати користуватися своїм обліковим записом вже зараз',
        button: 'Перейти до останнього кроку',
        buttonNew: 'Продовжити',
    },
    importWalletSuccess: {
        title: 'Гаманець імпортований',
        text: 'Вітаємо! Ваш гаманець успішно імпортовано, ви можете почати користуватися своїм обліковим записом',
        button: 'Продовжити',
        buttonNew: 'Перейти до останнього кроку',
    },
    login: {
        facebook: 'Увійти з Facebook',
        google: 'Увійти з Google',
        apple: 'Увійти з Apple',
        email: 'Увійти з електронної пошти',
        twitter: 'Увійти з Твіттером',
        emailTitle: 'Вхід / Реєстрація',
        creatingAccount:
            'Створюючи обліковий запис, я даю згоду на обробку моїх персональних даних згідно з',
        and: 'і',
        privacyPolicy: 'Політикою конфіденційності',
        termsOfUse: 'Умовами використання',
        placeholderEmail: 'Введіть електронну пошту',
        labelEmail: 'Електронна пошта',
        placeholderVerificationCode: 'Введіть код верифікації',
        labelVerificationCode: 'Код підтвердження буде надіслано на вашу пошту',
        sendCode: 'Надіслати',
        resendIn: 'Надіслати',
        seconds: 'сек',
        welcomeTo: 'Вітаємо в',
        codeSent: 'Одноразовий пароль відправлено!',
        errors: {
            invalidEmailAddress: 'Невірна адреса електронної пошти',
            emailIsRequired: "Поле обов'язкове для заповнення",
            verificationCodeIsRequired:
                'Для входу в обліковий запис необхідно ввести одноразовий пароль',
            verificationCodeIsBadOrExpired:
                'Одноразовий пароль неправильний або прострочений. Спробуйте ще раз',
            verificationCodeTooMuchAttempts:
                'Занадто багато спроб. Будь ласка, спробуйте ще раз пізніше',
            loginFailed: 'Не вдалося увійти в систему',
            smthWentWrong:
                'Під час входу щось пішло не так. Спробуйте пізніше або скористайтеся іншим методом',
        },
        loading: {
            sendingCode: 'Відправка коду..',
            loggingIn: 'В процесі авторизації..',
        },
    },
    mintPetRank: {
        title: 'Ранг улюбленця',
        text: 'Ранг визначає, скільки винагород отримає ваш улюбленець за виконання щоденних завдань',
        free: 'Безкоштовно',
        roi: 'ROI ≈',
        dailyReward: 'Щоденна Винагорода',
        buttonNext: 'Перейти до наступного кроку',
        disabled:
            'На один обліковий запис дозволено лише однин безкоштовний ранг',
        info: 'Що таке ранг?',
        whiteList: 'Білий список ({{amount}})',
        mysteryBox: 'Загадкова Коробка',
        mysteryBoxWithAmount: 'Загадкові Коробки ({{amount}})',
    },
    mintPickPhoto: {
        title: 'Виберіть фото свого улюбленця',
        text: 'Сфотографуйте свого улюбленця або оберіть улюблену фотографію з галереї',
        or: 'або',
        takePhoto: 'Відкрити камеру',
        selectFromGallery: 'Виберіть з галереї',
        tips: {
            title: 'Інструкція для ідеального фото',
            visible: 'Правильно',
            cut: 'Вирізаний ',
            blurry: 'Розмитий',
            glare: 'Відблиски',
            tipOne: 'Гарне освітлення має важливе значення',
            tipTwo: 'Намагайтеся робити знімок на нейтральному фоні',
            tipThree: 'Переконайтеся, що тварина на фото єдина',
        },
        analyzingPhoto: 'Аналізуємо вашу фотографію..',
        errors: {
            uploadError: {
                title: 'Не вдалося завантажити',
                text: 'Перевірте підключення до Інтернету та повторіть спробу',
            },
            processImageFailed: {
                title: 'Помилка',
                text: 'Не вдалось обробити фото, попробуйте інше фотоа, або ще раз пізніше',
            },
            notAnimal: {
                title: 'Тут немає тварин',
                text: 'Наші алгоритми не можуть розпізнати тварину на вашому фото. Будь ласка, спробуйте ще раз з іншим фото',
                try: 'Спробуйте ще раз',
                cancel: 'Скасувати',
            },
            explicitContent: {
                title: 'Заборонений контент',
                text: 'На зображенні є заборонений контент. Подальші дії можуть привести до блокування акаунта',
            },
        },
    },
    mintEditPhoto: {
        title: 'Налаштуйте NFT вашого улюбленця',
        text: 'Підберіть фон для вашого NFT-улюбленця',
        loading: 'Зображення в процесі обробки..',
    },
    mintNamePhoto: {
        title: "Виберіть ім'я своєму улюбленцю",
        text: "Ваш улюбленець заслуговує на найкраще ім'я. Ім'я не повинно бути довшим за 20 символів",
        inputLabel: "Ім'я",
        placeHolder: 'наприклад, Sirko',
        buttonNext: 'Перейти до наступного кроку',
        infoText:
            'Наші алгоритми здатні розпізнавати тварин на фотографіях з ймовірністю 99%',
        deleteNFTphoto: 'Видалити фото',
        deleteNFTphotoText:
            'Ви впевнені, що хочете піти? Ваш прогрес буде втрачено',
        yesDelete: 'Так, вийти',
        noKeep: 'Ні, продовжити',
        errors: {
            startSpace: 'Пробіл не може бути першим символом імені',
            specialCharacters: 'Назва не може містити спеціальних символів',
            latinCharacters: 'Назва може містити тільки символи від A до Z',
            numbers: 'Назва не може містити цифр',
            doubleSpaces: 'Назва не може містити подвійних пробілів',
            maxLength: 'Назва не може бути довшою за 20 символів',
            minLength: 'Назва не може бути коротше 2 символів',
            mint: {
                title: 'Не вдалося здійснити карбування NFT',
                petRankWrongState: 'Ранг улюбленця не доступний для монет',
                obscenePetName:
                    'Кличка улюбленця не може містити поганих слів. Ваш акаунт може бути заблокований',
            },
        },
    },
    mintCheckout: {
        transaction: 'NFT',
        rank: 'Ранг',
        nftCustomization: 'NFT',
        successTitle: 'Створено нового улюбленця NFT',
        successText:
            'Ви стали щасливим власником нового улюбленця. Не забувайте про правильний догляд за ним!',
        backToPlaying: 'Розпочати гру',
        backToCollection: 'Переглянути колекцію',
    },
    wallet: {
        screenTitle: 'Гаманець',
        loading: 'Завантаження гаманця..',
        emptyTitle: 'Не вдається завантажити гаманець',
        emptyText: 'Помилка при завантаженні гаманця',
        total: 'Всього',
        deposit: 'Депозит',
        withdraw: 'Вивести',
        trade: 'Торгівля',
        balances: 'Баланс ',
        exchanges: 'Біржі',
        exchangesInfo:
            'Придбати наші токени можна на будь-якій з перерахованих нижче бірж',
        available: 'Доступно:',
        view: 'Перейти',
        depositTo: 'Поповнення рахунку',
        depositBEP: 'Депозит {{coin}} (BEP-20)',
        testnet: 'Тестнет',
        testnetWarning:
            'Додаток працює в тестовій мережі Тестнет, будь-ласка не переводьте справжні гроші на цей адрес гаманця',
        howToPurchaseBNB: 'Як придбати BNB',
        howToPurchaseIGU: 'Як придбати IGU',
        warning:
            'Переконайтеся, що ви вносите токени на правильну адресу та в правильну мережу (BEP-20)',
        withdrawFrom: 'Вийти з',
        transactionHistory: 'Історія транзакцій',
        viewOnBscScan: 'Див. на BscScan',
        noTransactionYet: 'Поки що немає транзакцій',
        noTransactionYetInfo: 'Ви ще не здійснили жодної транзакції',
        transactionDetails: 'Деталі транзакції',
        amount: 'Сума',
        type: 'Тип',
        date: 'Дата',
        fromAddress: 'З гаманця',
        toAddress: 'На гаманець',
        blockChainFee: 'Оплата за газ',
        loadingWithdraw: 'Відправлення транзакції..',
        transactions: {
            coin: {
                DEPOSIT: {
                    name: 'Депозит',
                    text: 'На ваш гаманець прийшла криптовалюта. Переглянути історію транзакцій для більш детальної інформації',
                },
                WITHDRAW: {
                    name: 'Виведення',
                    text: 'Криптовалюта переказана з вашого гаманця. Будь ласка, зверніться на платформу одержувача для отримання квитанції про транзакцію',
                },
                SWAP: {
                    name: 'Обмін',
                    text: 'Криптовалюта була замінена на іншу криптовалюту за допомогою вбудованого DEX.',
                },
                CLAIM: {
                    name: 'Клейм',
                    text: 'Ця транзакція переводить наявні у вас винагороди VIGUP на віртуальному балансі в токени на блокчейні',
                },
                NFT_PAYMENT: {
                    name: 'Платіж NFT',
                    text: "Криптовалюта використовувалася для оплати в додатку за мінт, здоров'я або апгрейд. Переглянути історію транзакцій для більш детальної інформації",
                },
                UNKNOWN: {
                    name: 'Транзакція',
                    text: 'Будь-яка інша мережева транзакція, включаючи підтвердження, комісію тощо. Переглянути історію транзакцій для більш детальної інформації',
                },
                CONFIRMED: { title: 'Завершено' },
                FAILED: {
                    title: 'Не вдалося',
                    text: "У зв'язку з мережевими проблемами ми не змогли обробити вашу транзакцію",
                },
                PENDING: {
                    title: 'На розгляді',
                    text: 'Транзакція ще не підтверджена мережею. Зазвичай це займає від 5 хв до 1 години',
                },
            },
            nft: {
                DEPOSIT: {
                    name: 'Депозит',
                    text: 'Переказ NFT на Ваш гаманець. Переглянути історію транзакцій для більш детальної інформації',
                },
                WITHDRAW: {
                    name: 'Виведення NFT',
                    text: 'Переказ NFT з додатку. Будь ласка, зверніться на платформу одержувача для отримання квитанції про транзакцію',
                },
                MINT: {
                    name: 'Мінт',
                    text: 'Створення NFT у додатку',
                },
                CONFIRMED: { title: 'Завершено' },
                FAILED: {
                    title: 'Не вдалося',
                    text: "У зв'язку з технічними роботами в мережі ми не змогли обробити Вашу транзакцію",
                },
                PENDING: {
                    title: 'На розгляді',
                    text: 'Транзакція ще не підтверджена мережею. Зазвичай це займає від 5 хв до 1 години',
                },
            },
            reward: {
                GameIterationReward: {
                    title: 'Винагорода за Завдання',
                    text: 'Винагорода за виконання щоденних завдань в додатку',
                },
                ReferralReward: {
                    title: 'Реферали',
                    text: 'Винагорода за активність іншого користувача з вашого реферального посилання',
                },
                Claim: {
                    title: 'Клейм',
                    text: 'Ця транзакція переводить наявні у вас винагороди VIGUP на віртуальному балансі в токени на блокчейні',
                },
                PetLevelUpPayment: {
                    title: 'Підвищення Рівня',
                    text: 'Внутрішній платіж за підвищення рівня улюбленця',
                },
                PetRankUpPayment: {
                    title: 'Підвищення Рангу',
                    text: 'Внутрішній платіж за підвищення рангу улюбленця',
                },
                PetRevivePayment: {
                    title: 'Відновлення',
                    text: 'Внутрішній платіж за відновлення улюбленця',
                },
                PetHealUpPayment: {
                    title: 'Лікування',
                    text: 'Внутрішня оплата за лікування улюбленця',
                },
                MintBonus: {
                    title: 'Бонус За Мінт',
                    text: 'Бонусна нагорода за мінт NFT',
                },
                CharityDonation: {
                    title: 'Благодійність',
                    text: 'Пожертвування на вибрану благодійну організацію',
                },
                GameIterationRewardSubtransaction: {
                    title: 'Винагорода за Завдання',
                    text: 'Винагорода за виконання щоденних завдань в додатку',
                },

                CONFIRMED: { title: 'Завершено' },
                PENDING: {
                    title: 'В процесі',
                    text: 'Транзакція клейму була розпочата, але не була завершена. Вам необхідно завершити цю транзакцію, перш ніж ви зможете запросити нову',
                },
                UNLOCK: {
                    title: 'В розблокуванні',
                    text: 'Ці нагороди зараз недоступні і будуть начислені на гаманець відповідно до графіка розблокування.',
                    locked: '{{amount}} {{coin}} заблоковані',
                },
                unlockTransactions: {
                    title: 'Розблоковані нагороди',
                },
                UNKNOWN: {
                    name: 'Транзакція',
                    text: 'Транзакція на гаманці',
                },
                GameRewardStakeBonus: {
                    title: 'Бонус за буст',
                    text: 'Заморожені бонуси за буст',
                },
                GameRewardStakeBonusSubtransaction: {
                    title: 'Бонус за буст',
                    text: 'Заморожені бонуси за буст',
                },
            },
        },
        nft: {
            nft: 'NFT',
            tokenId: 'Ідентифікатор токену',
            myCollection: 'Колекція',
            tooltip: 'Тут ви можете переглянути своїх NFT улюбленців',
            noNFTYet: 'Поки що тут порожньо',
            noNFTYetInfo: 'Порожній список',
            mintNewNft: 'Мінт нової NFT',
            NFTs: '{{balance}} NFTs',
            noNFTs: '0',
            deposit: 'Депозит NFT',
            viewAll: 'Переглянути всі',
            allNFTs: 'Всі НФТ',
            withdraw: 'Вивести NFT',
            withdrawNftLabelAddress: 'Адреса',
            withdrawNftPlaceholderAddress: 'Введіть адресу',
            withdrawNftTitle: 'Вивести NFT',
            blockchainFee: 'Оплата за газ',
            confirmButtonLabel: 'Підтвердити Вивід',
            confirmModal: {
                title: 'Підтвердити виведення NFT',
                nftName: 'NFT',
                addressFrom: 'З (Гаманець)',
                addressTo: 'На (Гаманець)',
                send: 'Підтвердити',
                cancel: 'Скасувати',
            },
            withdrawSuccess: {
                title: 'Виведення NFT',
                text: 'NFT {{name}} було успішно виведено. Зазвичай це займає від 5 хв до 1 години',
                addressFrom: 'З гаманця',
                addressTo: 'На гаманець',
                backToWallet: 'Повернутися до гаманця',
            },
            transactionNft: 'Виведення NFT',
            withdrawWarningText:
                'Переконайтеся, що ви виводите свої токени на правильну адресу і в правильну мережу (BEP-20). Якщо ви відправите NFT на будь-яку іншу мережу або біржовий гаманець, ви можете безповоротно втратити його',
            transactionHistory: 'Історія транзакцій',
            noTransactionYet: 'Немає ні одної транзакціі',
            noTransactionYetInfo: 'Ви ще не зробили жодної транзакції',
        },
        rewards: {
            tooltipText:
                "Кнопка 'Клейм' дозволяє конвертувати ваші віртуальні токени винагороди в IGUP. Ця транзакція виконається на блокчейні. Кнопка буде доступна, як тільки у вас з'являться нагороди, доступні для конверсії.",
            claimButton: 'Заклеймити',
            reclaimButton: 'Повторити',
            stakeButton: 'Буст',
            rewardsWallet: 'Гаманець нагород',
            mainWallet: 'Головний гаманець',
            transactionHistoryText: 'Історія транзакцій',
            rewardsCarousel: {
                availableRewards: 'Доступні винагороди',
                availableRewards_text:
                    'Винагороди, які можна конвертувати в токени IGUP',
                lockedRewards: 'Заблоковані винагороди',
                lockedRewards_text:
                    'Винагороди будуть доступні по графіку розблокування',
                pendingRewards: 'Винагороди для клейму',
                pendingRewards_text: 'Завершити клейм',
                claimReward: 'Заклеймити',
            },
            transactionHistory: {
                Claim: 'Клейм',
                GameIterationReward: 'Винагорода за Завдання',
                ReferralReward: 'Реферальний Бонус',
                PetLevelUpPayment: 'Підвищення Рівня',
                PetRankUpPayment: 'Підвищення Рангу',
                PetRevivePayment: 'Відновлення',
                PetHealUpPayment: 'Лікування',
                MintBonus: 'Бонус за Мінт',
                CharityDonation: 'Благодійність',
                GameIterationRewardSubtransaction: 'Розблокування',
                GameRewardStakeBonus: 'Бонус за буст',
                GameRewardStakeBonusSubtransaction: 'Розблокування',
            },
            filter: {
                title: 'Сортувати за',
                ALL: 'Всі',
                Claim: 'Клейми',
                GameIterationReward: 'Завдання',
                ReferralReward: 'Реферали',
                MintBonus: 'Мінт Бонус',
                GameRewardStakeBonus: 'Бонус за буст',
            },
            empty: {
                title: 'Транзакцій поки що немає',
                text: 'Ваші транзакції будуть відображатися тут',
                button: 'Оновити',
            },
            confirmationModal: {
                title: 'Підтвердити транзакцію',
                keys: {
                    from: 'Від',
                    to: 'На (Гаманець)',
                    fee: 'Оплата за газ',
                    total: 'Підсумок',
                },
                values: {
                    rewardsWallet: 'Гаманець нагород',
                    mainWallet: 'Гаманець IGUP',
                },
                warning:
                    'Переконайтеся, що у вас достатньо на балансі BNB для оплати комісії мережі',
            },
            claimSuccess: {
                title: 'Опрацьовується клейм',
                text: 'Ви ініціювали нову клейм транзакцію з Вашого Гаманця Винагород. Зазвичай обробка транзакції мережею триває від 5 хвилин до 1 години',
                backToWallet: 'Повернутися до гаманця',
            },
            claimLoading: 'Клейм в процесі обробки, не закривайте додаток..',
            claimBusy:
                'Наразі мережа перегружена, будь ласка, спробуйте ще раз через деякий час',
        },
        gaming: {
            gamingWalletChangeFeatureText:
                'Це приблизне співвідношення обміну від IGU до VIGU',
            gamingWalletCarousel: {
                AvailableWallet: {
                    title: 'Доступний гаманець',
                    text: 'Щоб узяти участь, поповніть свій ігровий гаманець',
                },
                PendingWallet: {
                    title: 'Гаманець очікування',
                    text: 'Токени будуть заморожені, поки ви не закінчите гру',
                },
            },
            gamingWalletButtons: {
                topUp: 'Поповнити',
                withdraw: 'Вивести',
            },
            TopUpGamingWalletScreen: {
                screenTitle: 'Поповнити',
                title: 'Поповнити ігровий гаманець',
                text: 'Щоб взяти участь, поповніть свій ігровий гаманець IGU та отримайте VIGU',
                infoText: 'Як це працює',
                button: 'Перейти до Оплати',
                inputSection: {
                    infoText:
                        'Введіть або виберіть кількість, яку ви хочете придбати',
                    errors: {
                        digits: 'Повинні бути тільки цифри',
                        min: 'Сума повинна бути не менше {{limit}} {{coin}}',
                        max: 'Сума повинна бути не бiльше {{limit}} {{coin}}',
                    },
                },
                howToModal: {
                    title: 'Поповнити ігровий гаманець',
                    text: 'Щоб взяти участь, поповніть свій ігровий гаманець IGU та отримайте VIGU. Використовуйте кнопку нижче, щоб поповнити токени',
                },
            },
            SelectWithdrawTokenModal: {
                title: 'Виберіть токен для виведення',
                text: 'Ви можете вибрати токен, у якому ви отримаєте свої нагороди в основному гаманці',
                button: 'Bибрати',
            },
            TopUpSuccessScreen: {
                title: 'Успішне поповнення',
                text: 'Ви успішно поповнили ігровий гаманець токенами. Приєднуйтесь до змагальних ігор просто зараз!',
                button: 'Дослідити ігри',
                button2: 'Переглянути історію транзакцій',
                buttonBack: 'Повернутися до гри',
            },
            transactionHistory: {
                filter: {
                    title: 'Сортувати по',
                    [IGU_WALLET_TRANSACTIONS.All]: 'Всі',
                    [IGU_WALLET_TRANSACTIONS.Deposit]: 'Поповнити',
                    [IGU_WALLET_TRANSACTIONS.Withdraw]: 'Вивести',
                    [IGU_WALLET_TRANSACTIONS.RevertWithdraw]:
                        'Повернути Вивести',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGamePayment]: 'Оплата',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameRefund]:
                        'Закінчення терміну',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDraw]: 'Нічия',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameWin]: 'Перемога',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameFee]: 'Комісія',
                    [IGU_WALLET_TRANSACTIONS.DepositBonus]:
                        'Бонус за поповнення',
                },
                transactions: {
                    [IGU_WALLET_TRANSACTIONS.Deposit]: {
                        title: 'Поповнити',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.Withdraw]: {
                        title: 'Вивести',
                        text: 'Переказ криптовалюти з ігрового гаманця. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.RevertWithdraw]: {
                        title: 'Повернути Вивести',
                        text: 'Переказ криптовалюти з ігрового гаманця. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDraw]: {
                        title: 'Нічия в загадкових лайках',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGamePayment]: {
                        title: 'Оплата в загадкових лайках',
                        text: 'Переказ криптовалюти з ігрового гаманця. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameRefund]: {
                        title: 'Закінчення терміну в загадкових лайках',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameWin]: {
                        title: 'Перемога в загадкових лайках',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.DepositBonus]: {
                        title: 'Бонус за поповнення',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.DirectReferralDepositBonus]: {
                        title: 'Бонус за поповнення (Прямі)',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.IndirectReferralDepositBonus]: {
                        title: 'Бонус за поповнення (Непрямі)',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameFee]: {
                        title: 'Загадкові лайки: зняття комісії',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDirectReferralBonus]:
                        {
                            title: 'Реферальні нарахування (Прямі)',
                            text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                        },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameIndirectReferralBonus]:
                        {
                            title: 'Реферальні нарахування (Непрямі)',
                            text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                        },
                    [IGU_WALLET_TRANSACTIONS.Breeding]: {
                        title: 'НФТ Еволюція мінт',
                        text: 'Переказ криптовалюти з ігрового гаманця. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.GamesTurnoverReward]: {
                        title: 'PVP Бонус',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },

                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameDraw]: {
                        title: 'Фруктові перегони - Нічия',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGamePayment]: {
                        title: 'Фруктові перегони - Оплата',
                        text: 'Переказ криптовалюти з ігрового гаманця. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameRefund]: {
                        title: 'Фруктові перегони - Повернення',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameWin]: {
                        title: 'Фруктові перегони - Перемога',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameFee]: {
                        title: 'Фруктові перегони - Комісія',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.LuckyStrikeGameWin]: {
                        title: 'Лакі Страйк - Перемога',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.LuckyStrikeGamePayment]: {
                        title: 'Лакі Страйк - Білет',
                        text: 'Переказ криптовалюти з ігрового гаманця. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.QuantumSpinReward]: {
                        title: 'Квантовий диск - Винагорода',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.QuantumSpin]: {
                        title: 'Квантовий диск - Оплата',
                        text: 'Переказ криптовалюти з ігрового гаманця. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictWin]: {
                        title: 'Ігуманія - Винагорода',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredict]: {
                        title: 'Ігуманія - Оплата',
                        text: 'Переказ криптовалюти з ігрового гаманця. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictFee]: {
                        title: 'Ігуманія - Комісія',
                        text: 'Переказ криптовалюти з ігрового гаманця. Перевірте більше деталей на bscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictRefund]: {
                        title: 'Ігуманія - Нічия',
                        text: 'Криптовалюта переводяться на ігровий гаманець. Перевірте більше деталей на bscan',
                    },
                },
            },
        },
        stakingBanner: {
            title: 'Збільшіть нагороди та отримайте за це бонуси!',
            text: 'Буст за IGUP доступний просто зараз у вкладці "Нагороди"!',
            button: 'Увімкнути буст',
        },
    },
    trade: {
        poweredBy: 'Powered by',
        from: 'З',
        to: 'На',
        estimate: ' (Приблизно)',
        enterAmount: 'Введіть суму',
        available: 'Макс',
        selectToken: 'Виберіть Токен',
        deposit: 'Депозит',
        trade: 'Обміняти',
        rate: 'Курс',
        confirmTrade: 'Підтвердити торгівлю',
        cancel: 'Скасувати',
        settings: 'Налаштування',
        settingTitle: 'Допустиме прослизання',
        slippageMainText:
            'Ваша транзакція буде скасована, якщо ціна зміниться несприятливо більш ніж на відсоток нижче',
        save: 'Зберегти',
        percentFour: 'Введіть %',
        inputWarning:
            'Значення прослизання має бути між {{minAmount}}% та {{maxAmount}}%. Будь ласка, введіть інший відсоток',
        checkout: { estimate: 'Ви платите', to: 'Ви отримуєте' },
        processingTrade: 'Транзакція в обробці..',
        calculatingTrade: 'Розрахунок..',
        button: 'Обміняти',
        errors: {
            isRequired: "Значення обов'язкове для заповнення.",
            maxAmountError:
                'Недостатньо токенів на балансі. Будь ласка, введіть іншу суму або зробіть вплату',
            minLimit: 'Сума обміну повинна бути не менше {{limit}} {{coin}}',
            bnbNotEnough:
                'На Вашому балансі недостатньо BNB для оплати за газ. Будь ласка, введіть іншу суму або зробіть вплату',
            transaction: 'Транзакція не відбулася',
            DS_MATH_SUB_UNDERFLOW:
                'Завелике число токенів, попробуйте інше число',
        },
        tradeSuccess: {
            title: 'Обмін завершено',
            text: 'Вітаємо! Ви успішно обміняли токени. Ваші токени доступні на вашому балансі. Детальніше в історії транзакцій',
            backToWallet: 'Повернутися до гаманця',
            from: 'Від',
            to: 'До',
            estimate: '(Приблизно)',
            blockchainFee: 'Оплата за газ',
            totalSummary: 'Загальний підсумок',
            back: 'Продовжити торгівлю',
        },
    },
    tradingView: {
        title: 'Графік',
        back: 'Назад до торгівлі',
    },
    walletSettings: {
        title: 'Налаштування гаманця',
        header: 'Параметри безпеки',
        description:
            'Тут можна переглянути сід-фразу, закритити ключ, а також керувати паролем',
        backup: {
            title: 'Сід-фраза',
            description:
                'Ніколи нікому не показуйте свою сід фразу! Вона контролює всі ваші кошти',
            modal: {
                title: 'Фраза / ключ для відновлення гаманця',
                text: 'Переконайтеся, що ніхто не може побачити ваші секретні дані. Розголошуючи їх будь-кому, ви ризикуєте втратити свої кошти',
                yes: 'Побачити',
                no: 'Назад',
                alert: 'Команда IguVerse ніколи не запитає Вас про вашу сід-фразу або приватний ключ. Якщо хтось запитує вас, це 100% шахрай, будьте обережні!',
                checkbox:
                    'Я розумію ризик того, що мої токени і домашні тварини можуть бути вкрадені, якщо я повідомлю комусь свою сід-фразу або приватний ключ',
            },
        },
        passcode: {
            title: 'Пароль та біометрія',
            description:
                'Встановіть або змініть пароль/ввімкніть біометричну ідентифікацію',
        },
    },
    passcode: {
        passcode: 'Пароль',
        modal: {
            title: 'Введіть пароль',
            subTitle:
                'Чотиризначний код підвищить твою безпеку і буде використовуватися для підтвердження валивих дій',
        },
        welcome: {
            title: 'Введіть пароль',
            subTitle:
                'Введіть пароль, який ви будете використовувати для доступу до програми та підтвердження важливих дій',
        },
        new: {
            title: 'Введіть пароль',
            subTitle:
                'Введіть пароль, який ви будете використовувати для доступу до програми та підтвердження важливих дій',
        },
        confirm: {
            title: 'Підтвердьте пароль',
            subTitle:
                'Введіть пароль, який ви будете використовувати для доступу до програми та підтвердження важливих дій',
            error: 'Невірний код. Введіть той самий код що і на минулому етапі',
        },
        check: {
            title: 'Введіть пароль',
            subTitle: 'Введіть поточний пароль для підтвердження',
            error: 'Неправильний код. Спробуйте ще раз або скористайтеся біометричною ідентифікацією',
        },
        success: {
            title: 'Ваш обліковий запис захищений!',
            subTitle:
                'Тепер ваш обліковий запис та гаманець IguVerse захищені від шкідливих дій. Ви завжди можете змінити пароль у налаштуваннях',
        },
        change: {
            title: 'Змінити пароль',
            subTitle:
                'Введіть новий пароль, який буде використовуватися для підтвердження важливих дій',
        },
        faceId: {
            title: 'Увімкнути біометричну ідентифікацію',
            subTitle:
                'Підтверджуйте важливі дії простіше та швидше. Ваші біометричні дані не зберігаються в IguVerse',
        },
        settings: {
            turnOff: 'Вимкнути пароль',
            biometric: {
                title: 'Біометрична ідентифікація',
                subTitle:
                    'Використовуйте Face ID або відбиток пальця для підтвердження важливих дій у програмі',
            },
        },
        modalRemove: {
            title: 'Вимкнути пароль?',
            subTitle:
                'Всі ваші дані надійно захищені паролем. Ви можете змінити його в налаштуваннях у будь-який час',
        },
        toasts: {
            turnOff: 'Успішно! Пароль вимкнено!',
            biometricOff: 'Успішно! Біометрію вимкнено!',
            biometricOn: 'Успіх! Біометрія увімкнена!',
            change: 'Успішно! Пароль змінено!',
            biometricError: 'Помилка! Спробуйте ще раз!',
        },
    },
    walletSettingsBackup: {
        mnemonic: {
            title: 'Ваша сід фраза',
            text: "Будь ласка, запишіть ці 12 слів на аркуші паперу. Записуючи їх, пам'ятайте про їхній порядок. Зберігайте його в надійному місці.",
            reveal: 'Утримуйте, щоб розкрити фразу',
        },
        privateKey: {
            title: 'Ваш приватний ключ',
            text: "Приватний ключ - це випадково згенерований номер, який дає користувачеві контроль над усіма коштами, прив'язаними до гаманця. Зберігайте його в таємниці",
            reveal: 'Утримуйте, щоб відкрити приватний ключ',
        },
        privateKeyModal: {
            title: 'Приватний ключ',
            text: 'Запишіть свій приватний ключ. Зберігайте його в надійному місці',
        },
        buttons: { hidden: 'Тримайте, щоб розкрити', visible: 'Приховати' },
        viewPrivateKey: 'Перегляд приватного ключа',
        emptyTitle: 'Помилка',
        emptyText: 'Не вдається завантажити гаманець',
    },
    withdrawScreen: {
        title: 'Вивести',
        labelAddress: 'Адреса',
        labelAmount: 'Сума',
        placeholderAddress: 'Введіть адресу',
        placeholderAmount: 'Введіть суму',
        labelAvailable: 'В наявності',
        allButtonLabel: 'Макс',
        confirmButtonLabel: 'Підтвердити транзакцію',
        depositButtonLabel: 'Депозит',
        depositBEP: 'Депозит {{coin}} (BEP-20)',
        blockchainFee: 'Оплата за газ',
        totalSummary: 'Загальний підсумок',
        errors: {
            address: 'Адреса не може бути порожньою',
            amountRequired: 'Сума не може бути порожньою',
            invalidAddress: 'Недійсний адресний гаманець',
            sameWallet: 'Неможливо вивести на власний гаманець',
            digits: 'Повинні бути тільки цифри',
            maxAmountError:
                'Недостатньо токенів на балансі. Будь ласка, введіть іншу суму або депозит',
            minLimit: 'Виведення повинно бути не менше {{limit}} {{coin}}',
            bnbNotEnough:
                'Недостатньо BNB на балансі. Будь ласка, введіть іншу суму або зробіть вплату',
        },
        withdrawWarningText:
            'Переконайтеся, що ви вилучили свої токени на правильну адресу та мережу (BEP-20)',
        withdrawWarningTextNFT:
            'Якщо ви відправите NFT в будь-яку іншу мережу або біржовий гаманець, ви можете безповоротно втратити його',
        transaction: 'Виведення коштів',
        withdrawSuccess: {
            title: 'Виведення коштів у процесі обробки',
            text: 'Ви ініціювали нове виведення коштів зі свого гаманця. Зазвичай це займає від 5 хв до 1 години',
            backToWallet: 'Повернутися до гаманця',
            viewTransactionHistory: 'Переглянути історію транзакцій',
        },
    },
    ModalConfirmTransaction: {
        title: 'Підтвердити транзакцію',
        confirm: 'Підтвердити',
        cancel: 'Скасувати',
    },
    ModalCoinSelect: { select: 'Виберіть Токен' },
    ModalCropImage: {
        title: 'Обрізати зображення',
        crop: 'Обрізати і перейти далі',
    },
    qrCodeScanner: {
        openSettings: 'Налаштування',
        noAccessToCamera: 'Немає доступу до камери',
        title: 'Розмістіть QR-код у рамці',
        wallet: {
            titleScanned: 'Адреса відсканована',
            text: 'Відскануйте QR-код адреси токена. Переконайтеся, що видно всі деталі',
        },
        referral: {
            titleScanned: 'Відскановано код направлення',
            text: 'Відскануйте QR-код направлення. Переконайтеся, що всі деталі видно',
        },
        verify: {
            titleScanned: 'Підтвердити відсканований код',
            text: 'Відскануйте QR-код Verify code. Переконайтеся, що видно всі деталі',
        },
    },
    nftSelectGeneration: {
        continue: 'Продовжити',
        search: 'Пошук',
        pageTitle: 'Створіть свого улюбленця NFT',
        pageInfo: 'Ви можете обрати спосіб створення Вашого NFT',
        nftFromPhoto: 'NFT з фото',
        nftFromPhotoText:
            'Створіть красиву NFT з власної фотографії домашнього улюбленця. Виберіть один з наших чудових фонів для вашого майбутнього компаньйона',
        nftFromImagination: 'NFT з Вашої уяви',
        nftFromImaginationText:
            'Наші AI / ML алгоритми можуть намалювати вашого віртуального улюбленця саме таким, яким ви його собі уявляєте. Опишіть риси вашого улюбленця і насолоджуйтеся результатом',
        provideMoreInformation: 'Опишіть улюбленця своєї мрії',
        provideMoreInformationInfo:
            'Виберіть один із запропонованих нижче варіантів, щоб створений NFT ідеально відповідав тому, що ви собі уявляєте',
        selectAccessories: 'Виберіть аксесуари',
        maximumAccessories: 'Ви можете вибрати максимум {{num}} аксесуарів',
        selectGeneratedNFT: 'Оберіть свого улюбленця',
        selectGeneratedNFTInfo:
            'Ми створили кілька унікальних домашніх улюбленців на ваше прохання. Обирайте того, хто вам найбільше сподобався',
        continueNextStep: 'Перейти до наступного кроку',
        generateNewNFT: 'Повторити спробу',
        generateNFTButton: 'Генерувати NFT',
        loadingModalText: 'Йде загрузка..',
        randomize: 'Рандомізувати',
        clear: 'Очистити',
        select: 'Виберіть',
        noResult: 'Немає результатів',
        noResultText:
            'Для "{{query}}" не знайдено результатів. Введіть інші ключові слова для пошуку',
        form: {
            animal: {
                label: 'Тварина',
                placeHolder: 'Виберіть тварину',
                modalTitle: 'Виберіть тварину',
            },
            'drawing-type': {
                label: 'Тип картинки',
                placeHolder: 'Виберіть тип картинки',
                modalTitle: 'Виберіть тип картинки',
            },
            cat: {
                label: 'Порода кішки',
                placeHolder: 'Виберіть породу кішки',
                modalTitle: 'Виберіть породу кішки',
            },
            dog: {
                label: 'Порода собаки',
                placeHolder: 'Виберіть породу собаки',
                modalTitle: 'Виберіть породу собаки',
            },
            'maturity-size': {
                label: 'Вік / Розмір',
                placeHolder: 'Виберіть вік або розмір',
                modalTitle: 'Виберіть вік або розмір',
            },
            color: {
                label: 'Колір',
                placeHolder: 'Виберіть колір',
                modalTitle: 'Виберіть колір',
            },
            emotion: {
                label: 'Емоція',
                placeHolder: 'Виберіть емоцію',
                modalTitle: 'Виберіть емоцію',
            },
            accessories: {
                label: 'Аксесуари',
                placeHolder: 'Виберіть аксесуари',
                modalTitle: 'Виберіть аксесуари',
            },
            context: {
                label: 'Контекст',
                placeHolder: 'Виберіть контекст',
                modalTitle: 'Виберіть Контекст',
            },
            style: {
                label: 'Стиль',
                placeHolder: 'Виберіть стиль',
                modalTitle: 'Виберіть стиль',
            },
        },
        errors: {
            maintenance: {
                title: 'Наші моделі АІ перевантажені',
                text: 'На жаль, наші ШІ-моделі не можуть обслужити ваш запит на даний момент. Будь ласка, спробуйте ще раз',
            },
        },
    },
    bottomNavigation: {
        play: 'Грати',
        charity: 'Благодійність',
        statistics: 'Статистика',
        collection: 'Колекція',
        marketplace: 'Магазин',
    },
    playScreen: {
        timeToComplete: 'Раунд закінчиться через',
        startPlaying: 'Розпочати гру',
        howToPlay: 'Як грати?',
        nftToPlay: 'Колекція',
        edit: 'Редагувати',
        nftToPlayInfo:
            'Обирайте своїх улюбленців, які будуть брати участь у грі та заробляти нагороди',
        nftToPlayHint:
            'Порядок розташування ваших NFT має значення. Перша NFT розташовується на вашому ідентифікаторі улюбленця. Перша NFT також отримує найбільше досвіду за виконання завдань',
        noNFTyet: 'Тут ніхто не живе',
        noNFTyetInfo:
            'На жаль, у вас ще немає улюбленця. Поспішіть завести і розпочинайти гру',
        exploreShop: 'Дослідити магазин',
        mintNew: 'Завести улюбленця',
        dailyTasks: 'Щоденні Завдання',
        dailyTasksInfo:
            'Виконуйте щоденні завдання, щоб заробляти енергію та обмінювати її на токени',
        timeLeftToComplete: 'Раунд закінчиться через',
        selectNFT: 'Додайте більше улюбленців',
        playCards: {
            SHARE_title: 'Поділіться своїм улюбленцем',
            SHARE_info:
                'Ваші домашні улюбленці потребують щоденної уваги. Поділіться ними в соціальних мережах',
            SHARE_button: 'Перейти до завдання',
            addSocialAccount: 'Додати соціальний акаунт',
            socialAlert:
                'Перевірка соціального завдання може зайняти аж 12 годин, і якщо воно виконано пізніше, то буде зараховано аж в наступній ігровій ітерації',
            MOVE_title: 'Вигул домашніх тварин',
            MOVE_info:
                'Ваші домашні улюбленці потребують щоденних прогулянок. Гуляйте зі своїми улюбленцями',
            MOVE_button: 'Перейти до завдання',
            PLAY_title: 'Грайте зі своїми домашніми улюбленцями',
            PLAY_info:
                'Грайте зі своїми улюбленцями в аркадну міні-гру на реакцію',
            PLAY_button: 'Перейти до завдання',
            VERIFY_title: 'Знайти інших тварин',
            VERIFY_info:
                'Знаходьте домашніх улюбленців інших користувачів у соціальних мережах',
            VERIFY_button1: 'Продовжити завдання',
            VERIFY_button2: 'Знайти інших тварин',
            completedEnergy:
                '{{energyRewarded}} / {{maxEnergyReward}} Зібрана енергія',
            SHARE_failed_title: 'Вашу публікацію не вдалося перевірити.',
            SHARE_failed_text:
                'Під час перевірки вашого поста іншим користувачам не вдалося знайти або побачити ваш Pet ID. Ми переглянули повідомлення і не змогли його перевірити. На жаль, сьогодні ви не отримаєте жодної енергії від цього завдання. Будь ласка, постарайтеся бути уважнішими наступного разу',
            SHARE_failed_button: 'Повернутися до ігор',
            knowledgeBase: 'Переглянути базу знань',

            SHARE_failed_reasons: {
                notEnoughFollowers:
                    'Схоже, ваш обліковий запис недостатньо активний. Будь ласка, виберіть інший обліковий запис або займіться розвитком цього',
                petIdNotFound:
                    'Інші користувачі стверджують, що не можуть знайти пост із Pet ID у вашому профілі',
                petIdIncorrectPosition:
                    'Ваш Pet ID розміщено так, що інші користувачі не можуть розібрати, що на ньому. Намагайтеся бути уважнішими наступного разу',
                userNotFound:
                    'Ні користувачі, ні адміністратори не змогли знайти ваш обліковий запис. З нею щось трапилося?',
            },
            SHARE_success_title: 'Завдання з обміну виконано',
            SHARE_success_text:
                'Вітаємо! Ви поділилися фотографією і вона пройшла перевірку. Приходьте завтра за новинами',
            SHARE_success_button: 'Переглянути деталі',
        },
        modalAllDead: {
            title: 'Ваші домашні тварини мертві',
            text: 'Ви не можете виконувати завдання, поки хоча б один з ваших улюбленців не буде в хорошій формі. Відновлюйте своїх улюбленців і повертайтеся',
            button: 'Відновити улюбленця',
        },
        modalSomeDead: {
            title: 'Деякі з ваших домашніх тварин загинули',
            text: 'Деякі з ваших улюбленців загинули, і вони не отримають винагороди. Ви впевнені, що хочете продовжувати?',
            button: 'Відновити улюбленців',
            button2: 'Продовжити грати',
        },
    },
    collectionsScreen: {
        title: 'Моя колекція',
        text: 'Це дім для ваших чудових домашніх улюбленців',
        mintNewNft: 'Завести першого улюбленця',
        mintPet: 'Створіть домашнього улюбленця',
        noCollectionsYet: 'Тут ніхто не живе',
        noCollectionsYetInfo:
            'На жаль, у вас ще немає улюбленця. Поспішіть завести його!',
        levelUp: 'Підвищити рівень',
        rankUp: 'Підвищити ранг',
        restore: 'Відновити',
        feed: 'Погодувати',
        healAllButtonTooltip:
            "Ви можете використовувати масове зцілення вихованців, лише якщо у вас є щонайменше 2 вихованці зі здоров'ям нижче 100%",
    },
    detailedPet: {
        headerSubtitle:
            'Це ваш домашній улюбленець в формі NFT, з ним ви можете виконувати щоденні завдання та отримувати за це винагороди. Не забувайте про нього піклуватись',
        levelXP: {
            title: 'Level & XP',
            text: 'Заробляйте досвід за виконання завдань і підвищуйте рівень свого улюбленця. Після досягнення певного рівня улюбленець може перейти на більш високий ранг',
            textUpgrade:
                'Ви зібрали весь можливий досвід на рівні {{level}}. Підніміть свій NFT на новий рівень, щоб заробляти більше токенів',
            upgrade: 'Підвищити до {{level}} Рівень',
        },
        animalType: {
            title: 'Тип тварини',
            text: 'Наші алгоритми здатні з високою ймовірністю розпізнавати тварин на фотографіях',
        },
        rank: {
            title: 'Ранг {{rank}}',
            text: 'Ранг - одна з основних характеристик улюбленця. Вищі ранги приносять більше нагород і мають вищу швидкість розблокування нагород',
            upgrade: 'Підвищити до "{{rank}}" Ранг',
            textUpgrade:
                'Ви досягли всіх рівнів у ранзі "{{rank}}". Перейдіть на новий ранг, щоб заробити більше жетонів',
        },
        age: {
            button: 'Відновити NFT',
            Baby: 'Дитина NFT = {{current}} / {{max}} днів',
            Young: 'Підліток NFT = {{current}} / {{max}} днів',
            Adult: 'Дорослий NFT = {{current}} / {{max}} днів',
            Old: 'Старий NFT = {{current}} / {{max}} днів',
            description:
                'Вік вашого улюбленця рахується з моменту його створення. Коли ваш улюбленець постаріє, він помре, і його потрібно буде відновити',
            descriptionDead:
                'Улюбленець прожив довге і щасливе життя і померла. Не потрібно засмучуватися, ви можете оживити його та грати знову!',
            dailyUnlock: 'Щоденне розблокування = ',
            daysMore: 'ще днiв',
            modalWhatIsAge: {
                title: 'Що таке вік?',
                text: 'Щойно ви створите свого звіра, він почне жити та старіти. У міру дорослішання він зрештою помре. У цьому випадку його потрібно буде оживити. Довголіття вашого віртуального вихованця залежить від його рангу',
                feature: {
                    title: 'Знижка на оживлення = {{discount}}%',
                    text: 'Після природної смерті улюбленця, його можна воскресити зі знижкою {{discount}}% (зберігаючи ранг)',
                    alert: 'Підвищення рангу скине вік вашого улюбленця до нуля, і оновлений віртуальний улюбленець буде жити відповідно ліміту нового рангу. Після того, як улюбленець вернеться до життя - ви почнете з першого рівня',
                },
            },
            modalNFTisAgeDead: {
                button: 'Відновити',
                title: 'NFT померла від старості!',
                text: 'NFT "{{name}}" прожила довге і щасливе життя і померла. Не потрібно засмучуватися, ви можете оживити її та грати знову!',
                feature: {
                    title: 'Знижка на оживлення = {{discount}}%',
                    text: 'Після природної смерті NFT її можна воскресити зі знижкою {{discount}}% (зберігаючи ранг)',
                    alert: 'Підвищення рангу скине вік вашого улюбленця до нуля, і оновлений віртуальний улюбленець буде жити відповідно ліміту нового рангу. Після того, як улюбленець вернеться до життя - ви почнете з першого рівня',
                },
            },
            checkoutAgeRevive: {
                title: 'Відновлення NFT',
                text: 'Ваш NFT недоступний для виконання щоденних завдань. Відновіть його, щоб грати та заробляти більше токенів',
                restoreTo: 'Відновити до',
                transaction: `Відновити "{{name}}" NFT`,
                errors: {
                    wrongState: 'Щось не так, не вдається оживити улюбленця.',
                },
            },
            successAgeRevive: {
                title: 'NFT відновлено!',
                text: 'NFT успішно відновлено. Грайте щоденні завдання та заробляйте ще більше токенів',
                backToPet: 'Переглянути улюбленця',
            },
        },

        earnings: {
            title: 'Заробіток',
            text: 'Заробіток NFT залежить від рангу та рівня улюбленця',
            rank: 'Заробіток з Рангу = ',
            level: 'Бонус з Рівня = ',
        },
        matching: {
            title: 'Вподобання',
            text: 'Інші користувачі можуть оцінювати вашого NFT улюбленця в завданнях',
            like: '{{like}} Лайків',
            dislike: '{{dislike}} Дізлайків',
        },
        health: {
            title: "Здоров'я",
            text: "Нагодуйте улюбленця, інакше він може втратити здоров'я. Як тільки здоров'я улюбленця досягне 0, улюбленець помре",
            titleDead: 'Улюбленець помер',
            textDead:
                'Ви довго не годували свого улюбленця і тепер він помер. Ви не зможете збирати досвід, нагороди та грати зі своїм улюбленцем. Але не хвилюйтесь, ви можете вернути його до тями і продовжити гру. Покваптеся!',
            buttonFeed: 'Годувати улюбленця',
            buttonRestore: 'Відновлення NFT',
            modalWhatIsHealth: {
                title: "Що таке здоров'я?",
                text: "Здоров'я вашого улюбленця погіршується з кожним днем, якщо ви її не годуєте. Тримайте своє здоров’я завжди на максимумі, щоб заробляти більше.",
                card: {
                    title: "Здоров'я улюбленця = Щоденні нагороди",
                    text: 'Нагороди пропорційні HP, тобто. маючи 80 HP, ви отримаєте 80% нагород. Дбайте про свого улюбленця!',
                },
            },
            modalNFTisDead: {
                title: 'NFT Улюбленець помер',
                text: 'Ви довго не годували свого улюбленця і нажаль він помер. Ви не зможете збирати досвід, нагороди та грати зі своїм улюбленцем. Але не хвилюйтесь, ви можете вернути його до тями і продовжити гру. Покваптеся!',
                button: 'Відновити улюбленця',
            },
            checkoutRevive: {
                title: 'Відновлення NFT',
                text: 'Ваш NFT недоступний для виконання щоденних завдань. Відновіть його, щоб грати та заробляти більше токенів',
                restoreTo: 'Відновити до',
                transaction: `Відновити "{{name}}" NFT`,
                max: "100 Здоров'я",
                errors: {
                    wrongState: 'Щось не так, не вдається оживити улюбленця.',
                },
            },
            successRevive: {
                title: 'NFT відновлено!',
                text: 'NFT успішно відновлено. Грайте щоденні завдання та заробляйте ще більше токенів',
                backToPet: 'Переглянути улюбленця',
            },
            infoMultipleHealUp: {
                title: 'Погодувати декількох вихованців',
                text: 'Використовуйте одну кнопку, щоб нагодувати всіх вихованців! Вихованці лікуватимуться по черзі. Усі транзакції відбуваються у блокчейні, тому ви зможете їх відстежити',
                primaryButton: 'Погодувати вихованців',
                secondaryButton: 'Не показуйте це більше',
            },
            checkoutHealUp: {
                title: "NFT Здоров'я",
                text: "Здоров'я вашої тварини залежить від щоденного годування. При повному здоров'ї ваша тварина заробляє більше монет",
                restoreTo: 'Відновити на',
                transaction: `Відновити "{{name}}" NFT`,
                max: "{{amount}} Здоров'я",
                errors: {
                    wrongState: 'Щось не так, не може вилікуватися улюбленець.',
                },
            },
            checkoutMultipleHealUp: {
                title: 'Погодувати декількох вихованців',
                text: "Відновіть здоров'я всіх ваших вихованців. NFT з великою кількістю здоров'я матимуть більше нагород",
                transaction: `Відновити {{count}} NFT`,
            },
            proceedingMultipleHealUp: {
                title: "Здоров'я відновлюється",
                text: 'Зачекайте, поки всі транзакції не будуть завершені. Не виходьте з екрана, оскільки транзакції можуть не пройти! Як тільки їх буде завершено, ви зможете вийти з екрана',
                error: 'Деякі транзакції NFT завершилися невдачею через проблеми з блокчейном. Спробуйте ще раз',
            },
            multipleSuccessHealUp: {
                title: "Здоров'я NFT відновлено!",
                text: "Здоров'я ваших вихованців було відновлено. Натисніть кнопку нижче, щоб отримати докладнішу інформацію про кожну транзакцію",
                backToCollection: 'Повернутись до колекції',
                item: 'Годівля {{length}} улюбленців',
            },
            successHealUp: {
                title: "Здоров'я NFT відновлено!",
                text: "NFT успішно вигодували та відновили здоров'я. Грайте щоденні завдання та заробляйте ще більше токенів",
                backToPet: 'Переглянути улюбленця',
            },
            healUpAmountChoose: {
                title: "Погодувати і відновити здоров'я",
                text: "Виберіть кількість очок здоров'я, яке ви хочете відновити",
                button: 'Перейти до Оплати',
                loading: 'Підсумування..',
                label: 'Виберіть відповідну кількість',

                errors: {
                    MAX: 'Макс. можна відновити {{amount}} здоров’я',
                    MIN: 'Мін. можна відновити {{amount}} здоров’я',
                },
            },
            healthPetCollectionList: {
                health: "{{health}} Здоров'я",
            },
            healAllLeave: {
                title: 'Ви впевнені, що хочете піти?',
                text: 'Процес годування ваших вихованців триває, якщо ви покинете сторінку під час нього, це може призвести до помилок, подвійних витрат або некоректного вирахування балансу. Дійте з обережністю',
                leave: 'Вийти',
                keep: 'Продовжити годування',
            },
        },
        blockchainInfo: {
            tokenId: 'Ідентифікатор токену',
            title: 'Огляд NFT',
            description:
                'Ваш улюблений NFT-актив зберігається на блокчейні. Ви можете вивести його з гаманця в будь-який момент',
            descriptionFree:
                'Ваш улюбленець не має рангу, і не є справжнім NFT. Підвищуйте рівень і ви зможете зробити з нього NFT',
            warningText:
                'Після виводу NFT перейде в режим Cooldown і буде недоступний для гри протягом наступних 24 годин',
            cooldown: 'Охолодження закінчується в',
            withdraw: 'Вивести',
        },
    },
    mysteryBoxes: {
        title: 'Загадкові Коробки',
        emptyTitle: 'Загадкові Коробки Відсутні',
        emptyText: 'У вас немає ні одної загадкової коробки',
        emptyButton: 'Купити коробку',
        prepareToOpen: 'Підготовка до відкриття..',
        banner: {
            isComing: {
                title: 'Продаж Загадкових Коробок завершений',
                text: ' часу залишилось',
            },
            isStart: {
                title: 'Купити Загадкову Коробку',
                text: 'Попробуйте ваше везіння',
            },
            isNotAvailable: {
                title: 'Продаж Закрита',
                text: 'Продаж Загадкових Коробок це незвичайна подія, і нажаль поки що він недоступний',
            },
        },
        header: {
            title: 'Загадкові Коробки',
            text: 'Ваші Загадкові Коробки будуть зберігатись тут',
        },
        mysteryBoxCard: {
            open: 'Відкрити',
            mint: 'Створити NFT',
        },
        error: {
            title: 'Помилка',
            text: 'Щось пішло не так, будь ласка попробуйте ще раз',
        },
        openRank: {
            button: 'Подивитись Деталі',
        },
        openBoxModal: {
            title: 'Ви Хочете Відкрити Коробку?',
            text: 'Після відкриття коробки вам згенерується випадковий ранг і ви зможете змінтити NFT',
            button1: 'Так, Відкрити',
            button2: 'Ні, назад',
        },
        purchaseWelcome: {
            stepOne: {
                title: 'Попробуйте Ваше Везіння з Загадковими Коробками',
                text: 'Загадкові Коробки дають вам можливість придбати найкращий можливий ранг за фіксованою ціною. Бажаємо вам везіння!',
            },
            stepTwo: {
                title: 'Шанс Отримати Найкращий Ранг',
                text: 'Після покупки Загадкової коробки, ви зможете відкрити її в любий час і перейти до процесу створення NFT без додаткових коштів',
            },
            stepThree: {
                title: 'Справжня Випадковість',
                text: 'Загадкові Коробки використовують технологію справжніх випадкових чисел від ChainLink, яка гарантує справедливу генерацію випадкових чисел, яка записується на блокчейні',
            },
            button: 'Вибрати Кількість',
        },
        purchaseScreen: {
            title: 'Вибрати Кількість',
            text: 'Ви можете купити декілька коробок за один раз',
            label: 'Виберіть або впишіть кількість',
            labelNoInput: 'Виберіть кількість коробок',
            errors: {
                max: 'Максимальна кількість 10 штук',
                min: 'Мінімальна кількість 1 штука',
                noSymbols: 'Тільки числа дозволено',
            },
            button: 'Перейти до Оплати',
            loading: 'Підсумування..',
        },
        purchaseCheckout: {
            title: 'Купити Загадкові Коробки',
            text: 'Загадкові Коробки дають вам можливість придбати найкращий можливий ранг за фіксованою ціною. Бажаємо вам везіння!',
            transactionDetails: {
                label: 'Загадкові Коробки',
                text: '{{amount}} шт.',
                transaction: 'Купити {{amount}}',
            },
        },
        purchaseSuccess: {
            title: 'Загадкові Коробки Успішно Куплені!',
            text: 'Вітаємо вас з покупкою загадкових коробок! Відкривайте їх і створюйте ваші NFT',
            button: 'Перейти До Коробок',
        },
        comingSoon: {
            title: 'Продаж Загадкових Коробок Вже Незабаром',
            text: 'Наближається продаж Загадкових Коробок, не пропустіть цю можливість!',
            timer: 'Залишилось часу',
        },
        saleClosed: {
            title: 'Загадкові Коробки',
            text: 'Загадкові Коробки зараз недоступні. Слідкуйте за офіційними джерелами, і не пропустіть продаж',
        },
        errors: {
            forbidden: {
                title: 'Коробки закінчились',
                text: 'На жаль Загадкові Коробки закінчились. Попробуйте своє везіння наступного разу',
            },
        },
        modalMysteryBoxSaleInfo: {
            title: 'Спробуйте свою удачу з Загадковими коробками',
            text: 'Вартість виграної NFT буде не меншою за ціну самої коробки. Коробки продаються за ціною',
            timerTitle: 'Час до розпродажу',
            timerText:
                'Ми підготували розпродаж лімітованої колекції, яка триватиме обмежений час. Усього ',
            timerAdditionalText: '{{amount}} NFT',
            chanceTitle: 'Шанси на перемогу',
            chanceText: 'Виграйте NFT з певною ймовірністю:',
            button: 'Перейти до коробок',
        },
    },
    errorBoundary: {
        navigation: 'Помилка',
        title: 'Помилка в коді',
        text: 'На жаль, щось пішло не так з нашого боку. Якщо ви продовжуєте бачити цю помилку, будь ласка, зверніться до нашої служби підтримки',
        button: 'Перейти на головну сторінку',
        reloadApp: 'Перезавантажити додаток',
    },
    pullToRefresh: {
        reloadBalance: {
            text: 'Оновлення балансу..',
            modalText: 'Оновлення..',
        },
        reloadPets: {
            text: 'Оновлення домашніх улюбленців..',
            modalText: 'Оновлення..',
        },
        reloadTasks: {
            text: 'Оновлення завдань..',
            modalText: 'Оновлення..',
        },
        reloadVerifyUsers: {
            text: 'Шукаємо домашніх улюбленців..',
            modalText: 'Оновлення..',
        },
        reloadMysteryBox: {
            text: 'Оновлення..',
            modalText: 'Оновлення..',
        },
        reloadRewards: 'Оновлення винагород..',
        reloadStatistics: 'Оновлення статистики..',
        reloadReferrals: 'Оновлення рефералів..',
        loading: 'Оновлення..',
        pulling: 'Потягнути, щоб оновити',
        releasing: 'Відпустити',
    },
    petLevelUp: {
        readyToUpModal: {
            titleStart: 'Улюбленець готовий до підвищення до',
            titleLevelUp: ' {{level}} Рівня ',
            titleEnd: '',
            subTitleStart: 'Вітаємо! Ви зібрали весь досвід і NFT ',
            subTitleEnd: ' готовий до підвищення рівня',
            button: 'Підвищити',
            featureRankEarnings: {
                title: 'Заробіток від рангу ≈ {{igup}} ≈ ({{usd}}$)',
                text: 'Це ваші прибутки, виходячи лише з рангу',
            },
            featureLevelEarnings: {
                title: 'Заробіток від рівня',
                text: 'Додатковий заробіток, який ви отримуєте залежно від рівня вашої NFT. Кожен наступний рівень збільшує ваш дохід',
            },
            featureNextRank: {
                title: 'Ще {{levels}} рівні(ей) до “{{rankName}}”',
                text: 'Вам потрібно підвищити свою NFT ще {{levels}} рази, перш ніж ви зможете підвищити її до наступного рангу',
            },
        },
        petLevelUpSuccess: {
            title: 'NFT Улюбленець підвищений в рівні!',
            text: 'NFT {{name}} успішно підвищено до рівня {{level}}. Виконуйте щоденні завдання та заробляйте ще більше токенів з вашим NFT улюбленцем',
            backToPet: 'Переглянути улюбленця',
            loading: 'Завантаження..',
        },
        headerTitle: 'Підвищити рівень NFT',
        checkout: {
            upgrade: 'Підвищення до',
            level: 'Рівень {{level}}',
            transaction: 'Підвищити рівень для {{name}} NFT',
        },
        errors: { PET_WRONG_STATE: 'Підвищення рівня недоступне' },
    },
    petRankUp: {
        readyToUpModal: {
            title: 'Підвищити до {{rank}} Рангу',
            subTitle:
                'Ви досягли всіх рівнів у ранзі {{rank}} і ваш улюбленець готовий до підвищення рангу',
            button: 'Підвищити',
        },
        petLevelUpSuccess: {
            title: 'Рівень NFT підвищений!',
            text: 'NFT {{name}} був успішно підвищений до рангу {{rank}}. Грайте щоденні завдання та заробляйте ще більше токенів з оновленим NFT',
            backToCollection: 'Повернутись до колекції',
            loading: 'Завантаження..',
        },
        headerTitle: 'Підвищення рівня NFT',
        checkout: {
            upgrade: 'Підвищення до',
            level: 'Рівень {{level}}',
            transaction: 'Підвищити рівень для {{name}} NFT',
        },
        errors: { PET_WRONG_STATE: 'Підвищення не доступно' },
    },
    petIsPlaying: {
        title: 'Ваш улюбленець бере участь в ігрі',
        text: 'Якщо ви вишлете NFT з акаунта під час виконання завдань, ви не отримаєте винагороди за завдання, а ваш улюбленець перейде в режим Cooldown на наступні 24 години',
        button: 'Я розумію, далі',
    },
    petOnCooldown: {
        title: 'Cooldown NFT',
        text: 'Ваш NFT був переданий з іншого гаманця і ще не доступний для участі в завданнях',
    },
    petIsDead: {
        title: 'NFT улюбленець мертвий',
        text: 'Ви давно не годували свою тварину "{{petName}}" і тепер вона померла. Ви не зможете збирати досвід, нагороди та грати зі своїм улюбленцем. Але не хвилюйтеся, ви можете оживити його і продовжити гру. Покваптеся!',
        errors: {
            PET_WRONG_STATE: 'Відновлення улюбленця недоступне',
        },
    },
    socializeToEarn: {
        welcomeSlidesShare: {
            startSharing: 'Поділитись в соцмережах',
            sharing: 'Ділитися - значить піклуватися',
            sharingText:
                'Щодня ваші улюбленці потребують вашої уваги. Подаруйте її, поділившись з друзями в соціальних мережах',
            sharingEnergy: ' Енергії',
            socialMedia: 'Поділіться своїм улюбленцем у соціальних мережах',
            socialMediaText:
                'Виберіть свій обліковий запис у соціальній мережі та прикріпіть Pet ID до свого контенту в соціальних мережах, щоб інші користувачі могли знайти вашого улюбленця',
            socialMediaEnergy: ' Енергії',
            referral: 'Додайте своє реферальне посилання',
            referralText:
                'Ваше реферальне посилання має бути прикріплене до ID вихованця в історії. Інші гравці не зможуть перевірити ваше завдання, якщо посилання відсутнє!',
            errors: {
                FORBIDDEN: {
                    text: 'Ви не можете розпочати соціальне завдання цього дня з цим соціальним акаунтом. Попробуйте завтра ще раз',
                },
            },
        },
        shareYourPetPhoto: {
            copyToClipboard: 'Ім’я користувача скопійовано в буфер обміну',
            title: 'Поділіться в соцмережах',
            texts: {
                INSTAGRAM:
                    'Діліться своїм контентом з прикріпленою карткою Pet ID в історії Instagram та дозволяйте іншим користувачам знаходити вашого улюбленця',
                TIKTOK: 'Діліться своїм контентом з прикріпленою карткою Pet ID в TikTok і дозволяйте іншим користувачам знаходити вашого улюбленця',
                TWITTER:
                    'Діліться своїм контентом з прикріпленою карткою Pet ID в Twitter і дозволяйте іншим користувачам знаходити вашого улюбленця',
                FACEBOOK:
                    'Діліться своїм контентом з прикріпленою карткою Pet ID в Facebook і дозволяйте іншим користувачам знаходити вашого улюбленця',
            },
            info: 'Як поділитися?',
            download: 'Зберегти',
            share: 'Поділитися',
            createPhoto: 'Редактор',
            button: 'Поділитись і завершити',
            warningText:
                'Переконайтеся, що ваш Pet ID можуть знайти інші користувачі, поки ваше завдання не буде підтверджено',
            selectCreationMethod: 'Виберіть фотографію',
            creationMethod: {
                camera: 'Зробити фото',
                gallery: 'Виберіть з галереї',
            },
            modalPetIdVisible: {
                title: 'Чи добре видно Pet ID і посилання?',
                text: 'Вашу історію перевірятимуть інші користувачі. Якщо вони не зможуть знайти Pet ID або посилання чи не зможуть розгледіти його вміст, завдання вважатиметься невиконаним',
                button1: 'Так, продовжити',
                button2: 'Ні, перевірити ще раз',
            },
            modalShareYourPhoto: {
                title: 'Виберіть спосіб',

                shareTemplate: {
                    title: 'Поділитись шаблоном',
                    text: 'Використовуйте створений шаблон, щоб поділитися Pet ID швидше',
                },
                editToShare: {
                    title: 'Редагувати та поділитися',
                    text: 'Завантажте зображення з галереї або зробіть фото, щоб редагувати Pet ID',
                },
                downloadPetId: {
                    title: 'Завантажити Pet ID',
                    text: 'Оформіть публікацію на власний розсуд, не використовуючи наші інструменти',
                },
                submit: 'Я поділився(лась) Pet ID',
                loading: 'Контент готується..',
                saveSuccess: 'Зображення успішно збережено',
            },
            petIdVisibleLoading: 'Створення завдання пошуку..',
            shareSuccess: {
                title: 'В Очікуванні на Перевірку',
                text: 'Ви успішно поділилися фотографією свого улюбленця, зазвичай підтвердження триває від 6 до 12 годин. Тепер ваша черга знайти інших домашніх улюбленців у соціальних мережах',
                button1: 'Знайти інших домашніх улюбленців',
                button2: 'Повернутись назад',
                button3: 'Повернутись до завадань',
                toastSuccess: 'Всі пошукові завдання виконані',
            },
            alert: 'Для правильного виконання завдання необхідно вставити посилання на додаток до історії',
        },
        createShareTemplate: {
            screenTitle: 'Поділитись шаблоном',
            title: 'Поділитись за допомогою шаблону',
            text: 'Діліться контентом швидко та зручно, використовуючи створений нами шаблон',

            shareTemplate: {
                Default: 'Я граю в IguVerse  щодня і заробляю криптовалюту',
                BinanceNft: 'Заробляйте NFT вихованцем разом з IguVerse',
                BnbChain: 'Заробляйте NFT вихованцем разом з IguVerse',
                Okx: 'IGU готуєтся до висадки на Місяць на OKX',
                KuCoin: 'IGU готуєтся до висадки на Місяць на KUCOIN',
                Bybit: 'Проголосуйте за\nIguVerse на ByBit\nі розділіть\n$121 000!',
            },
            placeForLink: 'Місце для посилання',
            socialCardTemplate: {
                Default: 'Я граю в IguVerse\nі заробляю криптовалюту',
                Bybit: 'Проголосуйте за\nIguVerse на ByBit\nі розділіть\n$121 000!',
            },
        },
        welcomeSlidesVerify: {
            startVerify: 'Почати пошукове завдання',
            find: 'Знайти інших домашніх улюбленців',
            findText:
                'Ваш улюбленець потребує уваги з боку інших улюбленців. Знаходьте улюбленців інших гравців і насолоджуйтеся нагородами разом. Не допускайте помилок під час пошуку інших улюбленців, вони покладаються на вас. Ваша щоденна мета - знайти всіх улюбленців.',
            findEnergy: ' Енергії',
            beResponsible: 'Будьте відповідальними',
            beResponsibleText:
                'Грайте чесно і не намагайтеся обманювати, вводячи систему в оману, надаючи невірні ідентифікатори або стверджуючи, що ви не можете знайти. Ваш обліковий запис може бути позначений, як тільки ви зробите це',
            beResponsibleEnergy: ' Енергії',
        },
        verifyUser: {
            title: 'Пошук улюбленця',
            text: 'Знайдіть і введіть Pet ID іншого користувача за посиланням в його соцмережах. За кожен успішний матч ви отримаєте {{energy}} Енергії',
            info: 'Як знайти Pet ID?',
            label: 'Pet ID код',
            placeHolder: 'Введіть ідентифікатор Pet ID',
            question: 'Як знайти Pet ID?',
            buttonVerify: 'Відправити',
            buttonNotFound: 'Ідентифікатор не знайдено',
            errorMessage:
                'Неправильний ідентифікаційний код тварини. Спробуйте ще раз. Залишилося {{attempts}}!',
            loadingVerifyUser: 'Перевірка завдань..',
            errors: {
                noTasksText1: 'Зараз немає доступних завдань',
                noTasksText2: 'Приходьте пізніше',
                gameIterationExists1: 'Ви не маєте права створювати',
                gameIterationExists2: 'більше завдань у цій ітерації гри',
            },
            toastNoPetVerification: {
                title: 'Помилка',
                text: 'Тварина недоступна для перевірки',
            },
            toastSuccess:
                'Вітаємо! Користувача {{user}} успішно зверифікований',
            toastFailedVerify: 'Провал! Користувач {{user}} не підтверджений',
            regexError: 'Допускаються тільки цифри та символи від A до Z',
            verifyEmpty: {
                title: 'Більше нікого немає',
                text: "Схоже, що зараз ніхто не грає. Ми повідомимо вам, коли з'являться нові домашні улюбленці",
                button1: 'Перейти до інших завдань',
                button2: 'Спробуйте ще раз',
                refresh: 'Оновити',
            },
            verifyNotFound: {
                title: 'Домашнього улюбленця не знайдено',
                text: 'Сподіваюся, ви не помилилися. Якщо тварина дійсно була там, то ми зробимо вам попередження',
                button1: 'Знайти далі',
                button2: 'Закінчити гру',
            },
            verifyAlreadyCompleted: {
                title: 'Вже завершено',
                text: 'Текст вже готовий',
                button1: 'Підтвердити Далі',
                button2: 'Закінчити гру',
            },
            verifyMatch: {
                title: 'Ваші домашні улюбленці знайшли один одного!',
                text: {
                    step1: 'Вітаємо! Твій улюбленець',
                    step2: ' здружився з домашнім улюбленцем',
                    step3: '! Тепер ви зможете спілкуватись всередині додатку',
                },
                button1: 'Знайти далі',
                button2: 'Закінчити гру',
                like: 'Мені подобається',
                dislike: 'Не подобається',
                alreadyRate: 'Не можете змінити своє рішення',
            },
            verifyFailed: {
                title: 'Не вдалося',
                text: 'На жаль, ви не вказали правильний ідентифікаційний код тварини',
                button1: 'Знайти далі',
                button2: 'Закінчити гру',
            },
            modalPetIdNotFound: {
                title: 'Не знайдено ідентифікатор домашнього улюбленця?',
                text: 'Будь ласка, спробуйте знайти Pet ID на фотографії користувача. Якщо Pet ID був, а Ви його не надали, то Ви не отримаєте Energy бали і можете отримати попередження.',
                button1: 'Так, підтверджую',
                button2: 'Скасувати',
            },
            tips: {
                title: 'Поради щодо перевірки',
                alert: "Якщо Pet ID не відповідає правилам, натисніть кнопку 'Ідентифікатор не знайдено'",
                post: 'Pet ID має бути в історії',
                picture:
                    'Pet ID і вся інформація на ньому повинні бути легко помітні на зображенні',
                changes:
                    'Pet ID можна змінити, але зміни не повинні суперечити іншим правилам',
                cropping:
                    'Забороняється обрізати, або ховати зображення і інформацію на ньому',
                overlaying:
                    'Забороняється зменшувати розмір Pet ID значно від оригінального',
            },
        },
        petCardId: {
            link: 'Завантажити додаток IguVerse ',
            earnStart: 'Мої улюбленці заробляють ',
            earnEnd: ' щодня',
            freeEarn: 'Мій безкоштовний улюбленець заробляє ',
            donateMessage: 'Частина заробітку йде на підтримку організації ',
            binanceMessage: 'IguVerse x Binance Розпродаж NFT',
            bnbMessage:
                'IguVerse x BNB Chain: Приєднуйтесь до нового тренду в Web3 і соціальних мережах',
            okxKuCoinMessage: 'Токен IGU запускається на ',
            defaultMessage:
                'Ми створюємо ШІ-маркетплейс і рекламну мережу - приєднуйся!',
        },
    },
    moveToEarn: {
        welcomeSlides: {
            walkPet: 'Вигул домашніх тварин',
            walkPetText:
                'Ваші домашні улюбленці потребують щоденних прогулянок, щоб бути здоровими так само, як і ви. Вигулюйте свого улюбленця, і ви будете винагороджені Енергією',
            energyTotal: ' Енергії',
            complete: 'Досягніть своєї мети в ходьбі',
            completeText:
                'Виконуйте свою спортивну мету, відстежуйте результати та насолоджуйтесь здоровим способом життя',
            antiCheating: 'Алгоритми захисту від накруток',
            antiCheatingText:
                'Наші алгоритми боротьби з накруткою здатні виявити підозрілу активність користувача. Користувачі, які шахраюють, втрачають свої енергетичні бали',
        },
        modals: {
            prepare: 'Готуємося до прогулянки',
            prepareText:
                'Ви можете виконувати прогулянку один раз на день. Після того, як ви закінчите завдання, ви не зможете грати більше цього дня',
            leave: 'Ви хочете піти?',
            leaveText:
                'Ваш прогрес буде збережено, але ви зможете перейти до збору енергії вже завтра',
            leaveBtn1: 'Так, вийти',
            leaveBtn2: 'Ні, продовжуйте',
            prepareBtn1: 'Почати прогулянку',
            prepareBtn2: 'Скасувати',
            permissionsInfoText:
                'Ми використовуємо фонове місцезнаходження та GPS для відстеження вашого переміщення, натисніть продовжити, щоб надати дозвіл',
            permissionsInfoBtn1: 'Продовжити',
            permissionsInfoBtn2: 'Скасувати',
            leaveWithOutFinish: 'Ви хочете вийти?',
            leaveWithOutFinishText:
                'Ваш прогрес втратиться але ви зможете вернутись до завдання ще раз пізніше',
            leaveWithOutFinishBtn1: 'Вийти',
            leaveWithOutFinishBtn2: 'Назад',
        },
        notSupported: {
            title: 'Геолокація Не Доступна',
            text: 'Ваш пристрій не підтримує геолокацію, ви не зможете виконати завдання',
            button: 'Зрозуміло',
        },
        locationProblem: {
            title: 'Проблема с геолокацією',
            text: 'Модуль геолокаціі перестав працювати, одною із причин може бути відключення прав доступу. Попробуйте ще раз надати права і розпочати завдання заново.',
            button: 'Окей',
        },
        progress: {
            paused: 'Призупинено',
            walking: 'Ходьба',
            stopped: 'Зупинено',
            tooFast: 'Занадто швидко',
            title: 'Прогулянка з улюбленцем',
            timeLeft: 'Час до кінця прогулянки',
            tooFastMessage:
                'Ваша швидкість не може перевищувати 20 км/год. Прогрес відновиться, коли швидкість знизиться',
            walkStoppedMessage:
                'Здається, ви зупинили вашу прогулянку. Ваш прогрес відновиться, як тільки ви продовжите',
        },
        summary: {
            title: 'Статистика ходьби',
            youEarned: 'Ви заробили',
            energy: 'Енергія',
            subtitle:
                'Вітаю! Ви знайшли всіх домашніх тварин. Приходьте завтра за новими',
            distance: 'Відстань',
            steps: 'Кроки',
            averageSpeed: 'Середня швидкість',
            viewMoreTasks: 'Переглянути більше завдань',
            finishPlaying: 'Закінчити гру',
        },
        startWalking: 'Почніть ходити',
        skip: 'Натисніть, щоб пропустити',
        km: 'км',
        kmH: 'км/год',
    },
    playToEarn: {
        welcomeSlides: {
            energy: 'Відновлюйте свою енергію',
            energyText:
                'Збирайте фрукти, перестрибуйте через перешкоди та відновлюйте свій щоденний рівень енергії. Будьте уважні! У вас є лише одна спроба на день',
            energyAgainText:
                'Покращуйте свої навички у грі, щоб заробляти більше нагород. Завдання доступне лише один раз на добу, проте грати в гру можна в будь-який час',
            energyTotal: ' Енергії',
            energyAgainTotal: 'Пісочниця',
            avoid: 'Подолайте перешкоди',
            avoidText:
                'Ваша основна мета - перестрибувати через перешкоди та заробляти очки. Будьте уважні!',
            food: 'Збирайте їжу',
            foodText:
                'Зібрана їжа дає додаткові очки. Після того, як ви досягнете достатньої кількості очок, гра закінчиться і ваш запас енергії буде негайно відновлено',
        },
        modals: {
            prepareToPlay: {
                title: 'Приготуйтеся до гри',
                text: 'У першій грі ви будете грати на відновлення енергії. Якщо ви не зможете зібрати всю енергію, ви зможете продовжити гру, але без енергетичного прогресу',
                accept: 'Розпочати гру',
                cancel: 'Скасувати',
            },
            playAgain: {
                title: 'Приготуйтеся до гри',
                text: 'Сьогодні ви вже зібрали енергію в цій грі. Тепер ви можете просто грати, щоб покращити навички',
                accept: 'Розпочати гру',
                cancel: 'Скасувати',
            },
            loading: { text: 'Підготовка до гри..' },
            gameTimer: {
                text: 'Торкніться, щоб перестрибнути через перешкоди. Заробляйте очки і збирайте фрукти',
                textWebDesktop:
                    'Нажимайте пробіл, або лівий клік мишкою щоб перестрибнути через перешкоди. Заробляйте очки і збирайте фрукти',
                textWebMobile:
                    'Торкніться, щоб перестрибнути через перешкоди. Заробляйте очки і збирайте фрукти',
            },
            pause: {
                title: 'Ви хочете піти?',
                text: 'Ваш поточний прогрес буде конвертовано в енергію, але ви не зможете грати більше цього дня',
                accept: 'Так, вийти',
                cancel: 'Ні, продовжуйте',
            },
            win: {
                title: 'Завдання виконано',
                text: 'Вітаю вас! Ви успішно виконали своє щоденне завдання. Ви можете продовжувати грати в своє задоволення, але це не вплине на ваш рівень Енергії',
                accept: 'Фініш',
                cancel: 'Грати більше',
            },
            loose: {
                title: 'Гра завершена',
                text: 'Вам не вдалось виконати ваше щоденне завдання. Ви можете продовжувати грати для задоволення, однак це не вплине на ваш рівень Енергії',
                accept: 'Завершити',
                cancel: 'Продовжити гру',
            },
            score: 'Зібрані очки',
            energy: 'Відновлена енергія',
            savedLives: 'Життя',
            fruitCollected: 'Зібрані фрукти',
        },
        summary: {
            title: 'Статистика ігор',
            score: 'Ваш рахунок',
            lives: 'Життя',
            fruitCollected: 'Зібрані фрукти',
        },
        startPlaying: 'Розпочати гру',
        loadingStatuses: {
            downloading: 'Завантаження контенту',
            preparing: 'Підготовка текстур',
            loadingGraphics: 'Завантаження графіки',
            spawning: "Створення ігрових об'єктів",
            loading: 'Завантаження (не закривайте програму)',
        },
    },
    editNFTsScreen: {
        title: 'Виберіть улюбленців гравців',
        dragText:
            'Домашні улюбленці, які будуть брати участь в іграх. Перетягніть, щоб змінити порядок',
        selectList: 'Виберіть домашніх тварин зі списку',
        warningMessage:
            'Перший за порядком улюбленець буде відображатись в Pet ID, а також ідентифікувати ваш обліковий запис',
        cooldownMessage:
            'Ваш NFT перебуває в режимі Cooldown і не може брати участь у грі. Зачекайте, поки закінчиться режим Cooldown',
        button: 'Зберегти',
        errors: {
            saveChanges: {
                title: 'Незбережені зміни',
                text: 'У вас є незбережені зміни, ви впевнені, що хочете піти?',
                button1: 'Вийти',
                button2: 'Повернутись',
            },
        },
        loading: 'Збереження змін..',
        success: 'Порядок NFT збережено!',
    },
    statuses: {
        COMPLETED: { title: 'Завершено' },
        AWAITS_VERIFICATION: { title: 'В очікуванні на перевірку' },
        MODERATOR_VERIFICATION_REQUIRED: { title: 'В очікуванні на перевірку' },
        FAILED: { title: 'Не вдалося' },
    },
    profile: {
        title: 'Налаштування',
        logOut: 'Вийти з системи',
        deleteAccount: 'Видалити обліковий запис',
        logOutModal: {
            title: 'Хочете вийти?',
            description:
                'Вам потрібно буде увійти знову або зареєструвати новий обліковий запис, щоб користуватися додатком IguVerse',
            okText: 'Так, вийти з системи',
            cancelText: 'Скасувати',
        },
        deleteAccountModal: {
            title: 'Видалити обліковий запис?',
            description:
                'Ви можете назавжди видалити свій обліковий запис, але майте на увазі, що ви більше не зможете увійти в нього та користуватися ним',
            okText: 'Видалити обліковий запис',
            inputLabel: 'Підтверджувальна фраза',
            placeholder: 'Введіть фразу підтвердження',
            preConfirmationPhrase: 'Впишіть',
            afterConfirmationPhrase: ' для підтвердження дії',
            success: 'Ваш обліковий запис успішно видалено',
            loading: 'Видалення облікового запису..',
        },
        lightTheme: 'Світла',
        darkTheme: 'Темна',
        menuItems: {
            admin: {
                title: 'Верифікація користувачів',
                description: 'Верифікація користувачів соціальних мереж',
            },
            security: {
                title: 'Безпека',
                description: 'Налаштуйте параметри безпечності',
            },
            socialAccounts: {
                title: 'Соціальні мережі',
                description:
                    'Підключіть свої соціальні мережі, щоб брати участь в соціальних завданнях',
            },
            assignRole: {
                title: 'Призначити роль',
                description: 'Виберіть та призначте користувачеві роль',
            },
            language: {
                title: 'Мова',
                description: 'Встановити мову відображення',
            },
            theme: { title: 'Тема', description: 'Оберіть тему' },
            notifications: {
                title: 'Сповіщення',
                description:
                    'Виберіть типи сповіщень, які ви хочете отримувати від додатку',
            },
            support: {
                title: 'Підтримка',
                description: 'Наш спеціаліст відповість вам в чаті',
            },
            supportEmail: {
                title: 'Відправити емейл',
                description:
                    "Відправте емейл і наш спеціаліст зв'яжеться з вами",
            },
            knowledgeBase: {
                title: 'База знань',
                description:
                    'Перегляньте іншу корисну інформацію про додаток IguVerse, щоб дізнатися більше',
            },
            privacyPolicy: {
                title: 'Політика конфіденційності',
                description:
                    'Дізнайтеся більше про нашу Політику конфіденційності',
            },
            termsOfUse: {
                title: 'Загальні положення та умови',
                description: 'Дізнайтеся більше про наші Умови використання',
            },
            appVersion: {
                title: 'Версія програми',
                description: 'Найновіша {{version}}',
            },
            webVersion: {
                title: 'Веб Додаток',
                description: 'Ввійти в додаток в веб версії',
            },
            accessibility: {
                title: 'Доступність',
                description:
                    'Налаштуйте інтерфейс відповідно до своїх уподобань',
            },
            socialMedia: {
                title: 'Наші соцмережі',
                description:
                    'Підпишіться на IguVerse у соціальних мережах, щоб бути в курсі останніх новин',
            },
            adminSendPushNotification: {
                title: 'Надіслати push-сповіщення',
                description:
                    'Створіть одноразове повідомлення, яке відображатиметься для всіх користувачів',
            },
            adminReverification: {
                title: 'Повторна верифікація',
                description:
                    'Як адміністратор, ви можете надіслати соціальний обліковий запис на повторну перевірку',
            },
            adminBlockUser: {
                title: 'Заблокувати користувача',
                description:
                    'Заблокувати обліковий запис користувача, який порушив правила IguVerse',
            },
            adminMaintenanceMode: {
                title: 'Режим обслуговування',
                description:
                    'У разі технічних робіт переведіть додаток в режим обслуговування',
            },
            adminAssignWhiteList: {
                title: 'Надіслати вайтлист',
                description:
                    'Виберіть кількість і ранг NFT, щоб надіслати вайтлист переможцю',
            },
        },

        languageSettings: {
            title: 'Мови',
            subtitle: 'Виберіть мову',
            description:
                'Ви можете вибрати мову для відображення контенту в додатку IguVerse',
            options: {
                pl: {
                    name: 'Польська',
                    change: 'Польску мову',
                },
                en: {
                    name: 'Англійська',
                    change: 'Англійську мову',
                },
                ru: {
                    name: 'Російська',
                    change: 'Російську мову',
                },
                uk: {
                    name: 'Українська',
                    change: 'Українську мову',
                },
                cn: {
                    name: 'Китайська',
                    change: 'Китайську мову',
                },
                id: {
                    name: 'Індонезійська',
                    change: 'Індонезійську мову',
                },
                es: {
                    name: 'Іспанська',
                    change: 'Іспанську мову',
                },
                tr: {
                    name: 'Турецька',
                    change: 'Турецьку мову',
                },
            },
            switchLanguageModal: {
                title: 'Переключитися на {{localeId}}',
                description:
                    'Весь вміст у додатку IguVerse буде переключено на {{localeId}}. Ви можете змінити мову будь-коли',
            },
        },
        notificationsSettings: {
            title: 'Повідомлення',
            pushNotificationTitle: 'Push сповіщення',
            emailNotificationTitle: 'Email сповіщення',
            notifications: {
                pushDailyReminder: 'Щоденне нагадування',
                pushRewardEarned: 'Начислена винагорода',
                pushSocialTaskCompleted: 'Соціальне завдання виконано',
                pushPetLowHealth: "Низький рівень здоров'я",
                pushPetDead: 'Улюбленець помер',
                pushMysteryLikesGame: 'Загадкові лайки',
                emailPetDead: 'Улюбленець помер',
                emailSocialTaskCompleted: 'Соціальне завдання виконано',
            },
            saved: 'Налаштування збережено!',
        },
        socialAccountsSettings: {
            title: 'Соціальні мережі',
            headerTitle: 'Підключити соціальні мережі',
            headerText:
                "Прив'яжіть свій соціальний обліковий запис, щоб мати можливість виконати соціальне завдання. Докладніше про вимоги до облікового запису читайте у базі знань",
            headerInfo: 'Переглянути базу знань',
            alert: 'Після підключення акаунта необхідно виконати соціальне завдання, щоб акаунт пройшов верифікацію',
            modal: {
                title: 'Пройдіть верифікацію',
                text: 'Ви успішно підключили свій акаунт у соціальній мережі. Виконайте соціальне завдання, щоб акаунт був верифікований!',
                button: 'Перейти до завдань',
            },
        },
        roles: {
            PLAYER: 'Гравець',
            ADMIN: 'Адміністратор',
            MODERATOR: 'Модератор',
        },
        support: {
            success: {
                title: 'Повідомлення відправлено!',
                text: "Ми зв'яжемося з вами найближчим часом",
            },
            notSent: { text: 'Повідомлення не відправлено' },
            errorOpen: {
                text: 'Помилка при відкритті програми поштового клієнта',
            },
        },
        accessibilitySettings: {
            title: 'Доступність',
            faceId: 'Face ID / Пароль',
            shake: 'Вікно фідбеку під час трясіння',
            vibration: 'Вібрація при взаємодії',
            saved: 'Налаштування збережено!',
        },
        socialMediaSettings: {
            screenTitle: 'IguVerse Медіа',
            communities: {
                title: 'Офіційні спільноти',
                text: 'Приєднуйтесь до нашої величезної спільноти любителів домашніх тварин, отримуйте відповіді на запитання та спілкуйтесь',
                socials: {
                    discord: 'Discord',
                    telegram: 'Telegram',
                },
            },
            media: {
                title: 'Офіційні сторінки у соцмережах',
                text: 'Підпишіться на наші канали в соціальних мережах, щоб отримувати останні новини та оголошення',
                socials: {
                    twitter: 'Twitter',
                    instagram: 'Instagram',
                    youtube: 'Youtube',
                    tiktok: 'TikTok',
                    website: 'Вебсайт',
                    facebook: 'Facebook',
                },
            },
            telegram: {
                title: 'Telegram Спільноти',
                main: 'Офіційний канал',
                en: 'Англійський чат',
                uk: 'Український чат',
                ru: 'Російський чат',
                cn: 'Китайський чат',
                tr: 'Турецький чат',
                id: 'Індонезійський чат',
                kr: 'Корейський чат',
                jp: 'Японський чат',
                ab: 'Арабський чат',
                in: 'Індійський чат',
                pp: 'Філіппінський чат',
                vt: "В'єтнамський чат",
                bg: 'Бангладешський чат',
                pl: 'Польский чат',
                es: 'Іспанський чат',
                fr: 'Французький чат',
                pt: 'Португальський чат',
            },
        },
        adminSendPushNotification: {
            title: 'Надіслати push-сповіщення',
            text: 'Створіть одноразове повідомлення, яке відображатиметься для всіх користувачів',
            button: 'Надіслати',
            selectLanguage: {
                label: 'Мова',
                placeHolder: 'Виберіть мову повідомлення',
                modalTitle: 'Виберіть мову',
                button: 'Зберегти',
                title: '{{amount}} Обрана мова',
            },
            titleInput: {
                label: 'Назва (менше {{amount}} символів)',
                placeHolder: 'Введіть назву повідомлення',
            },
            bodyInput: {
                label: 'Опис (менше {{amount}} символів)',
                placeHolder: 'Введіть опис повідомлення',
            },
            errors: {
                required: "Це поле обов'язкове для заповнення",
            },
        },
        adminReverification: {
            screenTitle: 'Повторна верифікація',
            title: 'Надіслати на повторну перевірку',
            text: "Виберіть соціальну мережу та введіть ім'я користувача для надсилання облікового запису на перевірку",
            button: 'Відправити',
            labelSocial: 'Соціальна мережа',
            labelInput: 'Посилання на акаунт',
            placeHolder: 'Введіть посилання на акаунт',
            socialMediaModal: {
                title: 'Виберіть соціальну мережу',
            },
            checkModal: {
                title: 'Перевірте деталі профілю',
                text: 'Погляньте на соціальний обліковий запис нижче і перевірте, чи він правильний. Будьте уважні, оскільки цю дію не можна скасувати',
                button1: 'Надіслати на повторну перевірку',
                button2: 'Відмінна',
            },
            toastSuccess: 'Акаунт відправлено на повторну перевірку',
        },
        adminBlockUser: {
            screenTitle: 'Заблокувати користувача',
            title: 'Введіть адресу гаманця',
            text: "Введіть гаманець, прив'язаний до облікового запису, який порушив правила IguVerse",
            button: 'Заблокувати',
            modal: {
                title: 'Заблокувати користувача?',
                text: 'Переконайтеся, що ви заблокуєте потрібного користувача. Ви повинні блокувати користувачів з повною упевненістю у своєму рішенні. Ця дія не може бути скасована!',
                button1: 'Надіслати',
                button2: 'Скасувати',
            },
            toastSuccess: 'Користувач успішно заблоковано',
            toastError: 'Не вдалося знайти користувача',
            banReason: {
                screenTitle: 'Виберіть причину блокування',
                label: 'Причина блокування',
                placeHolder: 'Виберіть причину блокування',
            },
            banComment: {
                label: 'Коментар',
                placeHolder: 'Додайте коментар, якщо необхідно',
            },
            error: {
                banComment: 'Слід додати коментар',
                banReason: 'Будь ласка, оберіть причину блокування',
            },
        },
        adminMaintenanceMode: {
            screenTitle: 'Режим обслуговування',
            on: {
                title: 'Увімкнути режим обслуговування',
                text: 'Ви можете перевести програму в режим обслуговування, і користувачі не зможуть отримати доступ до нього. Щоб зробити його доступним знову, натисніть «Вимкнути режим обслуговування» у налаштуваннях',
                button: 'Увімкнути',
                modal: {
                    title: 'Увімкнути режим обслуговування?',
                    text: 'Користувачі не зможуть отримати доступ до програми, якщо ви активуєте її. Щоб знову зробити програму доступною, натисніть «Вимкнути режим обслуговування» у налаштуваннях',
                    button1: 'Увімкнути',
                    button2: 'Скасувати',
                },
                toastSuccess: 'Режим обслуговування ввімкнено',
            },
            off: {
                title: 'Вимкнути режим обслуговування',
                text: 'Програма знаходиться в режимі обслуговування, і в даний час користувачі не можуть отримати доступ до неї. Вимкніть його, як тільки технічні роботи будуть виконані, натиснувши кнопку нижче. Не забудьте підтвердити!',
                button: 'Вимкнути',
                modal: {
                    title: 'Вимкнути режим обслуговування?',
                    text: 'Переконайтеся, що технічні роботи закінчені, і програма працюватиме правильно. Щоб знову зробити програму доступною, натисніть кнопку нижче',
                    button1: 'Вимкнути',
                    button2: 'Скасувати',
                },
                toastSuccess: 'Режим обслуговування вимкнено',
            },
        },
        adminAssignWhiteList: {
            screenTitle: 'Надіслати Вайтліст',
            button: 'Надіслати',
            title: 'Надіслати Вайтліст',
            text: 'Введіть адресу гаманця користувача та виберіть ранг та кількість NFT',
            rank: {
                label: 'Ранг NFT',
                placeHolder: 'Виберіть ранг',
            },
            quantity: {
                label: 'Кількість',
            },
            modal: {
                screenTitle: 'Виберіть ранг',
                title: 'Надіслати Вайтліст?',
                text: 'Уважно перевірте всі дані: ранг NFT, кількість NFT та адресу гаманця. Ви повинні бути повністю впевнені, підтверджуючи цю дію, оскільки вона не може бути скасована',
                button1: 'Надіслати',
                button2: 'Вiдмiнна',
            },
            toastSuccess: 'Успішне внесення до Вайтлiсту',
            error: {
                quantity: {
                    max: 'Максимальна кількість {{quantity}}',
                    min: 'Мінімальна кількість {{quantity}}',
                    numbers: 'Тільки цифри',
                },
                rank: 'Необхідно вибрати ранг',
            },
            toastError: 'Не вдалося знайти Користувача',
        },
        adminAssignRole: {
            screenTitle: 'Призначити роль',
            button: 'Призначити',
            title: 'Призначити роль',
            text: 'Введіть адресу гаманця користувача та виберіть відповідну роль',

            role: {
                label: 'Роль',
                placeHolder: 'Виберіть роль',
            },
            roleModal: {
                title: 'Виберіть роль',
            },
            attentionModal: {
                title: 'Призначити роль',
                text: 'Уважно перевірте всі дані: адресу гаманця та роль. Переконайтеся, що ви не робите помилку. Ця дія не може бути скасована!',
                button1: 'Призначити',
                button2: 'Скасувати',
            },
            error: {
                role: 'Потрібно вибрати роль',
            },
            success: 'Роль була успішно призначена',
            toastError: 'Не вдалося знайти Користувача',
            toastSuccess: 'Роль була успішно призначена',
        },
        walletInput: {
            label: 'Адреса гаманця',
            placeHolder: 'Введіть адресу гаманця',
        },
        walletInputError: 'Не є адресою гаманця',
    },
    admin: {
        title: 'Адміністратор',
        verify: {
            title: 'Верифікація користувачів',
            subtitle: 'Перевірка соціальних мереж користувача',
            text: 'Відкрийте акаунт у соціальній мережі та надайте Pet ID для успішної верифікації',
            emptyTitle: 'Більше немає завдань',
            emptyText: 'Немає доступних завдань для перевірки, зайдіть пізніше',
            messages: {
                error: 'Неправильний ідентифікатор домашнього улюбленця, спробуйте ще раз',
                success: 'Вітаємо! Користувача верифіковано',
                notFound: 'Користувачеві відмовлено',
                failed: 'Виникла помилка, будь ласка, повідомте про це адміністратору',
            },
            modalPetIdNotFound: {
                title: 'Pet ID вихованця не знайдено?',
                text: 'Будь ласка, уважно розгляньте фотографію і, якщо вам не вдається верифікувати користувача, виберіть одну з таких причин',
                reasons: {
                    notEnoughFollowers: {
                        title: 'Недостатньо підписників',
                        text: 'Ваш обліковий запис недостатньо активний у соціальних мережах, не відкритий і/або має мало підписників',
                    },
                    petIdNotFound: {
                        title: 'Pet ID вихованця не знайдено',
                        text: 'Pet ID вихованця не видно на фотографії, або він не опублікований',
                    },
                    petIdIncorrectPosition: {
                        title: 'Pet ID вихованця має неправильне розташування',
                        text: 'Pet ID вихованця обрізаний або розміщений неправильно, так що неможливо побачити код',
                    },
                    userNotFound: {
                        title: 'Користувач не знайдений',
                        text: "Обліковий запис з публікацією або видалений, або прив'язаний неправильно і не може бути перевірений",
                    },
                },
                button1: 'Так, підтвердити',
            },
            label: 'Ідентифікатор домашнього улюбленця',
            placeHolder: 'Введіть ідентифікатор тварини',
            buttonVerify: 'Перевірте',
            buttonNotFound: 'Ідентифікатор тварини не знайдено',
            loadingVerifyUser: 'Перевіряю.',
            regexError: 'Допускаються тільки цифри та символи від A до Z',
        },
    },
    socialMediaConnect: {
        addSocialAccount: 'Додати соціальний акаунт',
        selectAccountToShare: 'Вибрати обліковий запис',
        select: 'Виберіть',
        connect: 'Підключіться',
        disconnect: "Від'єднати",
        unavailable: 'В даний момент недоступно',
        status: {
            moderating:
                'Ваш обліковий запис додано та буде перевірено, як тільки ви опублікуєте свій Pet ID для виконання соціального завдання!',
            success:
                'Аккаунт успішно перевірено нашими модераторами. Тепер ви можете використовувати його для виконання завдання Socialize to Earn',
            reject: 'Ваш обліковий запис не був схвалений модераторами. Будь ласка, підключіть обліковий запис, який відповідає нашим правилам',
        },
        modalTerms: {
            start: 'Підключаючи соціальний аккаунт, я погоджуюсь з ',
            and: ' та ',
            privacyPolicy: 'Політикою конфіденційності',
            termOfUse: 'Умовами користування',
        },
        connectTiktokModal: {
            title: 'Підключити обліковий запис TikTok',
            label: "Ім'я користувача",
            placeHolder: "Введіть ім'я користувача в TikTok",
            button: 'Підключіться',
            errors: {
                notExist:
                    "Цей обліковий запис не існує. Будь ласка, введіть дійсне ім'я користувача TikTok",
                somethingWrong:
                    'Щось пішло не так, будь ласка, спробуйте ще раз',
                likeFollowers:
                    'Недостатньо активності на рахунку. Можна підключити тільки реальний рахунок',
                cannotLoad:
                    'Не вдається завантажити обліковий запис користувача. Будь ласка, спробуйте ще раз',
                alreadyLinked:
                    "Надане ім'я користувача вже використовується іншим користувачем",
                notLinked: "Рахунок вже від'єднано",
            },
        },
        socialPreview: {
            checkProfile: 'Перевірте свій профіль',
            takeALook: `Погляньте на обліковий запис нижче і перевірте, чи належить він вам`,
            view: 'Перейти',
        },
        connectInstagramModal: {
            title: 'Підключити обліковий запис Instagram',
            label: "Ім'я користувача",
            addAccount: 'Це я, Додати обліковий запис',
            cancel: 'Це не я, Скасувати',
            placeHolder: 'Введіть імя користувача в Instagram',
            button: 'Підключіться',
            errors: {
                somethingWrong:
                    'Щось пішло не так, будь ласка, спробуйте ще раз',
                alreadyLinked:
                    "Надане ім'я користувача вже використовується іншим користувачем",
            },
            viaInstagram: 'або Увійти за допомогою Instagram',
        },
        connectTwitterModal: {
            title: 'Підключити обліковий запис Twitter',
            label: "Ім'я користувача",
            placeHolder: "Введіть ім'я користувача в Twitter",
            button: 'Підключіться',
            errors: {
                notExist:
                    "Цей обліковий запис не існує. Будь ласка, введіть дійсне ім'я користувача Twitter",
                somethingWrong:
                    'Щось пішло не так, будь ласка, спробуйте ще раз',

                alreadyLinked:
                    "Надане ім'я користувача вже використовується іншим користувачем",
            },
        },
        connectFacebookModal: {
            title: 'Підключити обліковий запис Facebook',
            label: "Ім'я користувача",
            placeHolder: "Введіть ім'я користувача в Facebook",
            button: 'Підключіться',
            errors: {
                notExist:
                    "Цей обліковий запис не існує. Будь ласка, введіть дійсне ім'я користувача Facebook",
                somethingWrong:
                    'Щось пішло не так, будь ласка, спробуйте ще раз',

                alreadyLinked:
                    "Надане ім'я користувача вже використовується іншим користувачем",
            },
            via: 'або Увійти за допомогою Facebook',
        },
        terms: {
            instagram: {
                one: 'Публічний профіль',
                two: 'Активний акаунт з мінімум 100 підписниками',
                three: 'Щонайменше 5 постів старше 3 місяців',
            },
            tikTok: {
                one: 'Щонайменше 500 підписників',
                two: 'Активний акаунт з мінімум 5 відеороликами старше 3 місяців',
                three: 'Не менше 500 лайків на акаунті',
            },
            twitter: {
                one: 'Публічний профіль',
                two: 'Активний акаунт з мінімум 500 підписниками',
                three: 'Щонайменше 5 постів старше 3 місяців',
            },
            facebook: {
                one: 'Публічний профіль',
                two: 'Активний акаунт з мінімум 100 друзями',
                three: 'Щонайменше 5 постів старше 3 місяців',
                four: 'Історії мають бути публічними',
            },
        },
        errors: {
            duplicate: {
                title: 'Ваш {{social}} вже підключений до іншого облікового запису',
                text: "Ваш профіль у соціальній мережі пов'язаний з іншим обліковим записом. Спочатку відключіть його і спробуйте ще раз",
                button: 'Закрити',
            },
            disconnect: {
                title: "Відв'язати акаунт?",
                text: 'Ви зможете використовувати свій новий акаунт для виконання соціального завдання, як тільки розпочнеться новий ігровий день',
                button1: "Так, роз'єднати",
                button2: 'Ні, залишити',
            },
            userNameError:
                'Можна використовувати лише літери, цифри, нижнє підкреслення та точки',
        },
        success: {
            linkInstagram: 'Instagram успішно підключено',
            unLinkInstagram: 'Instagram відключено',
            linkTiktok: 'TikTok успішно підключено',
            unLinkTiktok: 'TikTok відключено',
            linkTwitter: 'Twitter успішно підключено',
            unLinkTwitter: 'Twitter відключено',
            linkFacebook: 'Facebook успішно підключено',
            unLinkFacebook: 'Facebook відключено',
        },
    },
    playTasksHistory: {
        title: 'Історія завдань',
        info: 'Тут ви можете переглянути історію ваших завдань та ваш прогрес',
        historyCard: {
            SocialTask: 'Соціальне завдання',
            VerificationTask: 'Пошукове завдання',
            MoveTask: 'Прогулянка',
            PlayTask: 'Ігрове завдання',
        },
        emptyState: {
            title: 'Завдань поки що немає',
            text: 'Ви ще не виконали жодного щоденного завдання. Але це не проблема, давайте зробимо це прямо зараз',
            button: 'Розпочати гру',
        },
        historyTaskDetails: {
            title: 'Деталі завдання',
            text: 'Зібрана енергія буде конвертована в токени винагороди у вашому гаманці винагород. Детальніше про завдання читайте нижче',
            collectedEnergy: '{{earnedEnergy}} / {{maxEnergy}} Зібрана енергія',
            viewRewardWaller: 'Переглянути в гаманці винагород',
            details: {
                type: 'Тип:',
                type_SocialTask: 'Соціальне завдання',
                type_VerificationTask: 'Знайти завдання',
                type_MoveTask: 'Завдання на ходьбу',
                type_PlayTask: 'Ігрове завдання',
                petExp: 'Зароблений досвід:',
                exp: '{{exp}} XP',
                date: 'Дата:',
            },
        },
    },
    successTaskEnergyBlock: {
        text: 'Енергія',
        collectedEnergy: '{{earnedEnergy}} / {{maxEnergy}} Зібрана енергія',
    },
    successTaskPetsExp: {
        text: 'Зібраний досвід (XP)',
        collectedExp: '{{collectedExp}} XP',
    },
    checkout: {
        title: 'Підтвердити транзакцію',
        text: 'Перевірте інформацію та підтвердіть транзакцію',
        confirm: 'Підтвердити та придбати',
        try: 'Спробуйте ще раз',
        cancel: 'Скасувати',
        purchasingFrom: 'Спосіб оплати',
        available: 'Баланс',
        deposit: 'Депозит',
        wallet: '{{coin}} Гаманець',
        loadingPurchasing:
            'Завершується транзакція, будь ласка, не закривайте додаток..',
        free: 'Безкоштовно',
        whiteList: 'Білий список (1)',
        explorerUrl: 'Переглянути на BscScan',
        fields: {
            transaction: 'Транзакція',
            value: 'Значення',
            amount: 'Сума',
            totalSummary: 'Підсумок',
            from: 'Спосіб оплати',
            to: 'На гаманець',
            fee: 'Оплата за газ',
            modalTitle: 'Підтвердити транзакцію',
            toWallet: 'На (гаманець)',
            gamingWallet: 'Ігровий гаманець',
            mainWallet: 'Головний гаманець',
            confirm: 'Підтвердити',
            commissionFee: 'Комісія',
            nft: 'NFT',
            nftWallet: 'NFT Гаманець',
            nftMarketplace: 'NFT Маркетплейс',
        },
        errors: {
            notEnoughCoinFunds: 'Недостатньо коштів. Внесіть кошти на гаманець',
            notEnoughCoinFundsMulti:
                'Недостатньо коштів. Оберіть інший варіант оплати або внесіть кошти на гаманець',
            bnbNotEnough:
                'На Вашому балансі недостатньо BNB для оплати за газ. Будь ласка, поповніть баланс BNB',
            notEnoughBalanceFunds: 'Недостатньо коштів',
            notEnoughBalanceFundsMulti:
                'Недостатньо коштів. Оберіть інший варіант оплати',
            insufficientVirtualBalance:
                'Недостатньо коштів на віртуальному балансі',
        },
        purchasingFromCoins: {
            coins: 'Токени',
            virtual: 'Електронний гаманець',
            inapp: {
                ios: 'Apple',
                android: 'Google Pay',
            },
        },
        storePurchase: {
            loadings: {
                PURCHASE:
                    'Платіж обробляється, будь ласка, не закривайте програму..',
                FINALIZE:
                    'Транзакція обробляється, будь ласка, не закривайте програму..',
            },
            button: 'Добре',
            storePurchaseError: {
                PURCHASE: {
                    title: 'Щось пішло не так',
                    message:
                        'Щось сталося не так під час обробки платежу. Будь ласка, повторіть спробу\nКод помилки: {{code}}',
                },
                FINALIZE: {
                    title: 'Щось пішло не так',
                    message:
                        'Щось сталося не так під час обробки транзакції. Будь ласка, повторіть спробу',
                },
            },
        },
    },
    charity: {
        title: 'Благодійність',
        description:
            'Користувачі IguVerse сплачують пожертви зі свого щоденного доходу на користь однієї з попередньо обраних благодійних організацій',
        current: 'Мій вибір',
        dailyDonation: 'Щоденні пожертви від ваших винагород',
        howItWorks: 'Як це працює?',
        selectedOrganization: 'Обрана організація',
        edit: 'Редагувати',
        organizations: 'Організації',
        viewAll: 'Переглянути всі',
        donated: 'пожертвовано',
        buttonSave: 'Зберегти',
        loadingPercentage: 'Обробка..',
        saveSuccess: 'Змінено відсоток щоденних пожертвувань',
        organizationsTitle: 'Всі організації',
        infoRows: {
            address: 'Адреса',
            website: 'Веб-сайт',
            email: 'Е-мейл',
            instagram: 'Instagram',
            twitter: 'Twitter',
        },
        readMore: 'Читати далі',
        hide: 'Приховати',
        donations: 'Пожертви',
        totalSummary: 'Загальний підсумок',
        time: {
            minuteAgo: 'хвилину тому',
            minutesAgo: 'кілька хвилин тому',
            hourAgo: 'годину тому',
            hoursAgo: 'кілька годин тому',
            dayAgo: 'день тому',
            daysAgo: 'кілька днів тому',
        },
        payout: 'Благодійна виплата',
        noDonations: 'Нема пожертв',
        allDonations: 'Всі пожертви',
        modals: {
            confirmPercentage: {
                title: 'Підтвердіть свою дію',
                text: 'Відсоток пожертвувань буде впливати на Ваш заробіток і перераховувати його безпосередньо благодійній організації, Ви впевнені, що хочете змінити свій відсоток пожертвувань?',
            },
        },
        editOrganization: 'Редагувати організацію',
        editOrganizationNotChosen:
            'Вам необхідно обрати мінімум одну організацію для пожертвування',
        loadingOrganizationChange: 'Обробка..',
        changeOrganizationSuccess: 'Врятовано благодійну організацію',
        organizationDetails: 'Інформація про організацію',
        selectDescription: 'Виберіть організацію зі списку нижче',
        chooseOrganization: 'Оберіть організацію',
    },
    Marketplace: {
        title: 'Маркетплейс',
        text: 'Купити або продати домашніх тварин можна тут',
        description: 'Незабаром буде',
    },
    Feed: {
        title: 'Стіна',
        text: 'Ви можете дивитись інших улюбленців тут та взаємодіяти з ними',
        description: 'Незабаром буде',
    },
    Leaderboard: {
        [ROUTES.LEADERBOARD_DAILY_TASKS]: {
            title: 'Лідери по завданням',
            text: 'Слідкуйте за прогресом інших користувачів та змагайтеся з ними, виконуючи щоденні завдання',
            emptyList: {
                title: 'Ще немає користувачів у таблиці лідерів',
                text: 'На жаль, поки що жоден користувач не виконав жодного завдання. Але не хвилюйтеся, це буде швидко виправлено',
            },
            energy: 'Зібрана енергія',
            task: 'Виконані завдання',
        },
        [ROUTES.LEADERBOARD_PVP_GAMES]: {
            title: 'Лідери по ПВП',
            text: 'Слідкуйте за успіхами інших користувачів і змагайтесь, виграючи PvP-ігри',
            emptyList: {
                title: 'Ще немає користувачів у таблиці лідерів',
                text: 'На жаль, поки що жоден користувач не зiграв в жодну ігру. Але не хвилюйтеся, це буде швидко виправлено',
            },
            turnover: 'Обіг IGU',
            totalTurnover: 'Загальний Обіг IGU',
            pnl: 'PNL (перемоги/поразки)',
            games: 'Всього зіграно',
        },
        emptyScreen: {
            title: 'Упс!',
            text: 'Щось не так. Але не хвилюйся, ми це швидко виправимо. Спробуй потягнути.',
        },
    },

    playCollectedExperience: {
        screenTitle: 'Накопичений досвід',
        title: 'Досвід роботи з домашніми тваринами',
        text: 'Після виконання завдання ваші улюбленці збирають нові XP для просування по рівню',
    },
    playSuccessScreen: {
        button: 'Переглянути більше завдань',
        button2: 'Повернутися на головну',
        emptyStates: {
            VERIFY: {
                title: 'Знайти виконане завдання',
                text: 'Вітаємо! Ви виконали пошукове завдання на сьогодні. Приходьте завтра за новими',
                failTitle: 'Нажаль завдання провалене',
                failText:
                    'Ви не змогли виконати пошукове завдання на сьогодні. Приходьте завтра за новими',
            },
            MOVE: {
                title: 'Прогулянка виконана',
                text: 'Вітаємо вас! Ви виконали сьогоднішню ціль для прогулянки. Приходьте завтра ще раз',
                failTitle: 'Прогулянка не вдалась',
                failText:
                    'Ви не виконали завдання як належно. Приходьте завтра і спробуйте ще раз',
            },
            SOCIAL: {
                title: 'Соціальне завдання виконано',
                text: 'Вітаємо! Ви поділилися фотографією улюбленця і вона пройшла перевірку. Приходьте завтра ще раз',
            },
            PLAY: {
                title: 'Гру завершено',
                text: 'Вітаємо! Ви завершили гру на сьогодні. Приходьте ще раз завтра',
                failTitle: 'Нам прикро, але ви програли',
                failText:
                    'На жаль, Вам не вдалось пройти гру. Спробуйте краще наступного разу',
            },
        },
    },
    general: {
        howItWorks: 'Як це працює',
        comingSoon: 'Незабаром',
        comingSoonDesc: 'Ця функція ще не готова.',
        copiedToClipboard: 'Скопійовано в буфер обміну',
        createPet: 'Створіть домашнього улюбленця',
        next: 'Далі',
        or: 'або',
        ok: 'Гаразд',
        loading: 'Завантаження..',
        loadMore: 'Завантажити ще',
        errors: {
            unknown: {
                title: 'Невідома помилка',
                message: 'Будь ласка, спробуйте ще раз',
            },
            error: { title: 'Помилка' },
            networkRequestFailed: {
                title: 'Помилка мережі',
                message: "Не вдалося з'єднатися з мережею. Спробуйте ще раз",
            },
            TASK_WRONG_STATE: {
                title: 'Помилка',
                message: 'Термін дії завдання закінчився, спробуйте ще раз',
            },
            TASK_CREATE_FORBIDDEN: {
                title: 'Помилка',
                message: 'Термін дії завдання закінчився, спробуйте ще раз',
            },
            UNPREDICTABLE_GAS_LIMIT: {
                title: 'Проблеми з гаманцями',
                message:
                    'Неможливо оцінити вартість газу, транзакція не пройде. Переконайтеся, що у вас достатньо коштів та BNB для покриття плати за газ, а потім спробуйте ще раз',
            },
            INSUFFICIENT_FUNDS: {
                title: 'Не вистачає коштів',
                message:
                    'Переконайтеся, що у вас достатньо коштів і BNB для покриття комісії за транзакцію. Внесіть криптовалюту на гаманець і спробуйте ще раз',
            },
            fileIsTooBig: {
                title: 'Файл занадто великий',
                text: 'Розмір файлу зображення не повинен перевищувати {{size}} МБ',
            },
            cantOpenUrl: {
                text: 'Ваш пристрій не може відкрити URL-адресу {{url}}. Скопіюйте URL і перейдіть вручну',
            },
            gameAlreadyStarted: {
                text1: 'Гра вже почалася',
                text2: 'Будь ласка, виберіть іншу гру',
            },
            gameBanned: {
                text1: 'Вас заблоковано в цій грі',
                text2: 'Чекайте подальших повідомлень',
            },
            wrongGameStatus: {
                text: 'Неправильний статус гри',
            },
            emptyErrorScreen: {
                title: 'Упс!',
                text: 'Щось не так. Але не хвилюйся, ми це швидко виправимо',
            },
            ops: {
                text1: 'Ой!',
                text2: 'Щось пішло не так :(',
            },
        },
        success: { title: 'Успіх' },
        socialLoading: 'В процесі підключення..',
        cancel: 'Скасувати',
        back: 'Назад',
        current: 'Поточний',
        knowledgeBaseButton: 'Дізнатися більше в базі знань',
        timerTitle: 'Залишилося часу',
        hint: '{{hint}}/{{maxHints}} Підказки',
        continue: 'Продовжити',
        skip: 'Пропустити',
        BUTTONS: {
            mintNewNft: 'Мінт нової NFT',
            continue: 'Продовжити',
            continueLater: 'Продовжити пізніше',
            mintNft: 'Мінт NFT',
            select: 'Вибрати',
            startPlaying: 'Почати грати',
            start: 'Почати',
            learnMore: 'Дізнатися більше',
            playPvpGames: 'Грати в PVP - ігри',
            goToWallet: 'Перейти в Гаманець',
            createNewOrder: 'Створити новий ордер',
            apply: 'Застосувати',
            clear: 'Очистити',
            viewProfile: 'Переглянути профіль',
            buyForWithAmount: 'Купити за {{amount}}',
            cancel: 'Скасувати',
            delistNft: 'Видалити ордер',
            delist: 'Видалити',
            viewMarketplace: 'Переглянути маркетплейс',
            getStarted: 'Почати',
            reloadApp: 'Перезавантажити додаток',
            createNewGame: 'Створити нову гру',
            exploreMoreGames: 'Дослідити більше ігор',
            viewGamesHistory: 'Переглянути історію ігор',
            viewStatistics: 'Переглянути статистику',
            tryAgain: 'Спробуйте ще раз',
            createGame: 'Створити гру',
            topUpBalance: 'Поповнити баланс',
            continueToNextStep: 'Перейти до наступного кроку',
            continueShopping: 'Купити ще',
            enableNow: 'Увімкнути зараз',
            maybeLater: 'Можливо пізніше',
            backToSettings: 'Повернутися до налаштувань',
            turnOff: 'Вимкнути',
            purchaseFor: 'Покупка за {{amount}}',
            purchase: 'Купити',
            viewAll: 'Переглянути всі',
            view: 'Переглянути',
            purchaseMore: 'Придбати більше',
            viewDetails: 'Переглянути деталі',
            readMore: 'Читати далі',
            hide: 'Приховати',
            viewChart: 'Відкрити графік',
        },
        KEYS: {
            ranks: 'Ранги',
            price: 'Ціна',
            chance: 'Шанс',
            rank: 'Ранг',
            sortedBy: 'Відсортувати по',
            typeOfNft: 'Тип NFT',
            totalSummary: 'Загальний підсумок',
            totalSuccessfulOrders: 'Всього успішних ордерiв',
            totalPurchasesSummary: 'Загальна сума торгiв',
            NFTs: 'NFTs',
            profile: 'Профіль',
            details: 'Деталі',
            numberAndLevel: '{{level}} Рівень',
            numberAndHealth: "{{health}} Здоров'я",
            deadByAge: 'Вихованець був старим і помер',
            numberAndDaysAge: '{{days}} Вік у днях',
            yourNFT: 'Ваш NFT',
            vs: 'VS',
            opponentsNFT: 'NFT опонента',
            yourPoints: 'Ваші очки',
            opponentsPoints: 'Очки противника',
            type: 'Тип',
            gameSettings: 'Налаштування гри',
            difficulty: 'Складність',
            mode: 'Режим',
            livesCount: 'Кількість життів',
            yourAccount: 'Ваш обліковий запис',
            leaderboardPlace: 'Місце в лідерборді',
            timeLeft: 'Залишилося часу',
            ticketsAmount: 'Кількість квитків',
            tickets: 'Квитки',
            winner: 'Переможець',
            prizes: 'Призи',
            won: 'Вигран',
            hash: 'Хеш',
            date: 'Дата',
            roundId: 'ID Раунду',
            chainResults: 'Результати',
            globalSeed: 'Глобальне значення',
            gamesHistory: 'Історія ігор',
            users: 'Користувачі',
        },
        FILTERS: {
            byDate: {
                Day: 'Сьогодні',
                Week: 'Останні 7 днів',
                Month: 'Останні 30 днів',
            },
        },
        ALERTS: {
            notEnoughCoinsOnGamingWallet:
                'Недостатньо токенів на ігровому гаманці, щоб приєднатися до гри. Поповніть рахунок, щоб почати грати',
        },
        MERGED: {
            selectText: 'Оберіть {{text}}',
        },
        DECLINATION: {
            Ticket: {
                one: 'Білет',
                two: 'Білети',
                five: 'Білетів',
            },
        },
    },
    modal: {
        mintPetLeave: {
            title: 'Ви хочете піти?',
            text: 'Ви майже закінчили створення свого улюбленця. Не здавайтеся зараз!',
            keep: 'Продовжити створення',
            leave: 'Вийти',
        },
        ModalFreeRank: {
            title: 'Ви пропускаєте можливість отримати величезний бонус',
            text: 'Ви дійсно відмовляєтесь від бонусу в розмірі {{amount}} IGUP токенів (${{dollarValue}}) за створення улюбленця найвищого рангу?',
            highest: 'Створити та отримати бонус',
            proceed: 'Продовжити без бонусу',
        },
        askForPermissions: 'Запитайте дозволу',
        goToSettings: 'Перейти до налаштувань',
        try: 'Спробуйте ще раз',
        cancel: 'Скасувати',
        deletePhoto: 'Видалити NFT Photo?',
        deletePhotoInfo: 'Ви впевнені, що хочете видалити своє фото?',
        yesDelete: 'Так, видалити',
        noCancel: 'Ні, скасувати',
        changeRank: 'Хочете змінити ранг?',
        changeRankInfo:
            'Ви будете перенаправлені на перший крок процесу створення мінту',
        changeRankGo: 'Змінити ранг',
        upgradeRank: {
            title: 'Підвищення до рангу "{{slug}}"',
            text: 'Деякі функції розблоковуються з підвищенням рангу. Підвищіть свій ранг, щоб отримати доступ до цієї функції',
            upgradeToRank: 'Підвищення рангу',
        },
        savingName:
            'Збереження імені займає деякий час. Будь ласка, не закривайте додаток',
        generatingNFT:
            'Запит обробляється. Зазвичай це займає до декількох хвилин..',
        generateNewNFT: {
            title: 'Повернутися до попереднього кроку?',
            text: 'Ви будете повернуті назад і втратите поточний прогрес. Ваш улюблениць унікальний, ми не зможемо створити точно такого ж',
            yesGenerate: 'Так, повернутися назад',
            noKeep: 'Ні, залишитись тут',
        },
        askForCameraPermissions: {
            title: 'Немає дозволу на камеру',
            text: 'Для використання цієї функції необхідно надати дозволи для камери',
        },
        askForLocationPermissions: {
            title: 'Немає дозволу на геолокацію',
            text: 'Для використання цієї функції необхідно надати дозвіл на використання геолокації',
        },
        askForCameraRollPermissions: {
            title: 'Немає доступу до галереї',
            text: 'Для використання цієї функції необхідно надати дозвіл на запис до галереї',
        },
        askForLocationPermissionsWeb: {
            title: 'Немає дозволу на геолокацію',
            text: 'Для використання цієї функції необхідно надати дозвіл на використання геолокації',
            additionalText:
                '. Перейдіть до налаштувань і ввімкніть дозволи геолокації',
            button: 'Закрити',
        },
        nftPreview: {
            title: 'Попередній перегляд NFT',
            text: 'Це попередній перегляд вашого улюбленця',
        },
        confirmation: {
            title: 'Ви впевнені?',
            text: 'Будь ласка, підтвердіть свою дію для продовження',
            yes: 'Так, підтверджую',
            cancel: 'Скасувати',
        },
        modalChangeLanguage: {
            screenTitle: 'Змінити мову',
            button: 'Змінити',
        },
    },
    navigationBar: {
        wallet: {
            MAIN: 'Головний',
            NFT: 'NFT',
            REWARDS: 'Нагороди',
            GAMING: 'Ігровий',
        },
        tasks: { active: 'Завдання', history: 'Історія' },
        admin: { verify: 'Перевірка', dashboard: 'Особистий Кабінет' },
        referrals: { invites: 'Запрошення', all: 'Мої реферали' },
        collections: { collection: 'Колекція', mystery: 'Загадкові Коробки' },
        tooltip:
            'Це вкладка гаманця. Перейдіть сюди, щоб побачити свій баланс та винагороди. На вкладці ви можете знімати, вносити, вимагати та обмінювати токени',
    },
    AppState: {
        GameMaintenanceState: {
            title: 'Обслуговування гри',
            text: 'IguVerse ігровий двигун знаходиться на технічному обслуговуванні і наразі недоступний. Вибачте за незручності та повертайтесь найближчим часом',
            button: 'Зрозуміло',
        },
        FullMaintenanceState: {
            title: 'Повне технічне обслуговування',
            text: 'Додаток IguVerse знаходиться на технічному обслуговуванні і наразі недоступний. Вибачте за тимчасові незручності та повертайтесь найближчим часом',
        },
        GlobalErrorState: {
            title: 'Позапланове технічне обслуговування',
            text: 'Додаток IguVerse знаходиться в стадії активної розробки і наразі ми проводимо позапланові технічні роботи. Вибачте за тимчасові незручності та завітайте до нас якнайшвидше',
            button: 'Повторити спробу',
        },
        UpdateRequiredState: {
            title: 'Вийшла Нова Версія Додатку',
            text: 'Ця версія додатку більше не підтримується, будь ласка, оновіть додаток з {{store}} Store, щоб продовжити його використання',
            button: 'Оновити',
            cancel: 'Не зараз',
            error: 'Не вдається відкрити посилання, відкрийте {{store}} вручну та завантажте найновішу версію',
        },
        UpdateRequiredStateWeb: {
            title: 'В Процесі Оновлення',
            text: 'Додаток знаходиться в процесі оновлення, будь ласка, повторіть спробу через декілька хвилин',
            button: 'Спробуйте ще раз',
        },
        NoNetworkConnectionState: {
            title: "Немає зв'язку",
            text: 'Схоже, у вас проблеми з підключенням до Інтернету. Для коректної роботи програми потрібен інтернет',
            button: 'Зрозуміло',
            reconnected: "Під'єднано!",
            reconnecting: "Зв'язок втрачено. Повторне з'єднання.",
        },
    },
    ranks: {
        rankLongTitle: '{{rank}} Ранг',
        level: '{{level}} LVL',
        upgradeRankButton: 'Підвищення рангу',
        upgradeText:
            'Ви досягли всіх рівнів вашого поточного рангу. Настав час перейти на {{rank}} Підвищуй свій ранг і покращуй свої показники',
        lockedText:
            '{{rank}} Ранг не можна отримати за монети. Ви можете досягти його, підвищуючи рівень і просуваючись по грі',
        perDay: 'В день',
        dailyUnlock: 'Денний анлок',
        foodConsumption: 'Денні затрати',
        maxAge: 'Макс. Вік',
        days: 'Днів',
        list: {
            free: {
                title: 'Free',
                infoText:
                    'Ранг Free дасть вам можливість вивчити застосунок і його функції. Однак ви не можете отримати і виводити нагороди, поки не купите NFT або не підвищите ранг свого безкоштовного вихованця',
            },
            starter: {
                title: 'Starter',
            },
            common: {
                title: 'Common',
            },
            uncommon: {
                title: 'Uncommon',
            },
            unusual: {
                title: 'Unusual',
            },
            rare: {
                title: 'Rare',
            },
            mystical: {
                title: 'Mystical',
            },
            legendary: {
                title: 'Legendary',
            },
            epic: {
                title: 'Epic',
            },
            exotic: {
                title: 'Exotic',
            },
            royal: {
                title: 'Royal',
            },
            diamond: {
                title: 'Diamond',
            },
        },
        ranksDetailedInfoScreen: {
            current: 'Поточний',
            button: 'Виберіть ранг',
        },
        rankDetailedInfo: {
            reward: {
                title: 'Щоденна винагорода ≈ {{reward}} ≈ {{usd}}',
                text: 'Орієнтовна щоденна винагорода в токенах за умови виконання всіх щоденних завдань',
                warning:
                    'Це значення є приблизне і може змінюватись в залежності від даних системи',
                warningFree:
                    'Безкоштовний ранг має шанс заробити винагороду в грі. Гарантованих нагород за безкоштовний ранг немає',
            },
            rate: {
                title: 'Щоденне розблокування ≈ {{reward}} ({{rate}}) ≈ {{usd}}',
                text: 'Ви можете перевести {{percent}}% доступних винагород VIGUP на свій основний гаманець. Після запиту токен можна обміняти, відправити на інший гаманець або вивести',
                alert: 'Решта токенів VIGUP перебувають на розгляді і зберігатимуться в заблокованому гаманці',
            },
            consumption: {
                title: 'Споживання продуктів харчування = {{consumption}}',
                text: "Ваш улюбленець споживає токени щодня. Якщо улюбленця вчасно не нагодувати, він втрачає здоров'я і може померти",
            },
            age: {
                title: 'Максимальний вік = {{maxAge}} днів',
                text: 'Коли ваш NFT досягне цього віку, він помре і його потрібно буде оживити',
                alert: 'Підвищення рангу скине ваш вік NFT до нуля, і оновлений віртуальний улюбленець буде жити відповідно ліміту нового рангу. Після того, як NFT будете повернено до життя - ви почнете з першого рівня',
            },
        },
        modalWhatIsRank: {
            title: 'Що таке ранг?',
            text: 'Ранг впливає на можливість заробітку ваших улюбленців та інші важливі характеристики, такі як швидкість розблокування нагород та кількість споживання їжі улюбленцем. Чим вищий ранг, тим кращі характеристики',
            buttonAvailable: 'Переглянути доступні ранги',
            buttonAll: 'Переглянути всі ранги',
        },
        checkoutUpgradeRank: {
            title: 'Підвищення рангу',
            text: 'Чим вище ранг, тим більше нагород заробить ваш улюбленець',
            upgradeTo: 'Оновлення до',
            transaction: `Підвищити ранг до {{rank}} Ранг для "{{name}}" NFT`,
        },
        successUpgradeRank: {
            title: 'Ранг підвищено!',
            text: 'Успішно підвищено ранг NFT. Виконуйте щоденні завдання та заробляйте ще більше нагород',
            backToPet: 'Переглянути улюбленця',
        },
    },
    localNotifications: {
        moveToEarnFinished: {
            title: 'Завдання з ходьби виконано',
            message:
                'Відкрийте додаток і подивіться, скільки Енергії ви зібрали',
        },
        noPets: {
            title: 'Поспішайте забрати свого улюбленця',
            message:
                'Заведіть першого улюбленця та розпочніть свою дивовижну подорож в IguVerse',
        },
    },
    monthPicker: {
        month1: 'Січень',
        month2: 'Лютий',
        month3: 'Березень',
        month4: 'Квітень',
        month5: 'Травень',
        month6: 'Червень',
        month7: 'Липень',
        month8: 'Серпень',
        month9: 'Вересень',
        month10: 'Жовтень',
        month11: 'Листопад',
        month12: 'Грудень',
        selectMonth: 'Виберіть',
    },
    staking: {
        stakeLoading: 'Вмикаємо буст, будь ласка, не закривайте додаток',
        unStakeLoading: 'Вимикаємо буст, будь ласка, не закривайте додаток',
        general: {
            dailyBoost: 'Щоденний бустер',
            ended: 'Закінчиться',
            summary: 'Всього',
            days: '{{days}} Дні',
            current: 'Поточний буст',
        },
        plans: {
            title: 'Деталі варіанту',
            text: 'Кожен буст-варіант визначає період блокування та бонус',
            days: ' Дні',
            boost: 'Підвищення до {{boost}}%',
        },
        welcomeScreen: {
            title: 'Буст',
            headerTitleStart: 'Збільшіть дохід ',
            headerTitleCenter: 'на {{number}}%',
            headerTitleEnd: '',
            headerText:
                'Ви можете збільшити нагороди в основній грі за допомогою бусту, заморозивши токени на певний проміжок часу',
            stake: {
                title: 'Варіанти бусту',
                text: 'Інвестуй свої токени IGU та IGUP - отримуйте відсотки від вкладу, або збільшені нагороди',
            },
            lock: {
                title: 'Період блокування',
                text: 'Ваші токени будуть заморожені на період часу, зазначений у варіанті бусту',
            },
            calculation: {
                title: 'Розрахунок бусту',
                text: 'Буст перераховується щодня залежно від обраного варіанту бусту',
                alert: 'Якщо ваші нагороди змінилися (нп. збільшилась кількість тваринок), зміниться і буст. Ви завжди зможете побачити поточне значення буста',
            },
            button: 'Увімкнути буст',
        },
        optionsScreen: {
            toastAlready: 'Цей варіант буста вже ввімкнено',
            button: 'Продовжити',
            screenTitle: 'Варіант бусту',
            title: 'Вибрати варіант',
            text: 'Виберіть варіант бусту для ваших токенів. Можна використовувати кілька варіантів одночасно',
            IGUP: {
                title: 'Буст за IGUP',
                text: 'Заблокуйте свої IGUP на певний час і збільшіть вашу щоденну винагороду за завдання',
            },
        },
        plansScreen: {
            button: 'Продовження',
            selectPlan: 'Оберіть варіант',
            title: 'Вибрати варіант бусту',
            headerTitle: 'Оберіть варіант',
            headerText:
                'Обрана вами сума буде заблокована в смарт-контракті до кінця періоду. Одночасно можна використовувати тільки один тарифний план',
            headerInfoText: 'Який план обрати?',
            lock: {
                title: 'Період блокування = {{days}} днів',
                description:
                    'Період блокування - це період часу, протягом якого ваші токени будуть заблоковані, а буст буде активним',
            },
            boost: {
                title: 'Буст = ~{{boost}} %',
                description:
                    'Буст - це модифікатор, який збільшує ваші нагороди за завдання на певний відсоток',
            },
            calculation: {
                title: 'Щоденний приріст = ~{{boost}} %',
                description:
                    'Буст перераховується щодня залежно від ваших нагород',
                alert: 'Якщо ваша винагорода змінилася, то зміниться і бонус. Ви завжди зможете побачити поточний буст',
            },
        },
        coinsInputScreen: {
            title: 'Виберіть кількість токенів',
            button: 'Розрахувати щоденний буст',
            button2: 'Пропустити крок',
            loading: 'Розрахунок бусту..',
            available: 'Доступно: ',
            maxButton: 'Макс.',
            errors: {
                digits: 'Повинні бути тільки цифри',
                max: 'Недостатньо токенів на балансі. Будь ласка, введіть іншу суму або депозит',
                min: 'Кількість токенів має бути не меншою за {{limit}} {{coin}}',
                maxStack:
                    'Кількість токенів має бути не більшою за {{limit}} {{coin}}',
            },
            maxBoost:
                'Інвестуй {{amount}} {{coin}} щоб отримати {{boost}}% бусту',
            maxBoostModal: {
                title: 'Отримайте максимальний буст',
                text: 'Виберіть запропоновану суму та отримайте максимально можливий буст!',
                button: 'Додати монети',
                deposit: {
                    title: 'Оптимальний депозит = {{amount}} {{coin}}',
                    text: 'Оптимальна кількість токенів для максимальної прибутковості. Значення залежить вiд кількості тваринок та їх характеристик',
                },
                boost: {
                    title: 'Максимальний буст = {{boost}}%',
                    text: 'Максимально можливий буст від інвестування. Буст перераховуватиметься щодня залежно від характеристик ваших вихованців. Ви завжди можете додати токени, якщо це потрібно!',
                },
            },
        },
        dailyBoostScreen: {
            title: 'Щоденний буст',
            headerTitle: 'Буст = ',
            headerText:
                'Буст діятиме певний період часу, після якого ви зможете забрати токени',
            button: 'Підтвердити',
            confirmationModal: {
                title: 'Підтвердити',
                keys: {
                    from: 'З гаманця',
                    duration: 'Тривалість',
                    endingOn: 'Закінчиться',
                    dailyBoost: 'Щоденний буст',
                    summary: 'Сума',
                },
                values: {
                    from: 'Головний гаманець',
                    duration: '{{plan}}, {{days}} Днів',
                },
            },
        },
        successScreen: {
            title: 'Успішно увімкнено буст',
            text: 'Ваші токени будуть заблоковані і будуть утримуватися до кінця плану. Після закінчення плану вам необхідно скористатися кнопкою "Повернути токени", щоб повернути токени назад у свій гаманець',
            button: 'Повернутися до гаманця',
        },
        successUnStakeScreen: {
            title: 'Успішно вимкнено буст',
            text: 'Ви успішно зняли токени з бусту. Токени повернулися на ваш головний гаманець',
            button: 'Повернутися до гаманця',
        },
        alreadyScreen: {
            title: 'Буст',
            headerTitle: 'Деталі плану',
            headerText:
                'Ви інвестували свої токени і завдяки цьому отримуєте буст до нагород, який буде утримуватися до кінця плану. Після закінчення плану токени можна буде повернути на Головний гаманець',
            headerInfoText: 'Як це працює?',

            confirmationModal: {
                title: 'Підтвердити транзакцію',
                keys: {
                    from: 'На гаманець',
                    duration: 'Тривалість',
                    endingOn: 'Закінчився на',
                    dailyBoost: 'Щоденний буст',
                    summary: 'Підсумок',
                },
                values: {
                    from: 'Гаманець нагород',
                    duration: '{{plan}}, {{days}} Дні',
                },
            },
            staked: {
                title: '{{coin}} Буст',
                text: 'Активний план. Ви можете додати більше токенів',
                timerTitle: 'Залишилося часу',
                staking: 'Буст:',
                deposit: 'Початок:',
                end: 'Кiнець:',
                boost: 'Щоденний буст:',
                summary: 'Підсумок:',
                buttonAdd: 'Додати бiльше токенів',
                buttonUpgrade: 'Покращити план',
                buttonUnstake: 'Отримати токени',

                modalAddCoins: {
                    title: 'Додати ще токенів?',
                    text: 'Після того, як ви додасте токени, ваш варіант буста буде перерахований на основі внесеної суми, і таймер перезапуститься',
                    button1: 'Додати токенів',
                    button2: 'Скасувати',
                },
                modalUpgrade: {
                    title: 'Покращити план?',
                    text: 'Після того, як ви поліпшите варіант буста, він буде перерахований на основі внесеної суми, і таймер перезапуститься',
                    button1: 'Покращити',
                    button2: 'Скасувати',
                },
            },
        },
    },
    timer: {
        captions: { day: 'Дні', hour: 'Год.', min: 'Хв.', sec: 'Сек.' },
        newDay: 'Новий день',
        refreshed: 'Ваші завдання оновлені',
    },
    referrals: {
        myReferrer: 'Вас запросив цей користувач',
        referralCode: 'Ваш код',
        referralLink: 'Реф. посилання',
        header: {
            title: 'Запросити друзів',
            text: 'Запрошуйте інших користувачів і заробляйте ще більше з нашою реферальною програмою. Дізнайтеся, як це працює нижче',
            infoText: 'Як це працює?',
        },
        direct: {
            title: 'Друзі - {{directPercentage}}%',
            text: 'Ви будете отримувати {{directPercentage}}% від усіх нагород, зароблених друзями',
        },
        indirect: {
            title: 'Друзі друзів - {{inDirectPercentage}}%',
            text: 'Ви будете отримувати {{inDirectPercentage}}% від усіх винагород, зароблених друзями друзів',
        },
        gaming: {
            title: 'Ігрові бонуси',
            text: 'Реферальні бонуси діють як для PvP-ігор, так і для ігрових завдань',
        },
        buttonShare: 'Запросити користувачів',
        invitedReferrals: {
            card: {
                direct: 'Прямі реферали',
                indirect: 'Непрямі реферали',
                active: 'Активні реферали (друзі)',
                turnover: 'Загальний обіг',
            },
            viewReward: 'Переглянути винагороди',
            indirectModal: {
                title: 'Друг друга',
                text: 'Цього користувача запросив один з ваших друзів',
            },
            header: {
                title: 'Запрошені реферали',
                text: 'Тут ви можете побачити всіх запрошених рефералів і свій щоденний прибуток, якщо ви виконали всі умови',
                infoText: 'Як працює щоденний бустер?',
                list: 'Реферали',
                sort: 'Сортувати по',
                filter: {
                    CreatedAt: 'Найновші',
                    UserEnergy: 'Енергія',
                },
            },
        },
        emptyScreen: {
            title: 'Упс!',
            text: 'Щось не так. Але не хвилюйся, ми це швидко виправимо. Спробуй потягнути.',
        },
        emptyList: {
            title: ' Запрошені реферали',
            text: 'Ви ще не запросили жодного користувача. Але це не проблема, давайте зробимо це прямо зараз',
        },
        allInvitedReferralsScreen: { title: 'Всі запрошені реферали' },
        inviteUsersScreen: {
            title: 'Запросити користувача',
            text: 'Завантажте додаток IguVerse та надайте реферальний код',
            myNFT: 'My Pet NFT',
            collectedEnergy: 'Зібрана енергія',
            leaderBoard: 'Місце в лідерборді',
            button: 'Поділитись кодом',
            download: 'Завантажити додаток IguVerse',
        },
        referralCard: {
            title: 'Реферальний код',
            text: 'Введіть код реферала для отримання бонусів',
            button: 'Введіть код',
        },
        referrerModal: {
            title: 'Реферальний код',
            text: 'Введіть код реферала і ви отримаєте різні знижки та бонуси',
            label: 'Реферальний код',
            placeHolder: 'Введіть реферальний код',
            noCode: 'Не маєте коду? ',
            apply: 'Дізнатись про реф. програму',
            button: 'Надіслати код реферала',
            success: {
                toastSuccess: {
                    title: 'Надано код направлення',
                    text: 'Тепер всі функції доступні для Вас',
                },
            },
            error: {
                empty: 'Реф. код не может бути пустим',
                incorrectCode: 'Неправильний код. Код не існує або недійсний',
                toastError: {
                    title: 'Неправильний код',
                    text: 'Реферальний код не існує або недійсний',
                },
                forbidden:
                    'Неможливо використати реферальний код на цьому пристрої',
                toastForbidden: {
                    title: 'Заборонено',
                    text: 'Неможливо використати реферальний код на цьому пристрої',
                },
                toastAlreadyLinked: {
                    title: 'Вже використано',
                    text: 'У Вашому обліковому записі вже є реферальний код',
                },
            },
        },
        boostCards: {
            cardTitle: 'Бустер = {{boost}}%',
            cardText: 'Вам необхідно запросити ',
            users: ' Користувачів',
            text: 'Чим більше користувачів ви запросите, тим більший щоденний бустер ви отримаєте',
            button: 'Переглянути винагороди',
        },
        howBoostWorks: {
            title: 'Отримайте бустер',
            text: 'Запрошуйте користувачів та отримуйте додатковий бонус до нагород за виконання щоденних завдань після досягнення кількості запрошених активних гравців. Приріст буде автоматично застосований при досягненні цього показника',
            alert: 'Бустер вираховується щодня і діє тільки для активних рефералів, які грають щодня і досягають {{rewardEnergyThreshold}} Енергії',
        },
        modalReferee: {
            title: 'Зустрічайте свого реферала',
            text: 'Ви можете відвідати соціальні мережі запрошеного користувача, щоб дізнатися більше про свого реферала або познайомитися з ним',
            energy: 'Зібрана енергія (24год)',
        },
    },
    aiQuoteInfo: {
        alertCard: {
            overload: { title: 'Система перевантажена' },
            dailyAttempts: { title: '{{attempts}} Залишилось спроб' },
        },
        modalInfo: {
            title: 'NFT з Вашої уяви',
            text: 'Створити NFT можна за допомогою технології штучного інтелекту, але ця операція є дуже дороговартісною. Іноді через високе навантаження вона може бути тимчасово недоступна',
            daily: 'Використання за останні 24 години = ',
            dailyText:
                'Ви можете згенерувати не більше {{amount}} унікальних улюбленців за допомогою технології ШІ за 24 години',
            systemLoad: 'Навантаження на систему = {{load}}',
            systemLoadText:
                'Іноді система може бути перевантажена через великий попит. Вам доведеться трохи почекати',
            load: {
                low: 'Низьке',
                medium: 'Середнє',
                high: 'Високе',
                overloaded: 'Система перевантажена',
            },
            systemUsage: 'Використання системи = {{percentage}}%',
            systemUsageText:
                'Система працює в бета-версії і наразі доступна лише певні суми на добу',
        },
        modalErrorNoMints: {
            title: 'Спроб не залишилось',
            text: 'З прикрістю повідомляємо, що на сьогоднішній день всі спроби вичерпано. Але не хвилюйтеся, завтра ви зможете спробувати намалювати NFT за допомогою AI-технології',
            button1: 'Мінт з фото',
        },
        modalErrorOverLoad: {
            title: 'Система перевантажена',
            text: 'Нам шкода, але ми повідомляємо, що мінт AI зараз перевантажений іншими користувачами. Ми повідомимо вам, коли він буде доступний',
            button1: 'Мінт з фото',
        },
    },
    howTo: {
        fee: {
            stepOne: {
                title: 'Комісія за блокчейн є приблизною',
                text: 'Усі транзакції в додатку відбуваються саме в блокчейні та мають комісію в BNB. Сума комісії може бути відома лише під час транзакції, ми показуємо лише передбачуваний куш',
            },
            stepTwo: {
                title: 'Вища плата за токени',
                text: 'У блокчейні ви повинні схвалити використання токенів перед виконанням конкретної операції. Оплата за допомогою BNB займе лише одну транзакцію, тоді як для випуску інших токенів потрібні дві транзакції: підтвердження та виконання',
            },
        },
        charity: {
            stepOne: {
                title: 'Допомога зоозахисним організаціям',
                text: 'Ви маєте можливість обрати благодійну організацію зі списку та зробити пожертву на її користь для допомоги тваринам по всьому світу',
            },
            stepTwo: {
                title: 'Встановити бажаний відсоток',
                text: 'Ви можете вибрати відсоток від винагороди, який буде пожертвуваний (від 1% до 100%). Також ви можете змінити це значення в будь-який момент',
            },
        },
        play: {
            button: 'Розпочати гру',
            stepOne: {
                title: 'Виберіть домашніх тварин для виконання завдань',
                text: 'Виберіть у розділі нижче улюбленців, які будуть брати участь у грі. Перший улюбленець у списку буде використаний у соціальному завданні і буде відображатися як ваш основний улюбленець.',
            },
            stepTwo: {
                title: 'Відновлення Енергії',
                text: 'У вас є 24 години, щоб відновити свій рівень енергії, виконавши завдання до кінця дня. 100% Енергії означає, що ви заробите 100% від максимально можливої винагороди на основі статистики улюбленців. Щодня о 00:00 рівень енергії обнуляється',
            },
            stepThree: {
                title: 'Отримуйте Винагороди',
                text: 'Після виконання завдань ваша Енергія буде конвертуватися в Нагороди на основі статистики ваших улюбленців',
            },
            stepFour: {
                title: 'Покращуйте свої NFT',
                text: 'Виховуйте своїх улюбленців, створюйте нових улюбленців, підвищуйте ранг, щоб отримувати більше переваг. Підніміться на найвищу позицію в таблиці лідерів і отримайте ще більше нагород',
            },
        },
        referrals: {
            button: 'Запросити користувачів',
            stepOne: {
                title: 'Поділіться Вашим реферальним кодом',
                text: 'Запрошуйте користувачів в додаток IguVerse і заробляйте на їх грі. За прямих рефералів ви отримаєте - {{direct}}%, а за непрямих - {{inDirect}}%',
            },
            stepTwo: {
                title: 'Отримайте прискорення у виконанні щоденних завдань',
                text: 'Запрошуйте користувачів та отримуйте приріст до щоденних завдань після досягнення певної кількості запрошень. Детальніше у вкладці "Мої реферали"',
            },
            stepThree: {
                title: 'Отримуйте більше знижок',
                text: 'У блоці "NFT для гри" виберіть мінімум один NFT для гри. Враховуйте, що перший NFT буде збирати найбільший рівень досвіду',
            },
            stepFour: {
                title: 'Отримуйте ігрові бонуси',
                text: 'За кожну виграну гру і за кожне поповнення прямі реферали даватимуть вам {{direct}}% від суми, а непрямі реферали - {{inDirect}}%',
            },
        },
        availableRewards: {
            stepOne: {
                titleOne: 'Отримайте ',
                titleTwo: ' від ваших винагород',
                text: 'Ви можете перевести {{percent}}% доступних винагород VIGUP на свій основний гаманець. Після запиту токен можна обміняти, відправити на інший гаманець або вивести',
            },
            stepTwo: {
                title: 'Процес клейму',
                text: 'Клейм - це операція на блокчейні, яка дає вам можливість конвертувати ваш баланс VIGUP на ваш основний гаманець IGUP на блокчейні. Після успішного виконання клейму кошти стають доступними негайно на балансі',
            },
            stepThree: {
                title: 'Обмін VIGUP на',
                text: 'Ви зможете обміняти зароблені токени на токени IGUAI після виходу торгового маркетплейсу. Використовуючи додаток, ви стаєте одним із перших користувачів нашого рішення верхнього рівня',
            },
            stepFour: {
                title: "Від'ємний баланс",
                text: "Іноді ваш доступний баланс може бути від'ємним, що означає, що ви використовували заблоковані винагороди для різних операцій у грі, як-от лікування та підвищення рівня. Ми дозволяємо, щоб ваші доступні винагороди були нижче нуля, аж до суми вашого заблокованого балансу. Коли Ваші токени розблокуються, доступний баланс також зросте",
            },
            alert: 'Решта токенів VIGUP перебувають на розгляді і зберігатимуться в заблокованому гаманці',
        },
        lockedRewards: {
            stepOne: {
                title: 'Заблоковані винагороди',
                text: 'Зароблені нагороди блокуються відповідно до статистики улюбленців (ранг і рівень). Покращуйте своїх улюбленців, щоб зменшити період блокування',
            },
            stepTwo: {
                title: 'Конвертація в доступні винагороди',
                text: 'Заблоковані винагороди розблоковуються автоматично і після розблокування будуть доступні в розділі Доступні винагороди на балансі',
            },
            stepThree: {
                title: 'Обмін VIGUP на ',
                text: 'Ви зможете обміняти зароблені токени на токени IGUAI після виходу торгового маркетплейсу. Використовуючи додаток, ви стаєте одним із перших користувачів нашого рішення верхнього рівня',
            },
        },
        socializeToEarn: {
            CONFIRMED: 'Вірно',
            FAILED: 'Невірно',
            step: {
                title: 'Додавання посилання на IguVerse',
                text: 'Завжди додавайте посилання на додаток IguVerse, який можна знайти на екрані соціального завдання, під час публікації Pet ID. Посилання має бути прикріплене до самої історії.',
            },
            stepOne: {
                title: 'Pet ID і посилання повністю видимі',
                text: 'Інформація на Pet ID і посилання мають бути легко розпізнаваними. Посилання на додаток має бути активним',
            },
            stepTwo: {
                title: 'Невеликі модифікації допускаються',
                text: 'Ви можете змінити розмір та колір Pet ID або його нахил. Звичайно, ці модифікації не повинні суперечити першому правилу',
            },
            stepThree: {
                title: 'Pet ID важко розібрати',
                text: 'Ми не допускаємо жодних модифікацій Pet ID, включаючи обрізання та приховування зображення або його частин. Перегорніть, щоб дізнатися більше',
            },
            stepFour: {
                title: 'Pet ID прихований',
                text: 'Не допускається накладення або фарбування зображення, а також надмірне його зменшення',
            },
        },
        verifyUser: {
            stepOne: {
                title: 'Знайдіть Pet ID у соціальних мережах',
                text: 'Перейдіть на сторінку іншого користувача в соціальній мережі, перегляньте контент та знайдіть Pet ID. Введіть код у додатку та виконайте завдання',
            },
            stepTwo: {
                title: 'Надайте ідентифікатор знайденої тварини',
                text: 'Введіть код з Pet ID або відскануйте його за допомогою сканера QR-коду. Якщо його немає, натисніть кнопку "Тварину не знайдено". Знайдіть всіх користувачів для виконання завдання',
            },
            stepThree: {
                title: 'Будьте відповідальними',
                text: 'Грайте чесно і не намагайтеся обманювати, вводячи систему в оману, надаючи неправильні ідентифікатори або стверджуючи, що ви не можете знайти. Ваш акаунт може бути позначений або заблокований, якщо ви продовжуватимете це робити',
            },
        },
        purchaseBNB: {
            screenTitle: 'Як придбати BNB',
            title: 'Придбати BNB на Binance',
            text: 'BNB – це криптовалюта, яка використовується для оплати комісій у Binance Smart Chain, блокчейні, який ми використовуємо. Перегляньте відео нижче, щоб дізнатися більше про внесення BNB у внутрішньоігровий гаманець',
            guideBlock: {
                title: 'Посібник з купівлі та виведення коштів',
                first: 'Увійдіть до програми Binance. Завантажте, зареєструйтесь та пройдіть верифікацію, якщо у вас її немає',
                second: 'Купуйте крипту карткою або за допомогою p2p. Ви можете одразу вибрати BNB!',
                third: 'Відкрийте вкладку «Гаманець» та натисніть «Вивід»',
                fourth: 'Виберіть криптовалюту, яку потрібно вивести. У нашому випадку – BNB',
                fiveStepOne:
                    'Вставте адресу, на яку хочете вивести кошти, та виберіть мережу: ',
                fiveBold: 'BNB Smart Chain (BEP-20)',
                fiveStepTwo:
                    '. Адреса вашого гаманця можна знайти на вкладці гаманця в IguVerse. Він починається з 0x і є комбінацією букв і цифр',
                six: 'Зачекайте кілька секунд, доки транзакція буде оброблена, і все готово!',
            },
            resourceBlock: {
                title: 'Корисні ресурси',
                buy: 'Посібник щодо покупки BNB (BNB)',
                withdraw: 'Як зняти кошти з Binance',
                status: 'Як мені перевірити статус криптовалютної транзакції на блокчейні',
            },
        },
        petOrderId: {
            title: 'Виберіть порядок улюбленців',
            text: 'Виберіть ігрових улюбленців у розділі Колекція та розставте решту по-порядку! Порядок вихованців визначатиме отримуваний ними досвід',
            cardFeatureInfo: {
                title: 'Пріоритет улюбленців',
                text: 'Перший ігровий улюбленець представлятиме вас у вашому Pet ID, у голосуванні, у таблиці лідерів',
            },
            button: 'Змінити порядок',
        },
        howToGamingAvailableWallet: {
            screenTitle: 'Доступний гаманець',
            button: 'Поповнити',
            stepOne: {
                title: 'Грайте в змагальні ігри',
                text: 'Ігровий гаманець дає змогу змагатися з іншими гравцями та вигравати IGU. Використовуйте вкладку "Ігри", щоб побачити доступні ігри',
            },
            stepTwo: {
                title: 'Поповнити ігровий гаманець',
                text: 'Щоб взяти участь, поповніть свій ігровий гаманець IGU та отримайте VIGU. Використовуйте кнопку нижче, щоб поповнити токени',
            },
            stepThree: {
                title: 'Виведення на основний гаманець',
                text: 'Нагороди, виграні в змагальних іграх, зберігатимуться в ігровому гаманці. Ви можете вивести ці винагороди на основний гаманець у будь-який час',
            },
            stepFour: {
                title: 'Отримуйте бонус від рефералів',
                text: 'За кожну виграну гру і за кожне поповнення прямі реферали даватимуть вам {{direct}}% від суми, а непрямі реферали - {{indirect}}%',
            },
        },
        howToGamingPendingWallet: {
            screenTitle: 'Гаманець очікування',
            alert: 'Токени в гаманці заморозки не контролюються IguVerse і заблоковані в смарт-контракті протягом гри',
            stepOne: {
                title: 'Заморожування під час гри',
                text: 'Кошти в ігровому гаманці будуть заморожені доти, доки ви не закінчите гру. Цей захід запроваджено для запобігання шахрайству',
            },
            stepTwo: {
                title: 'Автоматичне розморожування',
                text: 'Якщо ви виграли гру, ваші кошти будуть автоматично повернуті в ігровий гаманець. В іншому випадку вони будуть передані переможцю',
            },
        },
        howToCommissionFee: {
            screenTitle: 'Комісія',
            stepOne: {
                title: ' Комісія',
                text: 'Ми стягуємо комісію в розмірі {{commission}}% за кожне виведення коштів з ігрового гаманця',
            },
            stepTwo: {
                title: 'Покращена токеноміка',
                text: 'PvP-ігри використовують економічну модель пулу, яка перевершує економіку більшості проєктів GameFi. Комісія списується для подальшого зміцнення економіки',
            },
        },
        HowToCollections: {
            stepOne: {
                title: 'Віртуальний вихованець - компаньйон',
                text: 'Створіть NFT-улюбленця за допомогою ШІ, який допоможе вам заробляти в соцмережах. Ви також можете завантажити фотографію свого вихованця для створення NFT',
            },
            stepTwo: {
                title: 'Відновлення Енергії',
                text: 'У вас є 24 години, щоб відновити свій рівень енергії, виконавши завдання до кінця дня. 100% Енергії означає, що ви заробите 100% від максимально можливої винагороди на основі статистики улюбленців. Щодня о 00:00 рівень енергії обнуляється',
            },
            stepThree: {
                title: 'Обмін VIGUP на ',
                text: 'Ви зможете обміняти зароблені токени на токени IGUAI після виходу торгового маркетплейсу. Використовуючи додаток, ви стаєте одним із перших користувачів нашого рішення верхнього рівня',
            },
        },
    },
    energyInfoScreen: {
        title: 'Збирайте Енергію і конвертуйте її в токени',
        text: 'Курс обміну Енергія/IGUP залежний від кількості домашніх улюбленців та їх характеристик такі як ранги, рівні, а також інших',
        button: 'Розпочати гру',
        features: {
            first: {
                title: '1 Енергія ≈ {{amount}} IGUP',
                text: 'Поданий курс є приблизним курсом на даний момент і може змінюватись в залежності від характеристик улюбленців, та інших модифікаторів',
            },
            second: {
                title: 'Мінімальний поріг {{energy}}',
                text: 'Якщо гравець не досягає мінімального порогу {{energy}} Енергії, половина Енергії буде перенесена на наступний день, а інша половина спалена',
            },
        },
    },
    initial: {
        initialMint: {
            title: 'Створіть Вашого першого улюбленця та розпочніть вашу пригоду в IguVerse',
            text: 'Це останній крок перед тим як ви зможете розпочати вашу пригоду та заробляти щоденні винагороди за активність з ним',
            button: 'Створити Улюбленця',
        },
        initialReferral: {
            title: 'Насолоджуйтесь бонусами і знижками',
            text: 'Вас запросили в додаток IguVerse! Насолоджуйтесь додатковими знижками і бонусами. Поспішіть створити свого улюбленця',
            button: 'Далі',
        },
    },
    ModalShareOrSave: {
        title: 'Збережіть Ваш Контент',
        text: 'Збережіть ваш контент з додатку IguVerse або поділіться ним з друзями',
        save: 'Зберегти в Галерею',
        share: 'Поділитись',
        loading: 'Контент готується..',
        saveSuccess: 'Контент збережений в галерею',
    },
    RelatedApps: {
        downloadApp: {
            titleiOS: 'Додаток доступний для IOS',
            titleAndroid: 'Додаток доступний для Android',
            description: 'Скачайте додаток для зручності',
            buttonOk: 'Завантажити',
            buttonCancel: 'Закрити',
        },
        switchToApp: {
            titleiOS: 'Додаток доступний для IOS',
            titleAndroid: 'Додаток доступний для Android',
            description: 'Перейдіть в додаток для зручності',
            buttonOk: 'Перейти',
            buttonCancel: 'Закрити',
        },
    },
    ShareYourFeedback: {
        title: 'Зворотній звязок',
        text: 'Ви можете поділитись з нами зворотнім звязком, також до надісланого повідомлення автоматично будуть додані логи з вашого пристрою які допоможуть нашим розробникам зрозуміти причину проблеми',
        placeholder: 'Опишіть Вашу проблему в деталях',
        button: 'Відправити',
        loading: 'Відправляється..',
        accessibility:
            "Вимкнути функцію «надсилати зворотній зв'язок при струшуванні»",
    },
    ModalMainnet: {
        title: 'Цей Функціонал Недоступний',
        text: 'Цей функціонал недоступний до моменту як токени будуть ліститсь на біржах. Точна дата буде анонсована в офіціальних каналах',
        button: 'OK',
    },
    ModalDailyRewards: {
        [DAILY_REWARD_STATUS.Bonus]: {
            title: 'Нараховано PvP-бонус',
            text: 'За вашу активність у PvP-іграх ви отримали бонус. Токени вже у вашому ігровому гаманці',
        },
        [DAILY_REWARD_STATUS.Daily]: {
            title: 'Ви отримали свої нагороди!',
            text: 'Ваші нагороди за виконання вчорашніх завдань вже нараховані!',
        },
        [DAILY_REWARD_STATUS.Both]: {
            title: 'Ви отримали щоденну нагороду та PvP-бонус',
            text: 'Нагороди за виконання завдань уже нараховані та починають розблоковуватися! Ви також отримали бонусні токени за участь у PvP-іграх',
        },
        dailyReward: {
            title: 'Доступно {{availableAmount}} / {{totalAmount}} IGUP',
            text: 'IGUP в кількості {{availableAmount}} доступний відразу у вашому гаманці',
        },
        unlocks: {
            title: 'Заблоковані токени',
            text: '{{restAmount}} IGUP поступово розморожуватиметься протягом періоду розблокування',
        },
    },
    MintBonusScreen: {
        mintSuccess: {
            title: 'Бонус',
            text: 'Створення NFT',
        },
        BonusMintRanksDetailedInfoScreen: {
            title: 'Створіть NFT - Отримайте Бонус',
            text: 'Унікальна пропозиція від IguVerse, створіть свого NFT улюбленця, і отримайте бонус в ігровому токені IGUP на ваш баланс. Щоб отримати бонус перейдіть далі',
            button1: 'Продовжити',
            button2: 'Переглянути Бонуси',
            timeRemaining: 'До кінця акціі',
            features: {
                bonus: {
                    key: 'Бонус = {{amount}} IGUP (${{dollarValue}})',
                    value: 'Токени будуть нараховані на ваш баланс одразу після створення улюбленця',
                },
                lock: {
                    key: 'Період Блокування = {{days}} днів',
                    value: 'Токени будуть заблоковані до кінця періоду блокування і після цього автоматично будуть доступні для виводу',
                },
            },
        },
        BonusMintRanksCarouselScreen: {
            screenTitle: 'Бонус за Створення NFT',
            title: '{{slug}} Ранг',
            button1: 'Вибрати Ранг',
            features: {
                bonus: {
                    key: 'Бонус за Ранг = {{amount}} IGUP (${{dollarValue}})',
                    value: 'Токени будуть нараховані на ваш баланс одразу після створення улюбленця',
                },
                lock: {
                    key: 'Період Блокування = {{days}} Днів',
                    value: 'Токени будуть заблоковані до кінця періоду блокування і після цього автоматично будуть доступні для виводу',
                },
            },
        },
    },
    YourPetsAreHungry: {
        title: 'Ваші улюбленці зголодніли!',
        text: "Втрачене здоров'я зменшить ваші нагороди і може через деякий час зробити ваші NFT непридатними для використання у додатку. Годуйте своїх улюбленців, щоби стабільно заробляти!",
    },
    priceUpModal: {
        title: 'Підвищення цін на ',
        text: 'Через високий попит і швидкій ріст проекту наша команда прийняла рішення підняти ціни на NFT, щоб винагородити перших користувачів і переконатися, що економіка залишається збалансованою в довгостроковій перспективі',
        priceUpdate: 'Підвищення цін через',
        button: 'Створити улюбленця',
    },
    updateModal: {
        banner: {
            title: 'Вийшло нове оновлення!',
            text: 'Перевірте нову версію {{version}} програми',
        },
        screen: {
            screenTitle: 'Нове оновлення',
            title: 'Вийшло нове оновлення!',
            text: 'Команда IguVerse старанно працює над покращенням програми та розробкою нових функцій. Насолоджуйтесь наступними покращеннями в новій версії{{version}}',
            button: 'Почніть грати',
        },
    },
    communityModal: {
        title: 'Отримайте допомогу від нашої спільноти',
        text: 'Приєднуйтесь до нашого офіційного чату спільноти, щоб отримати відповіді на свої запитання від інших гравців. Дізнайтеся, як грати, максимізуйте свій прибуток і насолоджуйтеся IguVerse разом!',
        button1: 'Переглянути інші канали',
        button2: 'Більше не показувати',
    },
    socialTooltip: {
        text: 'Натисніть на тег «Не вдалося», щоб дізнатися, чому ваш обліковий запис або Pet ID не відповідають нашим критеріям та були відхилені. Ви також зможете отримати доступ до бази знань, щоб дізнатися, що це за критерії',
    },
    gameIterationText: {
        text: 'Наразі підраховуються вчорашні нагороди, що зазвичай займає близько {{minutes}} хвилин. Ви зможете грати знову, коли нагороди будуть підраховані',
        toastErrorTitle: 'Наразі підраховуються вчорашні нагороди',
    },
    howConnectFacebookModal: {
        info: 'Як підключитися',
        screenTitle: 'Як підключити Facebook',
        title: 'Пошук Facebook ID',
        text: 'Щоб підключити свій обліковий запис Facebook, вам потрібно знайти та скопіювати свій ідентифікатор Facebook. Відвідайте сторінку свого профілю та скопіюйте частину посилання після / — це ваш ідентифікатор Facebook',
        button: 'Підключити акаунт',
    },

    listingIgu: {
        iguListing: 'IGU Лістинг',
        title: ' готуєтся до лістингу на ',
        textOne: 'Лістинг на біржі {{exchange}} відбудеться ',
        textTwo:
            '. Пристебніть ремені, Ігуани, - набираємо швидкість перед польотом!',
        button: 'Перейти на біржу',
        listed: {
            title: ' торгується на ',
            text: 'Нарешті відбувся довгоочікуваний запуск IGU — це лише початок нашої космічної Одіссеї! Купити IGU на біржі {{exchange}} можна за посиланням нижче',
        },
    },
    bybitVote: {
        title1: 'Проголосуйте за IGU на ByBit і розділіть ',
        title2: '!',
        text: "IguVerse було обрано для участі в програмі ByVotes - проект, який набрав найбільшу кількість голосів, з'явиться на ByBit!",
        banner: {
            title1: 'Проголосуйте і розділіть ',
            title2: '',
        },
        button: 'Докладніше',
    },
    howToPurchaseIGU: {
        modalTitle: 'Як придбати IGU',
        exchangesModalTitle: 'Купити IGU на біржах',
        cardDeposit: {
            title: 'Поповнення',
            text: 'Ви можете внести токени, що підтримуються, з будь-якого BSC BEP-20 гаманця',
        },
        cardExchange: {
            title: 'Купити на біржах',
            text: 'Купуйте та торгуйте IGU на біржах, на яких токен вже є',
        },
        cardTrade: {
            title: 'Торгуйте в додатку',
            text: 'Швидко та зручно обмінюйте IGU прямо в додатку',
        },
    },
    howToClaimFreePet: {
        title: 'Купіть NFT для отримання нагород',
        text: 'Ви не можете отримати нагороди, оскільки у вашому обліковому записі немає NFT. Безкоштовний вихованець - це не NFT, оскільки він не перебуває на блокчейні. Купівля NFT-вихованця або підвищення рангу вже існуючого дасть вам доступ до нагород',
        alert: 'Ми зберігаємо інформацію про всі ваші нагороди, і ви зможете отримати їх після купівлі NFT',
        button: 'Мінт нової NFT',
    },
    howToClaimOnButton: {
        titleOne: 'Отримайте ',
        titleTwo: ' від ваших винагород',
        text: 'Ви можете перевести {{percent}}% доступних винагород VIGUP на свій основний гаманець. Після запиту токен можна обміняти, відправити на інший гаманець або вивести',
        alert: 'Решта токенів VIGUP перебувають на розгляді і зберігатимуться в заблокованому гаманці',
        button: 'Отримайте вашi винагороди',
    },
    onBoarding: {
        mainWallet: {
            title: 'Головний гаманець',
            stepOne: {
                title: 'Уся ваша криптовалюта тут',
                text: 'У цьому гаманці зберігаються всі підтримувані токени, доступні у вашому обліковому записі. Непідтримувані токени не відображаються. Усі ваші нагороди будуть тут після клейма',
            },
            stepTwo: {
                title: 'Навігація між гаманцями',
                text: 'На вкладці "Головний гаманець" ви можете відкрити всі інші гаманці, доступні у вашому обліковому записі, провівши пальцем по екрану. До решти гаманців належать гаманець NFT, гаманець винагороди та ігровий гаманець',
            },
        },
        login: {
            stepOne: {
                title: 'Новий спосіб заробити криптовалюту',
                text: 'Перетворіть свою щоденну рутину в соцмережах на спосіб заробітку! Діліться контентом, гуляйте та грайте в аркадну гру, отримуючи нагороди',
            },
            stepTwo: {
                title: 'Віртуальний вихованець - компаньйон',
                text: 'Створіть NFT-улюбленця за допомогою ШІ, який допоможе вам заробляти в соцмережах. Ви також можете завантажити фотографію свого вихованця для створення NFT',
            },
            stepThree: {
                title: 'Змагальні ігри',
                text: 'Хочете заробляти набагато більше? Кидайте виклик іншим гравцям у наших PvP-режимах і вигравайте по-крупному',
            },
            stepFour: {
                title: 'Пожертвування для тварин',
                text: '1% ваших щоденних нагород йде на захист тварин. Ви можете збільшити розмір пожертвування в застосунку',
            },
            stepFive: {
                title: 'Майбутні продукти',
                text: 'Додаток є лише першим продуктом у серії. Станьте одним із перших користувачів нашого торгового майданчика на базі штучного інтелекту та децентралізованої рекламної мережі після їхнього виходу',
            },
        },
    },
    HomeScreen: {
        MemsModal: {
            title1: 'Ейрдроп на суму ',
            title2: ' у Дискорді MemeFi!',
            text: 'Команда MemeFi нещодавно запустила кампанію з роздачі NFT у Дискорді. За виконання простого завдання ви отримаєте квитки на NFT із вшитим ейрдропом $MEMF',

            button1: 'Відкрити Дискорд',
            button2: 'До сайту',
            banner: {
                title: '$450.000 Ейрдроп',
                text: 'Команда MemeFi нещодавно запустила кампанію з роздачі NFT у Дискорді',
            },
        },
        exploreGames: 'Дослідити ігри',
        minimalBet: {
            title: 'Мінімальна ставка = {{amount}}',
            text: 'Найменша сума, на яку ви можете зіграти',
        },
        WelcomeHeader: {
            title: 'Ласкаво просимо!',
            text: 'Грайте та заробляйте криптовалюту щодня',
        },
        ModalGameComingSoon: {
            title: 'Гра скоро вийде',
            text: 'Наша команда старанно працює над новою PvP-грою, і вона скоро буде випущена. Спробуйте інші захоплюючі ігри в нашій бібліотеці!',
        },
        GamesBlock: {
            header: 'Конкурентні ігри',
            button: 'Пограти в гру',
            buttonContinue: 'Продовжити грати',
            buttonComingSoon: 'Скоро буде...',
            orders: '{{orders}} Кімнат',
            games: {
                [MYSTERY_GAMES.mysteryLikes]: {
                    title: 'Загадкові лайки',
                    text: 'Вгадайте кількість лайків у NFT',
                },

                [MYSTERY_GAMES.nftRoyal]: {
                    title: 'Фруктові перегони',
                    text: 'Спрямуйтеся до перемоги на фруктово-ягідному шляху',
                },
                [MYSTERY_GAMES.nftEvolution]: {
                    title: 'NFT - еволюція',
                    text: 'Схрещуйте NFT і отримуйте їхні потужніші версії',
                },
                [MYSTERY_GAMES.luckyStrike]: {
                    title: 'Лакі Страйк',
                    text: 'Купуйте квитки, щоб ухопити удачу і забрати все в грі, в якій править фортуна',
                },
                [MYSTERY_GAMES.quantumSpin]: {
                    title: 'Квантовий диск',
                    text: 'Крути квантове колесо, щоб спіймати удачу',
                },
                [MYSTERY_GAMES.tokenteller]: {
                    title: 'Iгуманія',
                    text: 'Беріть свою магічну кулю і вгадуйте майбутню ціну IGU',
                },
                socialProof:
                    '{{amount}} виграли просто зараз у PvP-грі {{game}}',
            },
        },
        GamesFeatures: {
            orders: 'Вільні ігрові кімнати',
            prizePool: 'Загальний призовий фонд',
            turnover: 'Оборот у {{coin}}',
            totalSlots: 'Всього раундів',
        },
        VacantRoomsEmpty: {
            title: 'Немає вільних ігор',
            text: 'На даний момент ігрових запитів немає. Ви хочете створити його? Будь-який гравець зможе кинути вам виклик',
        },
        EmptyGameHistory: {
            title: 'Ігор немає',
            text: 'Ви жодного разу не брали участі в іграх і не створювали їх. Створіть гру зараз і киньте виклик випадковому гравцеві',
        },
        GamesNavigationBar: {
            ORDERS: 'Вільні кімнати',
            HISTORY: 'Історія',
            ROUNDS: 'Раунди',
            WHEEL: 'Диск',
        },
        ActiveOrdersFilters: {
            title: 'Вільні кімнати',
            modalTitle: 'Сортувати по',
            Newest: 'Перші',
            Oldest: 'Останні',
            Highest: 'Найбільша нагорода',
            Lowest: 'Найменша нагорода',
        },
        ConfirmPlayModal: {
            title: 'Грати на ',
            title2: 'Повернути за ',
            text: 'Приєднуючись до гри, ви підтверджуєте, що вказаний депозит буде переведено на гаманець очікування',
        },
        GamesCreateWelcome: {
            screenTitle: 'Створити "{{game}}" гру',
            title: 'Киньте виклик іншим',
            text: 'Створіть гру з переважною ставкою і завершіть її, щоб інші гравці могли прийняти ваш виклик',
        },
        MaxMinimalBetFeature: {
            title: 'Мінімальна ставка = {{min}}, Максимальна ставка = {{max}}',
            text: 'Найменша і найбільша суми, які можна поставити',
        },
        GameTermination: {
            title: 'Автоматичне завершення = {{days}} днів',
            text: 'Час, після якого гра закінчується, якщо жоден інший гравець не кине вам виклик',
            alert: 'Якщо ніхто не кинув вам виклик протягом семи днів, гру буде автоматично видалено, а депозит повернуто на ваш баланс',
        },
        EnterCoinsAmountScreen: {
            screenTitle: 'Введіть кількість монет',
            error: {
                max: 'Недостатній баланс, поповнити, щоб продовжити',
                maxStake:
                    'Максимальна ставка {{amount}}, будь ласка, зменшіть ставку',
                minStake:
                    'Мінімальна ставка {{amount}}, будь ласка, збільште ставку',
                digits: 'Повинні бути тільки цифри',
            },
            confirmTransaction: {
                valueType: 'Створення гри "{{game}}"',
            },
        },
        PreviousGameModal: {
            title: 'Завершити попередню гру?',
            text: 'Завершіть гру, до якої ви вже приєдналися, щоб інші користувачі могли кинути вам виклик. Гра автоматично зникне через {{days}} днів',
            button1: 'Завершити попередню гру',
        },
        GameHistoryScreen: {
            title: 'Історія',
            text: 'Тут наведено історію закінчених ігор. Ви можете переглянути їх за місяцями',
            status: {
                [MYSTERY_LIKES_STATUS.WaitingForMyself]:
                    'Очікування вашого ходу',
                [MYSTERY_LIKES_STATUS.WaitingForOpponent]:
                    'Очікування опонента',
                [MYSTERY_LIKES_STATUS.Refund]: 'Термін дії гри закінчився',
            },
        },
        MysteryGamesBanner: {
            oneGame: {
                title: 'Продовжити грати!',
                text: 'Закінчіть гру "{{game}}"',
            },
            more: {
                title: 'Продовжити грати!',
                text: 'У вас 2 незакінчені гри',
            },
        },
        MysteryGamesContinueModal: {
            title: 'Продовжити грати',
            text: '2 гри не закінчено. Дійдіть до кінця і дізнайтеся результати',
        },
        MysteryLikes: {
            MysteryLikesHowItWorks: {
                stepOne: {
                    title: 'Вгадайте кількість лайків',
                    text: 'Кожен ігровий раунд складається з {{gamesAmount}} ігор проти іншого гравця. Вгадуйте частіше, ніж ваш супротивник, щоб виграти',
                },
                stepTwo: {
                    title: 'Приєднуйтесь і створюйте ігри',
                    text: 'Користувачі можуть приєднуватися до ігор і створювати їх. Під час створення гри необхідно вибрати суму для ставки в токенах VIGU. Приєднуючись до гри, ви погоджуєтеся грати на кількість токенів, зазначену творцем гри',
                },
                stepThree: {
                    title: 'Неможливість чітингу',
                    text: "Користувачі в принципі не можуть отримати доступ до кількості лайків у NFT. Якщо ви часто програєте, то вам просто не пощастило. Пограйте ще трохи, і ситуація обов'язково зміниться",
                },
            },
            MysteryLikesCreateGameSuccess: {
                title: 'Гру було створено',
                text: 'Ви успішно створили гру! Будь ласка, завершіть раунд, щоб ми могли порівняти ваші відповіді з відповідями вашого майбутнього опонента',
                button: 'Почати гру',
            },
            MysteryLikesSelectRange: {
                title: 'Виберіть діапазон',
                text: 'Виберіть відповідний діапазон, до якого входить значення з правильною кількістю лайків',
                button: 'Перейдіть до наступного зображення',
                toastError: 'Уже проголосували',
                buttonFinish: 'Закінчити гру',
                tooltip1:
                    'NFT вашого опонента. Вам потрібно вгадати, скільки у неї лайків. Лайки невидимі ні вам, ні вашому опоненту',
                tooltip2:
                    'Щоб вибрати кількість лайків, натисніть на одну з карток і перейдіть до наступної картинки за допомогою кнопки нижче',
            },
            MysteryLikesSelectRangeFinish: {
                [MYSTERY_LIKES_STATUS.WaitingForOpponent]: {
                    title: 'В очікуванні противника',
                    text: 'Ви завершили гру. Тепер ваш противник повинен кинути вам виклик і приєднатися до гри. Якщо противник не завершить її протягом семи днів, гру буде автоматично припинено, а ваш депозит повернуто',
                },
                [MYSTERY_LIKES_STATUS.Won]: {
                    title: 'Ви виграли!',
                    textOne: 'Вітаю! Вам вдалося перевершити свого суперника. ',
                    textTwo: ' будуть негайно переведені на ваш гаманець',
                },
                [MYSTERY_LIKES_STATUS.Draw]: {
                    title: 'Нічия!',
                    text: 'Як не дивно, ви обидва набрали рівну кількість очок. Ваша ставка повернута на ваш гаманець. Хочете зіграти ще один раунд?',
                },
                [MYSTERY_LIKES_STATUS.Lost]: {
                    title: 'Ви програли :(',
                    text: "На жаль, у цьому раунді вашому супернику вдалося переграти вас. Вашу ставку було переведено на його гаманець. Пам'ятайте, ви завжди можете перемогти в наступній грі!",
                },

                statistics: 'Ваша статистика',
                alert: 'Якщо ніхто не кинув вам виклик протягом семи днів, гру буде автоматично видалено, а депозит повернуто на ваш баланс',
                likes: 'лайкiв',
            },
            MysteryLikesConfirmPlay: {
                warning:
                    'Користувачі в принципі не можуть отримати доступ до кількості лайків у NFT',
            },
            MysteryLikesLoadingScreen: {
                prepare: {
                    title: 'Підготовка NFT',
                    text: 'Ми тасуємо NFT, щоб ви отримали випадковий розклад. Нагадуємо, що лайки невидимі для гравців! Будь ласка, зачекайте трохи і не виходьте з гри та застосунку',
                },
                complete: {
                    title: 'Аналіз результатів',
                    text: 'Обробка ваших відповідей і відповідей вашого опонента для оголошення результатів. Будь ласка, почекайте трохи і не виходьте з гри та програми',
                },
            },
        },

        NftEvolution: {
            breedCost: {
                title: 'Вартість схрещування{{amount}}',
                text: 'Вартість NFT наступного рангу після селекції зі знижкою 40%',
                alert: 'Отримання наступного рангу не гарантується',
            },
            WelcomeNftEvolution: {
                BestRankToBreed: {
                    title: 'Найкращі комбо рангів',
                    text: 'Список найкращих комбінацій рангів для схрещування',
                },
                stepOne: {
                    title: 'Схрестити NFT',
                    text: 'Виберіть і схрестіть дві NFT і отримайте NFT випадкового рангу з певною ймовірністю. Ваші старі NFT не зникнуть!',
                },
                stepTwo: {
                    title: 'ДНК-клонування',
                    text: "Наші високотехнологічні лабораторії тепер можуть брати ДНК мертвих тварин і клонувати їх! Отже, візьміть пару мертвих NFT і створіть нову. На жаль, після клонування здоров'я відновлено не буде",
                },
                stepThree: {
                    title: 'Імовірність рангів',
                    text: "Дізнайтеся, які шанси отримати кожен ранг при розведенні. NFT не обов'язково повинні бути одного рангу. Однак у вас є можливість виграти NFT будь-якого рангу, в тому числі й вищого",
                },
                stepFour: {
                    title: 'Вартість схрещування',
                    text: 'Вартість NFT наступного рангу після селекції зі знижкою 40%. Ви отримаєте унікальний NFT, згенерований ШІ. Генерація за фотографією недоступна',
                },
            },
            NftEvolutionSelectPets: {
                text: 'Список найкращих комбінацій рангів для схрещування',
                button: 'Розрахувати шанси',
                emptyCard: {
                    first: 'Виберіть першу NFT для схрещування',
                    second: 'Виберіть другу NFT для схрещування',
                },
                loading: 'Аналіз...',
            },
            NftEvolutionSelectPet: {
                title: 'Виберіть NFT',
            },
            NftEvolutionCheckout: {
                title: 'Шанси на схрещування',
                text: 'Дізнайтеся більше, що ви отримаєте в результаті схрещування',
                button: 'Схрестити за {{amount}}',
                loading: {
                    title: 'NFT схрещуються',
                    text: "Будь ласка, зачекайте, поки схрещуються NFT. Не закривайте додаток і вкладку. Процес схрещування зазвичай займає до п'яти хвилин",
                },
            },
            ConfirmBreedModal: {
                title: 'Схрестити за ',
                text: 'Приєднуючись до гри, ви погоджуєтеся схрестити дві NFT для отримання нової NFT випадкового рангу',
            },
            NftEvolutionSuccess: {
                title: 'Створено NFT рангу {{rank}}!',
                text: 'Вітаємо! Ви успішно схрестили свої NFT і отримали NFT рангу {{rank}}',
            },
            NftEvolutionMintPet: {
                title: 'Вибір NFT',
                text: "Ми автоматично згенерували для вас чотири зображення NFT. Виберіть найкраще і введіть ім'я для вашого нового NFT-вихованця",
            },
            noPetModal: {
                title: 'Не вистачає NFT для гри',
                text: 'Для того, щоб узяти участь у грі, необхідно щонайменше два улюбленці. Створіть нового і починайте грати просто зараз',
            },
        },

        NftRoyal: {
            lockPeriodWarning:
                'Щоб запобігти нечесній грі, ми використовуємо розумну анти-чіт систему',

            NftRoyalHowItWorks: {
                stepOne: {
                    title: 'Перевершіть супротивників в аркадній грі',
                    text: 'Переформатована гра з щоденних завдань, де ви зіткнетеся з сильними супротивниками. У цій версії присутні кілька ігрових режимів. У кожній грі є тільки один противник',
                },
                stepTwo: {
                    title: 'Приєднуйтесь і створюйте ігри',
                    text: 'Користувачі можуть приєднуватися до ігор і створювати їх. Під час створення гри необхідно вибрати суму для ставки в токенах VIGU. Приєднуючись до гри, ви погоджуєтеся грати на кількість токенів, зазначену творцем гри',
                },
                stepThree: {
                    title: 'Чітинг неможливий',
                    text: 'Щоб запобігти нечесній грі, ми використовуємо розумну анти-чіт систему, яка гарантує, що тільки вміння і удача визначають переможця',
                },
            },
            NftRoyalGameSettings: {
                gameMode: {
                    [NFT_ROYAL_GAME_MODE.Score]: {
                        title: 'Очки',
                        text: 'Змагання за більшу кількість очок',
                    },
                    [NFT_ROYAL_GAME_MODE.Fruit]: {
                        title: 'Фрукти',
                        text: 'Змагання за більшу кількість фруктів',
                    },
                },
                difficultyType: {
                    [GAME_DIFFICULTY.Easy]: {
                        title: 'Легка',
                        text: 'Низька швидкість персонажа та появи кактусів',
                    },
                    [GAME_DIFFICULTY.Medium]: {
                        title: 'Середня',
                        text: 'Середня швидкість персонажа та появи кактусів',
                    },
                    [GAME_DIFFICULTY.Hard]: {
                        title: 'Висока',
                        text: 'Висока швидкість персонажа та появи кактусів',
                    },
                },
                lives: 'Максимальна кількість життів у грі',
            },
            NftRoyalGameSettingsModal: {
                title: 'Налаштування гри',
                text: 'Гра може бути кастомізована для більш комфортного та цікавого ігрового процесу',
                feature: {
                    mode: {
                        description:
                            'У першому режимі ви змагаєтеся за очки, а в другому - за кількість зібраних фруктів',
                    },
                    difficulty: {
                        description:
                            'Три рівні складності (легкий, середній і складний) контролюють швидкість гри та кількість кактусів',
                    },
                    livesCount: {
                        description:
                            'Кількість життів у грі. Гра закінчується втратою останнього життя одним із гравців',
                    },
                },
            },

            NftRoyalCreateGameSuccess: {
                title: 'Ви успішно створили гру!',
                text: 'Будь ласка, завершіть гру, щоб ми могли порівняти ваші результати з результатами вашого майбутнього суперника',
            },

            NftRoyalGameHistory: {
                [NFT_ROYAL_GAME_HISTORY_STATUS.WaitingForOpponent]: {
                    title: 'В очікуванні противника',
                    text: 'Ви завершили гру. Тепер ваш противник повинен кинути вам виклик і приєднатися до гри. Якщо противник не завершить її протягом семи днів, гру буде автоматично припинено, а ваш депозит повернуто',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Won]: {
                    title: 'Ви виграли!',
                    textOne: 'Вітаю! Вам вдалося перевершити свого суперника. ',
                    textTwo:
                        ' буде переведений на ваш ігровий гаманець негайно',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Draw]: {
                    title: 'Нічия!',
                    text: 'Як не дивно, ви обидва набрали рівну кількість очок. Ваша ставка повернута на ваш гаманець. Хочете зіграти ще один раунд?',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Lost]: {
                    title: 'Ви програли :(',
                    text: "На жаль, у цьому раунді вашому супернику вдалося переграти вас. Вашу ставку було переведено на його гаманець. Пам'ятайте, ви завжди можете перемогти в наступній грі!",
                },
                GameStatistics: {
                    title: 'Статистика ігри',
                    score: 'Ваш рахунок',
                    lives: 'Життя',
                    fruitCollected: 'Зібрані фрукти',
                },
            },
            NftRoyalLoadingScreen: {
                prepare: {
                    title: 'Підготовка гри',
                    text: 'Будь ласка, зачекайте трохи, доки завантажується та налаштовується гра. Це не займе багато часу!',
                },
                complete: {
                    title: 'Аналіз результатів',
                    text: 'Обробляємо ваш результат і результат вашого суперника, щоб обрати переможця. Будь ласка, зачекайте трохи і не залишайте гру або додаток',
                },
            },
            emptyScreen: {
                title: 'Упс!',
                text: 'Щось не так. Але не хвилюйся, ми це швидко виправимо',
            },
        },

        [MYSTERY_GAMES.luckyStrike]: {
            keys: {
                participants: 'Учасники',
                winners: 'Переможці',
            },

            purchaseTicket: 'Придбати квитки',
            ticketsGrabbed: 'Білетів придбано',
            soldOut: 'Усі квитки продано',
            LuckyStrikeTimerBlock: {
                title: 'Раунд закінчується через',
                text: 'Час до кінця раунду',
            },
            HashSecuritySystem: {
                title: 'Безпечна система білетів',
                text: 'Кожен білет має унікальний код, який прихований від інших гравців. Код визначає переможця!',
            },
            LuckyStrikePricePool: {
                title: 'Приз = {{text}}',
                text: 'Загальний пул, отриманий від премій за квитки. Один переможець забирає все. Винагорода виплачується на ігровий гаманець',
            },
            LuckyStrikeParticipants: {
                title: 'Учасники = {{text}}',
                text: 'Гравці, які беруть участь, і ліміт гравців. При досягненні ліміту квитки стають недоступними для придбання',
            },
            LuckyStrikeHowItWorks: {
                stepOne: {
                    title: 'Представляємо Лакі Страйк',
                    text: 'Візьміть участь у раунді та виграйте солідний приз! Кожен додатковий квиток у будь-якому з раундів збільшує ваші шанси на перемогу',
                },
                stepTwo: {
                    title: 'Збільште свої шанси',
                    text: 'У кожного гравця є шанс виграти весь пул, зібраний із коштів, на які було придбано квитки. Що більше квитків ви зберете, то вищий шанс отримати нагороду',
                },
                stepThree: {
                    title: 'Читинг неможливий',
                    text: "Оскільки код білета недоступний іншим користувачам, шахрайство неможливе. Якщо вам здається, що вам не пощастило, так воно і є. Пограйте ще трохи, і ситуація обов'язково зміниться",
                },
            },
            LuckyStrikeMain: {
                title: 'Раунди',
                text: 'Раунди відрізняються за тривалістю, кількістю гравців і шансом на перемогу',
                emptyList: {
                    title: 'Немає переможців',
                    text: "Пока що немає користувачів, вигравших раунд. Скоро з'являться.",
                },
            },
            LuckyStrikeWinners: {
                title: 'Переможці',
                text: 'Погляньте на переможців гри!',
            },
            LuckyStrikePurchaseModal: {
                title: 'Придбати білет на "{{type}}"',
                text: 'Кошти збираються з ігрового пулу. Переможець забирає весь пул і визначається за хешем квитка. Чим більше квитків ви зберете, тим вищий шанс отримати нагороду',
                alert: 'Для запобігання чітингу та поліпшення ігрового процесу не можна придбати більше {{maxTickets}} квитків',
            },
            LuckyStrikeWaitingForResult: {
                title: 'Очікування результатів!',
                text: 'Дочекайтеся закінчення раунду, щоб дізнатися результат гри. Ви можете придбати більше квитків, щоб збільшити свої шанси на виграш',
            },
            LuckyStrikeUserTickets: {
                text: 'Кожен білет має унікальний код, який прихований від інших гравців і допомагає нам гарантувати чесність гри',
                alert: 'Ви вже придбали {{text}} білетів на гру',
            },

            LuckyStrikeHistoryItem: {
                [LUCKY_STRIKE_GAMES_STATUS.Won]: '{{round}} виграний',
                [LUCKY_STRIKE_GAMES_STATUS.Lost]: '{{round}} програний',
                [LUCKY_STRIKE_GAMES_STATUS.WaitingForResults]:
                    'Очікування результатів',
            },
            LuckyStrikeHistoryBlockHeader: {
                [LUCKY_STRIKE_GAMES_STATUS.Won]: {
                    title: 'Ви виграли!',
                    textOne:
                        'Вітаємо! Ваш квиток виявився щасливим, і ви виграли весь призовий фонд. ',
                    textTwo: ' будуть миттєво зараховані на ваш гаманець',
                },

                [LUCKY_STRIKE_GAMES_STATUS.Lost]: {
                    title: 'Ви програли :(',
                    text: 'На жаль, цього разу вам не вдалося виграти раунд. Щасти у наступному!',
                },
            },
            LuckyStrikeGameHistoryInfo: {
                gameType: 'Тип гри',
                correctTicket: 'Виграшний білет',
                yourTicket: 'Ваш білет',
                yourTickets: 'Ваші білети',
            },
            toasts: {
                soldOut: {
                    text1: 'Помилка!',
                    text2: 'Всі білети продані!',
                },
                gameExpired: {
                    text1: 'Помилка!',
                    text2: 'Раунд закінчився!',
                },
                gamePending: {
                    text1: 'Ой!',
                    text2: 'Щось пішло не так',
                },
            },
        },

        [MYSTERY_GAMES.quantumSpin]: {
            keys: {
                spin: 'Повернути',
                spinning: 'Обертається',
            },
            QuantumSpinProvablyFair: {
                card: {
                    title: 'Чесна рандомізація',
                    text: 'Усі результати розраховуються за допомогою криптографічної функції, яка дає змогу кожному перевірити чесність гри',
                },

                title: 'Чесна рандомізація',
                text: "Результати об'єднані в криптографічний ланцюг, що унеможливлює обман системи. Оскільки ми опублікували перший хеш у Твіттері, ви можете самі переконатися у справедливості результатів",
                algorithm: {
                    title: 'Алгоритм',
                    text: "Результати наступних {{rounds}} раундів наперед згенеровані. Перед кожним раундом ми розкриваємо хеш результату, що унеможливлює його зміну постфактум.\n\nВсі результати пов'язані в криптографічний 'ланцюг', що унеможливлює їх зміну. Перед генерацією ланцюжка результатів ми опублікували перший хеш у Твіттері, змішавши його з заздалегідь невідомим нам хешом блоку Біткоіна. Таким чином, результати можна перевірити, і вони справді довільні.\n\nЛанцюжок хешів був створений до першого раунду гри. Кожен хеш являє собою 256-бітове значення. Ланцюжок починається з випадково вибраного 256-бітного значення, і кожне наступне значення розраховується за допомогою хеша BLAKE2b попереднього значення.\n\nКриптографічна хеш-функція гарантує, що можна легко обчислити будь-яке значення в ланцюжку, використовуючи попереднє значення, але неможливо обчислити значення у зворотному напрямку. Останнє значення в заздалегідь розрахованому хеш-ланцюжку, початковий хеш, ми публічно опублікували та використали у першому раунді гри. У кожному наступному раунді використовується попереднє значення хешу. Проходячи ланцюжок таким чином, можна переконатися, що результати всіх минулих ігрових раундів відповідають заздалегідь розрахованим ланцюжком, але результат майбутніх раундів залишається для користувачів непередбачуваним.\n\nЩоб виключити ймовірність того, що ми навмисно створили ланцюжок з використанням конкретного початкового значення, яке спотворювало б результати гри на нашу користь, кожне значення в ланцюжку додається до глобального початкового значення, а отримане значення знову хешується з використанням BLAKE2b для обчислення остаточного значення. Так визначається результат кожного ігрового раунду. Це глобальне початкове значення відповідає хешу блоку Біткоіна, який ми публічно обрали перед його майнінгом. Глобальне початкове значення гарантує, що результат ігор був нам невідомий, коли було опубліковано значення хеша першої гри",
                },
                verification: {
                    title: 'Приклад перевірки',
                    text: 'Будь-хто може переконатися, що результати всіх попередніх ігрових раундів були згенеровані з використанням алгоритму рандомізації, що перевіряється, за допомогою наступного коду Python',
                },
            },
            QuantumSpinHowItWorks: {
                stepOne: {
                    title: 'Крути квантове колесо',
                    text: 'Колесо перебуває в суперпозиції, тож заздалегідь невідомо, який результат воно покаже. Крути колесо, щоб вивести його із суперпозиції та виграти найбільший приз!',
                },
                stepTwo: {
                    title: 'Кожен квантовий поворот вимагає енергії, тобто токенів',
                    text: 'Ваш приз може бути нижчим або вищим за вашу ставку. Звісно, ви можете отримати величезну нагороду!',
                },
                stepThree: {
                    title: 'Читинг неможливий',
                    text: 'Результати повороту визначаються в момент гри випадковим чином і невідомі команді. Ми цінуємо чесність і прозорість',
                },
            },
            QuantumSuccess: {
                coin: 'Вітаємо! Ви виграли {{coin}}, які будуть негайно переведені на ваш гаманець. Випробуйте удачу ще раз і поділіться своїми результатами в соцмережах',
                rank: 'Вітаємо! Ви виграли NFT рангу {{rank}}, і вона буде негайно переведена на ваш гаманець. Випробуйте удачу ще раз і поділіться своїми результатами в соцмережах',
            },
            QuantumSpinGameHistory: {
                again: 'Повернути знову',
            },
            QuantumSpinDetailsModal: {
                button: 'Назад до диску',
            },
            QuantumSpinHistory: {
                title: 'Тут порожньо',
                text: 'Ви поки що не зіграли жодної гри',
            },
        },
        [MYSTERY_GAMES.tokenteller]: {
            predictPrice: 'Передбачити ціну',
            addMoreTokens: 'Додати токени',
            priceDirection: 'Напрям ціни',

            [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Up]: 'ВГОРУ',
            [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Down]: 'ВНИЗ',
            TokenTellerConfirmationModal: {
                [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Up]: 'Бичачий множник',
                [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Down]:
                    'Ведмежий множник',
            },

            TokenTellerHowItWorks: {
                stepOne: {
                    title: 'Ігуманія',
                    text: 'Перевірте свої навички передбачення в динамічній грі. Вгадуйте рух ціни IGU в {{min}}-хвилинних раундах. Ви можете використовувати будь-які необхідні засоби: кришталеві кулі, тварин-провидців і навіть чорну магію',
                },
                stepTwo: {
                    title: 'Розмір нагороди',
                    text: 'У грі ви обираєте, йтиме токен донизу чи догори. Розмір вашої винагороди залежить від множника, який являє собою відношення бичачого пулу до ведмежого пулу. Множник відображається на вкладці приєднання до раунду і може змінюватися до початку раунду',
                },
                stepThree: {
                    title: 'Читинг неможливий',
                    text: 'Ми використовуємо надійний оракул, який забезпечує відповідність поточної ціни {{coin}} в додатку і ціни на біржах. Ви завжди можете перевірити ціну',
                },
            },
            TokenTellerMainScreen: {
                title: 'Раунди',
                text: 'Ви можете приєднатися тільки до майбутнього раунду',
            },
            TokenTellerPurchaseModal: {
                title: 'Вгадайте рух ціни',
                text: 'Приєднуйтесь до раунду, щоб передбачити, куди піде {{coin}}. Виберіть ставку і напрямок нижче',
                alert: 'Ви вже вибрали, що токен піде {{direction}}. Тепер ви можете тільки збільшити свою позицію в цьому напрямку',
            },

            TokenTellerPricePool: {
                title: 'Пул = {{text}}',
                text: 'Пул збирається зі ставок користувачів. Винагорода залежить від співвідношення між бичачими і ведмежими ставками',
            },
            TokenTellerUpPayout: {
                title: 'Бичачий множник = {{coefficient}}X',
                text: 'Множник нагороди переможця при зростанні ціни',
            },
            TokenTellerDownPayout: {
                title: 'Ведмежий множник = {{coefficient}}X',
                text: 'Множник нагороди переможця при падінні ціни',
            },
            TokenTellerParticipants: {
                title: 'Учасники = {{text}}',
                text: 'Кількість гравців, які беруть участь у раунді',
            },

            TokenTellerTimerBlock: {
                [TOKEN_TELLER_GAME_STATUS.Pending]: {
                    title: 'Раунд починається через',
                },
                [TOKEN_TELLER_GAME_STATUS.Closed]: {
                    title: 'Раунд закінчується через',
                },
            },
            TokenTellerHistoryItem: {
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Won]: 'Перемога',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Lost]: 'Програш',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.WaitingForResults]:
                    'В очікуванні результату',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Refund]: 'Нічия',
            },

            TokenTellerHistoryBlockHeader: {
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Won]: {
                    title: 'Ви виграли!',
                    textOne: 'Вітаю! Ви правильно передбачили рух ціни. ',
                    textTwo: ' буде негайно зараховано на ваш гаманець',
                },

                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Lost]: {
                    title: 'Ви програли :(',
                    text: 'На жаль, цього разу вам не вдалося перемогти. Хороший привід проявити себе в наступному раунді!',
                },
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Refund]: {
                    title: 'Нічия???',
                    text: 'Як не дивно, результат – нічия. Вашу ставку повернуто до гаманця',
                },
            },

            TokenTellerGameHistoryInfoItem: {
                iguBefore: 'Початкова ціна',
                iguAfter: 'Ціна закриття',
                prediction: 'Позиція',
                totalPool: 'Загальний пул',
                participants: 'Учасники',
                upPayout: 'Бичачий множник',
                downPayout: 'Ведмежий множник',
            },
        },
        DailyTasks: {
            header: 'Щоденні завдання',
            collected: '{{collectedEnergy}} / {{maxEnergy}} Зібрано',
            SocialTask: {
                title: 'Соціальне завдання',
                text: 'Робіть пости в соціальних мережах',
            },
            VerificationTask: {
                title: 'Пошукове завдання',
                text: 'Перевіряйте повідомлення інших користувачів',
            },
            MoveTask: {
                title: 'Рухоме завдання',
                text: 'Насолоджуйтеся прогулянками на вулиці зі своїм улюбленцем',
            },
            PlayTask: {
                title: 'Ігрове завдання',
                text: 'Зіграйте в захопливу аркадну гру',
            },
        },
        ReferralCard: {
            title: '{{percent}}% знижка на NFT!',
            text: 'Запрошуйте нових користувачів у застосунок IguVerse та отримуйте знижку на мінт NFT',
            button: 'Запросити',
        },
        TimerTopUp: {
            title: 'за кожне поповнення',
            text1: 'Внесіть токени зараз і отримайте на свій гаманець {{percent}}% {{coin}}! Доступно тільки до:',
            text2: 'Почніть грати в наші нові Pvp-ігри та отримайте бонусні токени!',
        },
    },
    pvpBonus: {
        cardButton: 'PVP Бонус',
        title: 'PvP - бонуси',
        text: 'Власники NFT мають право на додаткові нагороди за участь у PvP. Почніть просто зараз і отримайте свої бонуси!',
        pvpBonusModal: {
            title: 'Як заробити більше в PvP',
            text: 'Доходи IguVerse від PvP будуть розподілятися між гравцями пропорційно обороту! Заведіть NFT, і ви автоматично отримаєте бонуси за гру',
            features: {
                games: {
                    title: 'Лічильник ігор = {{games}}',
                    text: 'Кількість ігор, у яких ви сьогодні брали участь. Може ще одну?',
                },
                bonus: {
                    title: 'PvP - бонуси = {{amount}}',
                    text: 'Це додаткові токени, які ви отримаєте за участь у PvP-іграх наприкінці дня. Боріться з іншими та заробляйте ще більше!',
                },
            },
        },
        pvpBonusModalFreePet: {
            title: 'Підвищіть ранг, щоб отримати більше токенів у PvP',
            text: 'Ваш улюбленець рангу Free має бути підвищений до вищого рангу, щоб ви могли мати право на бонуси від PvP',
        },
    },
    MarketPlace: {
        navigationBar: {
            ORDERS: 'Активні ордера',
            MY_PROFILE: 'Мій профіль',
        },
        MarketPlaceActiveOrdersScreen: {
            title: 'Маркетплейс',
            text: 'Місце для торгівлі NFT',
            empty: {
                title: 'Немає NFT на продаж',
                text: 'Поки що ордери на продаж відсутні. Створіть ордер першим!',
            },
            notFound: {
                title: 'Результатів не знайдено',
                text: 'Ми не знайшли таких ордерів. Введіть інше ключове слово для пошуку',
            },
        },
        MarketPlaceSearch: {
            modalTitle: 'Фільтри',
            placeHolder: 'Пошук за nft, колекцією, користувачем...',
            typeSection: {
                [MARKETPLACE_PET_TYPE.AISystem]: 'AI Система',
                [MARKETPLACE_PET_TYPE.FromPhoto]: 'З фотографії',
                [MARKETPLACE_PET_TYPE.Alive]: 'Живий',
                [MARKETPLACE_PET_TYPE.Dead]: 'Мертвий',
            },

            sortBySection: {
                [MARKETPLACE_ORDERS_SORT_OPTION.FromHighestPrice]:
                    'Від високих цін до низьких',
                [MARKETPLACE_ORDERS_SORT_OPTION.FromLowestPrice]:
                    'Від низьких цін до високих',
                [MARKETPLACE_ORDERS_SORT_OPTION.RecentlyListed]:
                    'Нещодавно розміщені',
                [MARKETPLACE_ORDERS_SORT_OPTION.EndingSoon]:
                    'Скоро закінчуються',
            },
        },
        MarketPlaceWelcomeCreateOrderScreen: {
            screenTitle: 'Створити новий ордер',
            title: 'Підготуйте NFT до великої подорожі',
            text: 'Тут ви можете розмістити свою NFT і продати її',
            features: {
                rank: {
                    title: 'Мінімальний ранг – {{rank}}',
                    text: 'Ваша NFT повинна мати ранг вище {{lowRank}}. Тільки NFT, придбані в додатку, можуть бути продані на Маркетплейсi',
                },
                termination: {
                    title: 'Автоматичне завершення = {{days}} Днів',
                    text: 'Час, протягом якого ордер закінчиться, якщо NFT не було куплено раніше',
                    alert: 'Якщо протягом {{days}} днів ніхто не придбав NFT, замовлення буде автоматично видалено з маркетплейсу. Під час лістингу ви можете продовжувати грати і заробляти',
                },
                commission: {
                    title: 'Комісія = {{commission}}%',
                    text: 'За кожну успішно продану NFT стягується комісія в {{commission}}%',
                },
            },
        },
        MarketPlaceModalNoPet: {
            title: 'Створіть хоча б одну NFT для продажу',
            text: 'Ви можете змінтити її просто зараз!',
        },
        MarketPlaceSelectNftScreen: {
            screenTitle: 'Виберіть NFT',
        },
        MarketPlaceSelectNftPriceScreen: {
            screenTitle: 'Введіть ціну NFT',
        },
        MarketPlaceCreateOrderSuccessScreen: {
            title: 'Створено ордер на продаж NFT',
            text: 'Ви успішно розмістили свою NFT на торговому майданчику. Тепер інші користувачі зможуть її придбати',
        },
        navigationBarOverview: {
            OVERVIEW: 'Огляд',
            OWNER_HISTORY: 'Історія',
        },
        MarketPlaceOverview: {
            text: 'Це NFT іншого користувача. Ви можете побачити його характеристики нижче:',
            textOwner:
                'Це ваш NFT. Ви можете побачити його характеристики нижче:',
            OverviewOwnerSection: {
                profileLabel: 'Профіль власника',
            },
            proceedToCheckoutModal: {
                title: 'Перейти до придбання?',
                text: 'Після купівлі NFT вона перебуватиме в пасивному режимі протягом 24 годин. Переконайтеся, що ви перевірили всі її властивості перед покупкою',
            },
        },
        DelistNftModal: {
            title: 'Видалити ордер?',
            text: 'У разі делістингу NFT більше не буде розміщена на продаж',
        },
        MarketplaceProfile: {
            joined: 'Приєднався {{date}}',
            myNFTs: 'Мої NFTs',
            exploreNFTs: 'Дослідити NFTs',
            emptyUser: {
                title: 'Немає ордерів',
                text: 'Ще не створено жодних ордерів на ринку',
            },
            empty: {
                title: 'Немає ордерів',
                text: 'Цей користувач ще не створив жодного замовлення',
            },
        },
        MarketPlaceDelistSuccessScreen: {
            title: 'NFT "{{name}}" успішно видалено з Маркетплейсу',
        },
        MarketPlaceBuySuccessScreen: {
            title: 'Нова NFT у колекції',
            text: 'Ви успішно придбали нову NFT! Тепер ваша колекція поповнилася новим вихованцем і стала набагато сильнішою',
        },
        MarketPlaceOverviewOwnerHistoryScreen: {
            empty: {
                title: 'Немає історії NFT',
                text: 'NFT ще не торгується. Ви можете купити його першим!',
            },
        },
        MarketPlaceNoTradeAvalibleScreen: {
            title: 'Вийшов маркетплейс!',
            description:
                'Ми тільки-но запустили наш внутрішній торговий майданчик, де ви можете торгувати своїми NFT. Відкрийте його через веб-додаток та створіть свій перший ордер прямо зараз!',
            button: 'Досліджуйте у веб-додатку',
        },
    },
    SpaceId: {
        card: {
            title: 'Встигніть отримати SPACE ID',
            text: 'Використовуйте оригінальний нікнейм у додатку та в усьому криптовсесвіті',
        },
        how: {
            screenTitle: 'Як використовувати SPACE ID',
            title: 'Створіть цифровий ID',
            text: "Втомилися від складних нечитабельних адрес? Замініть свою адресу на відповідне доменне ім'я за допомогою SPACE ID!",
            guideBlock: {
                first: 'Імпортуйте свій гаманець IguVerse у будь-який некастодіальний DeFi-гаманець (наприклад, Trustwallet, Metamask), використовуючи сід-фразу',
                second: 'Додайте мережу BEP-20 і підключіть гаманець до сайту',
                third: "Знайдіть потрібне доменне ім'я на сайті",
                fourth: "Купіть відповідне доменне ім'я та оновіть застосунок IguVerse. Ви зможете побачити свій користувацький нікнейм у гаманці, в таблиці лідерів і в будь-якому іншому місці, де він використовується",
                alert: 'Щоб купити домен, необхідно мати трохи BNB у гаманці',
            },
            button1: 'Ознайомитися з доменами',
        },
        modal: {
            title: 'Унікальний SPACE ID! ',
            text: 'Ви успішно придбали та зареєстрували власний домен! Відтепер ваше унікальне ім`я відображатиметься скрізь у додатку. Ваша справжня адреса залишиться тією самою. Щоб скопіювати її, натисніть кнопку "Копіювати" в гаманці',
            link: 'Дізнайтеся більше про SPACE ID',
        },
    },
    Achievements: {
        title: 'Досягнення',
        text: 'Захоплюючі завдання, які допомагають відстежувати ваш унікальний прогрес і дають змогу продемонструвати свої навички та ігровий досвід',
        unlocked: 'Досягнення {{achievement}} розблоковано!',
        unlockedText:
            'Вітаємо, вам вдалося розблокувати нове досягнення. Поділіться ним із друзями в соціальних мережах!',
        button: 'Поділитися Досягненням',
        modal: {
            title: 'Виділяйтеся досягненнями',
            text: 'Виконуйте завдання, щоб отримати досягнення. Набагато цікавіше грати, коли є виклик, а на додачу груди, повні нагород',
        },
    },
};

export default uk;
